import React, { useState, useRef } from 'react';
import {
	List, Datagrid, TextField, Edit, SaveButton,
	Toolbar, useInput, useListContext, Loading, ShowButton, Show, SimpleShowLayout,
	useRedirect, Create, SimpleForm, TextInput, fetchStart, fetchEnd, useRefresh, FunctionField, SimpleList, SelectInput, BooleanInput
} from 'react-admin';
import config from './config.json';
import featureData from './features.json';
import get from 'lodash/get'
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import {
	withStyles, FormControl, Button, IconButton, Avatar, Switch,
	Paper, Typography, Table, TableContainer, TableBody, TableCell, TableHead, TableRow, Divider, Portal, DialogContent, DialogContentText,
	DialogActions, TablePagination, TextField as MuiTextField, Box, Dialog, ListItemAvatar, Popover,
	List as MuiList, ListItem, ListItemText, CircularProgress, Select, Menu, MenuItem, InputLabel, AppBar,
	Tab, Tabs, Checkbox, Accordion, AccordionSummary, AccordionDetails, FormControlLabel, Radio, RadioGroup, TableSortLabel, useMediaQuery, Chip
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DateTimePicker, KeyboardTimePicker, KeyboardDatePicker } from "@material-ui/pickers";
import { stringify } from 'query-string';
import { makeStyles } from '@material-ui/core/styles';
import { customTheme } from './customTheme';
import CustomExportButton from "./components/CustomExportButton";
import ParkingSummaryCard from "./components/ParkingSummaryCard";
import { vehicleSvgs, parkingConfigurationProperties, sampleReceiptText, parkingReceiptProperties, paymentModeColors, hideVehicleNumber, discountPaymentModes } from "./sharedData";
import { Link, useHistory, useLocation } from 'react-router-dom';
// import { linkToRecord } from 'ra-core';
// import { Button as RaButton } from 'ra-ui-materialui';
import RefreshIcon from '@material-ui/icons/Refresh';
import Skeleton from '@material-ui/lab/Skeleton';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatUnderlinedIcon from '@material-ui/icons/FormatUnderlined';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import DeleteIcon from '@material-ui/icons/Delete';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import EditIcon from '@material-ui/icons/Edit';
import ImageDialog from "./components/ImageDialog";
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import queryString from 'query-string';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import DateTimePickerToolbar from "./components/DateTimePickerToolbar";
import ImageGalleryDialog from './components/ImageGalleryDialog';
// import CustomDateTimePickerV2 from './components/CustomDateTimePickerV2';
import CustomDateTimePicker from './components/CustomDateTimePickerV2';
import { MoneyOff as MoneyOffIcon, AttachMoney as AttachMoneyIcon } from "@material-ui/icons";
import CustomSearch from './components/CustomSearch';
import CustomFilter from './components/CustomFilter';
import CustomPagination from './components/CustomPagination';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import ScrollableTable from './components/ScrollableTable';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import MapOutlinedIcon from '@material-ui/icons/MapOutlined';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { translate, crudUpdate } from 'ra-core';
import QueueIcon from '@material-ui/icons/Queue';
import ParkingInfoSelector from './components/ParkingInfoSelector';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import SearchBar from "./components/SearchBar";
import notify from './components/CustomUseNotify';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import AssessmentIcon from '@material-ui/icons/Assessment';
import DehazeIcon from '@material-ui/icons/Dehaze';
import RaAutocompleteInput from './components/RaAutocompleteInput';
import BrokenImageOutlinedIcon from '@material-ui/icons/BrokenImageOutlined';
import CctvImage from '../src/images/cctv.svg';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CustomCreateButton from './components/CustomCreateButton';
import DownloadIcon from "@material-ui/icons/GetApp";
import DashboardTemplateSelector from './components/DashboardTemplateSelector';
import PhonelinkEraseIcon from '@material-ui/icons/PhonelinkErase';
import MobileFriendlyIcon from '@material-ui/icons/MobileFriendly';
import { useParams } from "react-router-dom";

const GRAPH_COLORS = {
	"Entered": "#9dca9d",
	"Exited": "#ca9d9d",
	"Amount": "#9d9dca",
}
const useStyles = makeStyles({
	timeFilterContainer: {
		alignItems: "center",
		marginTop: customTheme.spacing(5),
	},
	timeFilterInput: {
		marginLeft: "2%",
	},
	outlinedInput: {
		padding: 0,
	},
	timeFilterButton: {
		marginLeft: "1%",
		width: "10%",
		minWidth: 85
	},
	summaryListRoot: {
		marginTop: customTheme.spacing(2),
	},
	summaryCardContainer: {
		display: "grid",
		gridAutoFlow: "column",
		marginTop: customTheme.spacing(3),
	},
	flexContainer: {
		display: 'flex',
		alignItems: "center",
	},
	listActions: {
		justifyContent: "space-between",
		marginTop: customTheme.spacing(3),
	},
	mainTableCell: {
		color: `${customTheme.palette.grey[900]} !important`,
		fontWeight: 500,
	},
	listVehicleIcon: {
		width: 25,
		height: 25,
		marginRight: customTheme.spacing(1),
		verticalAlign: "middle",
	},
	chipCell: {
		textAlign: "center",
		padding: customTheme.spacing(1, 2),
		display: "inline-block",
		borderRadius: 50,
	},
	showLayoutMain: {
		marginTop: 0,
	},
	showTitle: {
		fontSize: 22,
	},
	searchParamsTitle: {
		fontSize: "1.05rem",
	},
	searchParams: {
		fontFamily: "Poppins-Regular",
		fontSize: "0.95rem",
	},
	parkingSelectorContainer: {
		display: "grid",
		justifyContent: "space-between",
	},
	asyncSelector: {
		display: "grid",
		gridAutoFlow: "column",
		justifyContent: "space-between",
		paddingRight: 5,
	},
	removeMargin: {
		margin: 0,
	},
	parkingListHead: {
		color: customTheme.palette.grey[500],
	},
	inlineForm: {
		display: "grid",
		gridAutoFlow: "column",
		padding: "18px 0%",
		// marginLeft: 15
	},
	removeUnderline: {
		borderBottom: "none",
	},
	checkIconButton: {
		borderRadius: 4,
		padding: "5px 5px 2px",
		'&:hover': {
			backgroundColor: "#0001 !important",
			cursor: "pointer",
		},
	},
	smallSelectRoot: {
		padding: "10px 32px 10px 18px",
	},
	receiptTextContainer: {
		display: "flex",
		padding: "15px 20px",
		'&:hover': {
			backgroundColor: "#00336608",
		},
		alignItems: "center",
		marginBottom: 15,
		border: "1px solid #bfbfbf",
		borderRadius: 4,
	},
	selectWithIcon: {
		display: "flex",
		justifyContent: "space-between",
		paddingLeft: 20,
		paddingRight: "40px !important",
		columnGap: 30,
	},
	editSummaryTime: {
		color: "#888",
		fontSize: 20,
		marginLeft: 10,
		'&:hover': {
			cursor: "pointer",
			opacity: 0.7,
		}
	},
	dialogPaper: {
		borderRadius: 15,
		padding: "5px 15px 15px",
	},
	backDrop: {
		backgroundColor: "#00000042"
	},
	statusCircle: {
		width: 7,
		height: 7,
		borderRadius: 10,
	},
	columnLink: {
		display: 'flex',
		alignItems: 'center',
		'&:hover': {
			cursor: 'pointer',
		}
	},
	autocomplete: {
		marginBottom: 30,
        '& .MuiAutocomplete-inputRoot': {
            height: '44px',
            display: 'flex',
            alignItems: 'center',
            '& .MuiChip-root': {
                marginTop: '-5px',
            },
            '& .MuiInputBase-input': {
				marginTop: '-5px'
            },
        },
		'& .MuiInputLabel-outlined': {
            marginTop:'-5px'
        },
	}
});

const StyledTableCell = withStyles((theme) => ({
	root: {
		fontSize: 13,
		borderBottomColor: customTheme.palette.divider,
		padding: "15px 5px !important",
	},
	head: {
		fontWeight: 500,
		color: customTheme.palette.grey[700],
	},
	body: {
		fontWeight: 400,
		color: customTheme.palette.grey[500],
	},
}))(TableCell);

const CustomDatagridHeaderTableCell = withStyles((theme) => ({
	head: {
		fontWeight: 500,
		color: customTheme.palette.grey[700],
		position: 'sticky',
		top: 0,
		zIndex: 5,
		backgroundColor: "#fff",
		fontFamily: 'Poppins-Medium'
	},
}))(TableCell);

const DatagridHeader = () => {
	const [role] = useState(sessionStorage.getItem('role'))
	const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
	const [hasParkingOptions] = useState(
		sessionStorage.getItem("allow_update_parking") === "1" ||
		sessionStorage.getItem("allow_parking_led_settings") === "1" ||
		sessionStorage.getItem("allow_parking_info_edit") === "1" ||
		sessionStorage.getItem("allow_parking_license_update") === "1"
	);
	return (
		<TableHead className="parkingsHeaderIcons">
			<TableRow>
				{role === 'admin' && <CustomDatagridHeaderTableCell></CustomDatagridHeaderTableCell>}
				<CustomDatagridHeaderTableCell></CustomDatagridHeaderTableCell>
				{role === 'admin' && <CustomDatagridHeaderTableCell></CustomDatagridHeaderTableCell>}
				<CustomDatagridHeaderTableCell>Name</CustomDatagridHeaderTableCell>
				{role !== 'admin' && <CustomDatagridHeaderTableCell>Vehicle Summary</CustomDatagridHeaderTableCell>}
				{role === 'admin' && <CustomDatagridHeaderTableCell>Place</CustomDatagridHeaderTableCell>}
				{role === 'admin' && <CustomDatagridHeaderTableCell>Type</CustomDatagridHeaderTableCell>}
				{role === 'admin' && <CustomDatagridHeaderTableCell>Sub Type</CustomDatagridHeaderTableCell>}
				{role === 'admin' && <CustomDatagridHeaderTableCell>EDC Provider</CustomDatagridHeaderTableCell>}
				{role === 'admin' && <CustomDatagridHeaderTableCell>
					<div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
						<IconButton title="Transactions">
							<CompareArrowsIcon />
						</IconButton>
						{/* <IconButton title="Devices">
							<PhoneAndroidIcon />
						</IconButton> */}
						<IconButton title="Slot Booked">
							<CalendarTodayOutlinedIcon />
						</IconButton>
						<div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
							<p style={{ width: 30, lineHeight: "3px" }} title="Controller Status"></p>
							<IconButton title="Devices">
								<PhoneAndroidIcon />
							</IconButton>
						</div>
					</div>
				</CustomDatagridHeaderTableCell>}
				{!viewOnly && role === 'admin' && hasParkingOptions && <CustomDatagridHeaderTableCell>Options</CustomDatagridHeaderTableCell>}
			</TableRow>
		</TableHead>
	)
};

const AVAILABLE_SEARCH_TYPES = ["Parking Name", "Parking Type", "Sub Type", "Place"];
export const ParkingList = ({ permissions, ...props }) => {
	const eventTracker = UseAnalyticsEvent()
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory()
	const location = useLocation();
	const listDataRef = useRef()
	let defaultImg = "https://images.parksmart.in/main/Images/ParkingImages/default_parking.jpg"

	const defaultCategoryFilter = sessionStorage.getItem("filter_category");
	const [categoryToFilter] = React.useState(defaultCategoryFilter);
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
	const [showSummary] = React.useState(sessionStorage.getItem('show_dashboard_summary') !== "0");
	const [showPaidUnpaidAmount] = React.useState(sessionStorage.getItem("show_paid_unpaid_amount") === "1");
	const [paymentDistributions] = useState(sessionStorage.getItem("payment_distributions"));
	//const [editSummaryTime, setEditSummaryTime] = React.useState(false);
	const parkingSummary = useSelector(state => state.parkingSummary);
	// console.log("Parking Summary", parkingSummary)
	const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
	const [showFastagPayment] = useState(sessionStorage.getItem("show_fastag_payment") === "1");
	//const [minDateValue] = useState(sessionStorage.getItem("data_period_allowed"));
	const [role] = useState(sessionStorage.getItem('role'));
	const [availableSearchTypes] = useState(role === "admin" ? AVAILABLE_SEARCH_TYPES.concat(["Access Key"]) : AVAILABLE_SEARCH_TYPES);
	let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
	const [searchTypes, setSearchTypes] = useState("Parking Name");
	let parkingSearch = sessionStorage.getItem('parkingSearch') ? sessionStorage.getItem('parkingSearch') : ""
	const [search, setSearch] = useState(parkingSearch)
	const [showSettingsMob, setShowSettingsMob] = useState(false)
	const [parkingId, setParkingId] = useState("")
	const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)

	const [startDateTime, setStartDateTime] = React.useState(null);
	const [endDateTime, setEndDateTime] = React.useState(null);
	const [startDateTimeFilter, setStartDateTimeFilter] = useState(null);
	const [endDateTimeFilter, setEndDateTimeFilter] = useState(null);
	const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
	const [useLatestVersion] = useState(sessionStorage.getItem("use_latest_version") === "1");
	const [allowCreateParking] = useState(sessionStorage.getItem("allow_create_parking") === "1");
	const [allowDownloadParkings] = useState(sessionStorage.getItem("allow_download_parkings") === "1");
	const [allowUpdateParking] = useState(sessionStorage.getItem("allow_update_parking") === "1");
	const [allowParkingLedSettings] = useState(sessionStorage.getItem("allow_parking_led_settings") === "1");
	const [allowParkingInfoEdit] = useState(sessionStorage.getItem("allow_parking_info_edit") === "1");
	const [allowParkingLicenseUpdate] = useState(sessionStorage.getItem("allow_parking_license_update") === "1");
	const hasParkingOptions = allowUpdateParking || allowParkingLedSettings || allowParkingInfoEdit || allowParkingLicenseUpdate;
	const [allowParkingStatusToggle] = useState(sessionStorage.getItem("allow_parking_status_toggle") === "1");
	//const [showParkingName, setShowParkingName] = useState(false)

	let filterTypesInitState = [
		{
			filterType: "Status",
			dataList: [{ name: "Active", id: 1 }, { name: "Inactive", id: 2 }],
			listType: "Static",
			caseType: "Static",
			showFilter: true
		},
		{
			filterType: "EDC Provider",
			dataList: [{ name: "ParkSmart", id: 1 }, { name: "Park+", id: 2 }],
			listType: "Static",
			caseType: "Static",
			showFilter: true
		}
	]

	const [settingFilterFormat, setSettingFilterFormat] = useState({})

	const onSummaryChange = value => {
		dispatch({
			type: "UPDATE_PARKING_SUMMARY",
			payload: {
				parkingSummary: {
					...parkingSummary,
					...value,
				}
			}
		});
	};

	const fetchSummary = () => {
		//setEditSummaryTime(false);
		onSummaryChange({ loading: true, data: null });
		var params = {
			user_id: sessionStorage.getItem("user_id"),
			category: categoryToFilter ? categoryToFilter : ""
		}
		if (startDateTime) params.start_time = moment(startDateTime).format("YYYY-MM-DD HH:mm:ss");
		if(endDateTime) params.end_time = moment(endDateTime).format("YYYY-MM-DD HH:mm:ss");

		let getSummaryURL = showPaidUnpaidAmount ? `${config.HOST_NAME}/crm/v3/allParkingSummary/paidunpaid?${stringify(params)}` : `${config.HOST_NAME}/crm/v3/allParkingSummary?${stringify(params)}`
		fetch(getSummaryURL, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
		})
			.then(response => {
				saveTokens(response)
				return response.json()
			})
			.then((responseJson) => {
				if (responseJson.success) {
					onSummaryChange({ loading: false, data: responseJson.data });
				} else {
					onSummaryChange({ loading: false });
					notify(responseJson.message, 'warning');
				}
			})
			.catch((e) => {
				onSummaryChange({ loading: false });
				notify('Error Fetching Parking Summary', 'warning')
			});
	};

	const setTimeFilters = () => {
		setStartDateTimeFilter(startDateTime);
		setEndDateTimeFilter(endDateTime);
	};

	// const renderStatus = record => (
	// 	<>
	// 		{
	// 			record.parking_info_id ?
	// 				<div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: record.approved === 1 ? `${customTheme.palette.primary.main}19` : `${customTheme.palette.error.main}19`, marginRight: 8 }}>
	// 					<div className={classes.statusCircle} style={{ backgroundColor: record.approved === 1 ? customTheme.palette.primary.main : customTheme.palette.error.main }} />
	// 				</div>
	// 				:
	// 				<div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: "#9597991a", marginRight: 8 }}>
	// 					<div className={classes.statusCircle} style={{ backgroundColor: "#1717181f" }} />
	// 				</div>
	// 		}
	// 	</>
	// );

	const renderCoordinatesMob = record => (
		<>
			{
				record.parking_info_id ?
					<Typography variant="body2" color="secondary" className={classes.columnLink}>
						Coordinates: {record.parking_latitude && record.parking_latitude ? `${parseFloat(record["parking_latitude"]).toFixed(3)}, ${parseFloat(record["parking_longitude"]).toFixed(3)}` : "-"}
					</Typography>
					: null
			}
		</>
	);

	const renderCoordinates = record => (
		<>
			{
				record.parking_info_id ?
					<>
						{record.city ? <p style={{ lineHeight: "3px", color: "#707683", textTransform: "capitalize" }}>{record.city}</p> : <p style={{ lineHeight: "3px" }}>-</p>}
						{record.parking_latitude && record.parking_longitude ?
							<p style={{ color: "#B5B5B5", lineHeight: "3px" }}>
								{parseFloat(record["parking_latitude"]).toFixed(3)}, {parseFloat(record["parking_longitude"]).toFixed(3)}
							</p> : '-'
						}
					</> : "-"
			}
		</>
	);
	const renderStatusForMob = record => (
		<>
			{
				record.parking_info_id ?
					<div style={{ display: 'flex', alignItems: "center" }}>
						<span style={{ color: "#5a5a5a", marginRight: 5 }}>Status:</span>
						<div className={classes.statusCircle} style={{ backgroundColor: record.approved === 1 ? customTheme.palette.primary.main : customTheme.palette.error.main }} />
						{/* {record.approved === 1 ? "Active" : "Inactive"} */}
					</div>
					: null
			}
		</>
	);

	const RenderTextRightToLeft = ({ record, permissions }) => {
		const parkingName = <div className={record && record.general_name.length > 26 ? "textBox" : ""} title={record.general_name}><span style={{ color: "#334d6e", textTransform: "capitalize", fontWeight: "bold", }}>{record.general_name}</span></div>;
		return (
			<div>
				{useLatestVersion ? <Link to={`/parkings/${record.id}/show`} style={{ textDecoration: "none" }}>{parkingName}</Link> : parkingName}
				{
					permissions === 'admin' &&
					<div style={{ display: "flex", justifyContent: 'flex-start', alignItems: "center", columnGap: 5 }}>
						<p style={{ color: "#B5B5B5", lineHeight: "0px", marginTop: 6 }}>
							{record.access_key} {record.zone_ids && record.zone_ids.includes(',') ? " | MultipleZones" : <IconButton style={{ color: "#999", padding: 0, marginLeft: 2 }} onClick={() => { navigator.clipboard.writeText(record.access_key) }}><ContentCopyIcon style={{ fontSize: 12 }} /></IconButton>}
						</p>
					</div>
				}
			</div>
		)
	}

	const getExportFile = (fileType) => {
		const {current : {total, currentSort}} = listDataRef
		const params = {
			filter: JSON.stringify({ search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, ...settingFilterFormat }),
			sort: JSON.stringify([currentSort.field, currentSort.order]),
			page: 1,
			perPage: total,
			user_id: sessionStorage.getItem("user_id")
		};
		fetch(`${config.HOST_NAME}/crm/v3/getParkingAccessKeysV3Export?${queryString.stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
				'Accept': `application/${fileType}`,
			},
		})
			.then(response => {
				saveTokens(response)
				return response.blob()
			})
			.then(blob => {
				const url = URL.createObjectURL(blob);
				const tempLinkElement = document.createElement('a');
				tempLinkElement.href = url;
				tempLinkElement.setAttribute('download', `Parkings Details.${fileType}`);
				tempLinkElement.click();
			})
			.catch(error => {
				notify('Error Exporting Data', 'warning');
			});
	};

	const getExcelFile = () => {
		getExportFile("xlsx");
	};

	React.useEffect(() => {
		if (showSummary)
			fetchSummary();
	}, [showSummary, startDateTimeFilter, endDateTimeFilter]); // eslint-disable-line react-hooks/exhaustive-deps

	const BulkActionButtons = (props) => {
		const { data } = useListContext();
		const parkingData = data[props.selectedIds[0]]
		return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", columnGap: 1 }} >
			<AssignParkingZone parkingData={parkingData} selectedIds={props.selectedIds} />
		</div>
	}

	React.useEffect(() => {
		let values = {}
		// Add more types based on the filters
		if (filterListValue) {
			for (let val in filterListValue) {
				if (filterListValue[val].filterType === "Status") {
					values = { ...values, status_type: filterListValue[val].value ? filterListValue[val].value : undefined }
				} if (filterListValue[val].filterType === "EDC Provider") {
					values = { ...values, edc_provider: filterListValue[val].value ? filterListValue[val].value : undefined }
				}
			}
			setSettingFilterFormat(values)
		}
		if (filterListValue === null) {
			setSettingFilterFormat({})
		}
	}, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

	React.useEffect(() => {
		eventTracker("PARKING SECTION", " PARKINGS LIST");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	return (
		<>
			<div style={{ margin: "10px 0px 0px 0px", display: "flex", flexDirection: "column", paddingBottom: 0 }}>
				<>
					<div className='customStyleForDataSearchDiv' style={{ marginBottom: permissions === 'admin' || permissions === 'sales' ? 0 : 20 }}>
						{showFilter && <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={availableSearchTypes} saveInputFlag={true} />}
						{showSummary && <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} onChange={setTimeFilters} />}
						{(permissions === 'admin' || permissions === 'sales') && <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />}
						{
							permissions === 'admin' &&
							<Button className='buttonStyle addBorderRadius'
								onClick={(e) => {
									e.stopPropagation()
									sessionStorage.setItem('mapview_type', "All");
									history.push("/mapview")
								}}>
								<MapOutlinedIcon />
							</Button>
						}
						{allowCreateParking && <CustomCreateButton label="Create" basePath={props.basePath} resource={props.resource} style={{ marginLeft: 10 }} />}
						{allowDownloadParkings && <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} />}

					</div>
					{showSummary && <>
						<div className={classes.summaryCardContainer} style={{ margin: customTheme.spacing(1, 0, 3), gridColumnGap: isSmallDevice ? 0 : "2%", gridTemplateColumns: isSmallDevice ? "100%" : "23% 23% 24% 23%", gridAutoFlow: isSmallDevice ? "row" : "column", gridRowGap: 14 }}>
							<ParkingSummaryCard
								title="Vehicle In"
								data={parkingSummary.data}
								getValue={data => data.enteredVehicles}
								getTypes={data => data.vehicleTypes}
								getTypeValue={type => type.entered ? type.entered : 0}
							/>
							<ParkingSummaryCard
								title="Vehicle Out"
								data={parkingSummary.data}
								getValue={data => data.exitedVehicles}
								getTypes={data => data.vehicleTypes}
								getTypeValue={type => type.exited ? type.exited : 0}
								valueDescription={parkingSummary.data && parkingSummary.data.exitedVehiclesCurrentPeriod && parkingSummary.data.exitedVehiclesPreviousPeriod ? `(${parkingSummary.data.exitedVehiclesCurrentPeriod} + ${parkingSummary.data.exitedVehiclesPreviousPeriod})` : null}
								valueDescriptionTooltip={`Indicates No. of Vehicles Exited which were entered in the current time period + No. of Vehicles Exited which were entered before the current time period`}
							/>
							{(!parkingSummary.data || parkingSummary.data.show_amount_in_crm) && !showPaidUnpaidAmount && paymentDistributions === 'P' && <ParkingSummaryCard
								title="Amount"
								data={parkingSummary.data}
								getValue={data => data.amount ? `₹ ${data.amount.toFixed(2)}` : `₹ 0`}
								getTypes={data => data.vehicleTypes}
								getTypeValue={type => type.amount ? `₹ ${type.amount.toFixed(2)}` : '₹ 0'}
								valueDescription={parkingSummary.data && parkingSummary.data.amountCurrentPeriod && parkingSummary.data.amountPreviousPeriod ? `(${parkingSummary.data.amountCurrentPeriod.toFixed(2)} + ${parkingSummary.data.amountPreviousPeriod.toFixed(2)})` : null}
								valueDescriptionTooltip={`Indicates Collection from the vehicles which entered in the current time period + Collection from the vehicles which entered before the current time period`}
							/>}
							{(!parkingSummary.data || parkingSummary.data.show_amount_in_crm) && showPaidUnpaidAmount && paymentDistributions === 'P' && <ParkingSummaryCard
								title="Paid Amount"
								data={parkingSummary.data}
								getValue={data => data.amount ? `₹ ${data.amount.toFixed(2)}` : `₹ 0`}
								getTypes={data => data.vehicleTypes}
								getTypeValue={type => type.amount ? `₹ ${type.amount.toFixed(2)}` : '₹ 0'}
							/>}
							{(!parkingSummary.data || parkingSummary.data.show_amount_in_crm) && showPaidUnpaidAmount && paymentDistributions === 'P' && <ParkingSummaryCard
								title="Unpaid Amount"
								data={parkingSummary.data}
								getValue={data => data.unpaidAmount ? `₹ ${data.unpaidAmount.toFixed(2)}` : `₹ 0`}
								getTypes={data => data.vehicleTypes}
								getTypeValue={type => type.unpaid_amount ? `₹ ${type.unpaid_amount.toFixed(2)}` : '₹ 0'}
							/>}

							{(!parkingSummary.data || parkingSummary.data.show_amount_in_crm) && (paymentDistributions === 'PM' || paymentDistributions === 'MP' || paymentDistributions === 'PMP' || paymentDistributions === 'PP') && <ParkingSummaryCard
								title="Payment Summary"
								data={parkingSummary.data}
							/>}
							<ParkingSummaryCard
								title="Not Exited"
								data={parkingSummary.data}
								getValue={data => (data.notExited > 0 ? data.notExited : 0)}
								getTypes={data => data.vehicleTypes}
								getTypeValue={type => type.notExited >= 0 ? type.notExited : 0}
							/>
						</div>

						{parkingSummary.data && parkingSummary.data.show_payment_type_summary && <div className={classes.summaryCardContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "23% 23% 24% 23%", gridRowGap: isSmallDevice ? 18 : 0, justifyContent: "space-between" }}>
							<ParkingSummaryCard
								title="CASH"
								data={parkingSummary.data}
								getValue={data => data.cashAmount ? `₹ ${data.cashAmount.toFixed(2)}` : "₹ 0"}
								getTypes={data => data.vehicleTypes}
								getTypeValue={type => type.cash_amount ? `₹ ${type.cash_amount.toFixed(2)}` : '₹ 0'}
							/>
							<ParkingSummaryCard
								title="CARD"
								data={parkingSummary.data}
								getValue={data => data.cardAmount ? `₹ ${data.cardAmount.toFixed(2)}` : "₹ 0"}
								getTypes={data => data.vehicleTypes}
								getTypeValue={type => type.card_amount ? `₹ ${type.card_amount.toFixed(2)}` : '₹ 0'}
							/>
							<ParkingSummaryCard
								title="UPI"
								data={parkingSummary.data}
								getValue={data => data.upiAmount ? `₹ ${data.upiAmount.toFixed(2)}` : "₹ 0"}
								getTypes={data => data.vehicleTypes}
								getTypeValue={type => type.upi_amount ? `₹ ${type.upi_amount.toFixed(2)}` : '₹ 0'}
							/>
							{
								parkingSummary.data.show_payment_type_summary && !showFastagPayment && <ParkingSummaryCard
									title="WALLET"
									data={parkingSummary.data}
									getValue={data => data.walletAmount ? `₹ ${data.walletAmount.toFixed(2)}` : "₹ 0"}
									getTypes={data => data.vehicleTypes}
									getTypeValue={type => type.wallet_amount ? `₹ ${type.wallet_amount.toFixed(2)}` : '₹ 0'}
								/>
							}
							{
								parkingSummary.data.show_payment_type_summary && showFastagPayment && <ParkingSummaryCard
									title="FASTag"
									data={parkingSummary.data}
									getValue={data => data.fastagAmount ? `₹ ${data.fastagAmount.toFixed(2)}` : `₹ 0`}
									getTypes={data => data.vehicleTypes}
									getTypeValue={type => type.fastag_amount ? `₹ ${type.fastag_amount.toFixed(2)}` : '₹ 0'}
								/>
							}
						</div>}
					</>
					}
				</>
			</div>

			<List {...props} title="List of Parkings" 
			style={{marginTop: 20}} 
			actions={false} 
			filter={{ search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, ...settingFilterFormat }} 
			exporter={false}
			pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}} />}
			perPage={25} 
			bulkActionButtons={permissions === 'admin' ? <BulkActionButtons /> : false}
			empty={false}
			>
				{isSmallDevice ?
					<SimpleList
						primaryText={record => null}
						secondaryText={record => (
							<div onClick={() => { if (useLatestVersion) history.push(`/parkings/${record.id}/show`) }}>
								{record.general_name && <div style={{ fontSize: "16px", color: "#272727" }}>{record.general_name}</div>}
								{permissions === 'admin' && <FunctionField label="Status" render={renderStatusForMob} />}
								{permissions === 'admin' && record.access_key && <div><span style={{ color: "#5a5a5a" }}>Access Key: </span>{record.access_key} <IconButton style={{ color: "#888", padding: 0, marginLeft: 5 }} onClick={(event) => { event.stopPropagation(); navigator.clipboard.writeText(record.access_key); }}><ContentCopyIcon style={{ fontSize: 14 }} /></IconButton></div>}
								{permissions === 'admin' && record.city && <div><span style={{ color: "#5a5a5a" }}>Place: </span>{record.city}</div>}
								{permissions === 'admin' && <FunctionField render={renderCoordinatesMob} />}
								{permissions === 'admin' && record.parking_type && <div><span style={{ color: "#5a5a5a" }}>Parking Type: </span>{record.parking_type}</div>}
								{permissions === 'admin' && record.parking_sub_type && <div><span style={{ color: "#5a5a5a" }}>Parking Sub Type: </span>{record.parking_sub_type}</div>}
								{permissions === 'admin' && record && record.parking_info_id && <GetParkingTSBDCounts record={record} />}
								{/* {permissions === "admin" && <EDCProviderToggle record={record} />} */}

								<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									{permissions === 'admin' && allowParkingStatusToggle && record && <ParkingActiveInActiveToggle record={record} />}
									{permissions !== 'admin' && useLatestVersion && <ShowButton label="Vehicle Summary" {...props} record={record} style={{ marginTop: "5px" }} />}
									{!viewOnly && permissions === 'admin' && allowUpdateParking && record && <ParkingSetting record={record} />}
									{!viewOnly && permissions === 'admin' && allowParkingLedSettings && record && record.led_id && record.zone_ids && !record.zone_ids.includes(',') ?
										<LedSettings record={record} /> :
										!viewOnly && permissions === 'admin' && allowParkingLedSettings && <IconButton title="LED Settings" disabled>
											<EmojiObjectsIcon />
										</IconButton>
									}
									{!viewOnly && permissions === 'admin' && allowParkingInfoEdit && record.parking_info_id ?
										<ParkingInfoEdit record={record} />
										:
										!viewOnly && permissions === 'admin' && allowParkingInfoEdit && <IconButton title="Parking Info Edit" disabled>
											<EditIcon />
										</IconButton>
									}
									{!viewOnly && permissions === 'admin' && allowParkingLicenseUpdate && <ParkingLicenseDialog expiryTime={record.license_expiry_time} id={record.parking_info_id}/>}
									{!viewOnly && permissions === 'admin' && record.zone_ids.includes(',') &&
										<IconButton onClick={(e) => {
											e.stopPropagation()
											if (parkingId !== "" && parkingId !== record.id) {
												setParkingId(record.id)
												setShowSettingsMob(true)
											} else {
												setParkingId(record.id)
												setShowSettingsMob(!showSettingsMob)
											}
										}}
										>
											{showSettingsMob && record.id === parkingId ? <KeyboardArrowUpIcon style={{ fontSize: "35px", color: "#18cc69" }} /> : <KeyboardArrowDownIcon style={{ fontSize: "35px", color: "#18cc69" }} />}
										</IconButton>}

								</div>

								{showSettingsMob && record.id === parkingId && <SettingDetails {...props} record={record} />}
							</div >)}
						linkType={false}
						onContextMenu={event => event.preventDefault()}
						rowStyle={() => ({ minHeight: permissions === 'admin' ? 80 : 0, alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
					/>
					:
					<Datagrid className='parkingDataGrid' header={DatagridHeader} component={ScrollableTable} classes={{ headerCell: classes.parkingListHead }} expand={<SettingDetails />}
						isRowExpandable={record => record && record.zone_ids && record.zone_ids.includes(',') && (permissions === 'admin' || permissions === 'sales')}>
						{permissions === 'admin' &&
							<FunctionField label={false} render={(record) => {
								return record && <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100px" }}>
									{permissions === 'admin' && allowParkingStatusToggle && record && <ParkingActiveInActiveToggle record={record} />}
									<ImageGalleryDialog thumbnailStyle={{ marginLeft: 8 }} thumbnail={true} record={record} getImages={(record) => {
										let parkingImage = defaultImg;
										const imgs = record && record.parking_images ? JSON.parse(record.parking_images) : undefined;
										if (Array.isArray(imgs) && imgs.length > 0) {
											return [...imgs]
										} else {
											return [parkingImage]
										}
									}} />
								</div>
							}} />}
						<FunctionField label='Name' render={(record) => record && record.general_name && <RenderTextRightToLeft record={record} permissions={permissions} />} />
						{permissions !== "admin" && <ShowButton label="Vehicle Summary" />}
						{permissions === 'admin' && <FunctionField label="Place" render={record => record && renderCoordinates(record)} />}
						{permissions === 'admin' && <FunctionField label="Type" render={(record) => record && record.parking_type ? <p className='tableDataCustomStyle'>{record.parking_type}</p> : "-"} />}
						{permissions === 'admin' && <FunctionField label="Sub Type" render={(record) => record && record.sub_type ? <p className='tableDataCustomStyle'>{record.sub_type}</p> : "-"} />}
						{permissions === 'admin' && <FunctionField label={false} render={(record) => record && <CustomSelectDropDown record={record} />} />}

						{permissions === 'admin' && <FunctionField label={false} render={(record) => record && record.parking_info_id && <GetParkingTSBDCounts record={record} />} />}
						{
							!viewOnly && permissions === 'admin' && hasParkingOptions &&
							<FunctionField className='parkingOptions' label="Options" render={(record) => {
								return <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginLeft: -12 }}>
									{allowUpdateParking && record && <ParkingSetting record={record} />}
									{allowParkingLedSettings && record && record.led_id && record.zone_ids && !record.zone_ids.includes(',') ? <LedSettings record={record} /> :
										allowParkingLedSettings && <IconButton title="LED Settings" disabled>
											<EmojiObjectsIcon />
										</IconButton>
									}
									{allowParkingInfoEdit && record && record.parking_info_id ?
										<ParkingInfoEdit record={record} />
										:
										allowParkingInfoEdit && <IconButton title="Parking Info Edit" disabled>
											<EditIcon />
										</IconButton>
									}
									{allowParkingLicenseUpdate && <ParkingLicenseDialog expiryTime={record.license_expiry_time} id={record.parking_info_id}/>}
								</div>
							}} />
						}
					</Datagrid >
				}
			</List >
		</>
	);
};

const CustomSelectDropDown = ({ record }) => {

	const refresh = useRefresh()
	const [items] = useState(["Unknown", "ParkSmart", "Park+"])
	const [showItems, setShowItems] = useState(false)

	const [anchorEl, setAnchorEl] = React.useState(null);
	const [loading, setLoading] = React.useState(false)

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
		setShowItems(!showItems)
	};

	const handleClose = () => {
		setAnchorEl(null);
		setShowItems(false)
	};

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;


	const edcProviderHandler = (providerName) => {
		setLoading(true);
		const params = {
			user_id: sessionStorage.getItem("user_id"),
			id: record.id,
			edc_provider_name: providerName

		};
		fetch(`${config.HOST_NAME}/crm/v3/updateEdcProvider`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
			body: JSON.stringify(params),
		})
			.then(response => {
				saveTokens(response)
				return response.json()
			})
			.then((responseJson) => {
				setLoading(false);
				if (responseJson.success) {
					refresh();
					notify(responseJson.message, "success");
				}
				else {
					notify(responseJson.message, 'warning');
				}
			})
			.catch((e) => {
				setLoading(false);
				notify('Error While Updating EDC Provider', 'warning')
			});
	};

	return (
		<>
			<div className="selectBox">
				<div className="selectBoxContainer" style={{ position: "relative" }}>
					<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
						<div style={{ marginTop: loading ? 6 : 2, cursor: "pointer", width: 70, height: 30 }}>
							{loading ? <Skeleton variant="text" height={20} width={65} style={{ display: "inline-block", transform: "none", borderRadius: 5 }} /> :
								record.edc_provider_name === "ParkSmart" ?
									<p style={{ fontWeight: "bold", lineHeight: "0px" }}><span style={{ color: "#334d6e" }}>{record.edc_provider_name.slice(0, 4)}</span><span style={{ color: "#18cc69" }}>{record.edc_provider_name.slice(4, record.edc_provider_name.length)}</span></p>
									: <p style={{ lineHeight: "0px", color: "#BDBDBD", fontWeight: "bold" }}>{record.edc_provider_name}</p>
							}
						</div>
						<div style={{ width: 30, height: 30, display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }} onClick={handleClick}>
							{
								showItems ? <ExpandLessIcon style={{ color: "#334D6E" }} /> : <ExpandMoreIcon style={{ color: "#334D6E" }} />
							}
						</div>
					</div>
					<Popover
						id={id}
						open={open}
						anchorEl={anchorEl}
						onClose={handleClose}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'right',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'right',
						}}
					>
						{items.map((item, index) => (
							<div
								key={index}
								onClick={() => {
									handleClose()
									edcProviderHandler(item)
								}}
								className="secondaryUsersList"
								style={{ cursor: "pointer", paddingLeft: 15, display: "flex", justifyContent: "center", alignItems: 'flex-start', flexDirection: 'column', width: "135px", minHeight: "45px" }}
							>
								<p style={{ lineHeight: "0px", color: "#334D6E", fontWeight: "bold", fontSize: 14 }}>{item}</p>
							</div>
						))}
					</Popover>
				</div>
			</div>
		</>
	);
}

function ParkingActiveInActiveToggle(props) {
	const { record } = props;
	const refresh = useRefresh()
	const [status, setStatus] = useState(record.approved)
	const [dialogVisible, setDialogVisible] = React.useState(false);
	const [loading, setLoading] = React.useState(false);

	const openDialog = () => {
		setDialogVisible(true);
	};

	const closeDialog = () => {
		setDialogVisible(false);
		refresh()
	};

	const toggleHandler = (event) => {
		event.preventDefault();
		setLoading(true);
		const params = {
			user_id: sessionStorage.getItem("user_id"),
			id: record.parking_info_id,
			status: status === true ? 1 : 0

		};
		fetch(`${config.HOST_NAME}/crm/v3/updateParkingStatus`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
			body: JSON.stringify(params),
		})
			.then(response => {
				saveTokens(response)
				return response.json()
			})
			.then((responseJson) => {
				setLoading(false);
				if (responseJson.success) {
					refresh();
					notify(responseJson.message, "success");
					setDialogVisible(false);
				}
				else {
					notify(responseJson.message, 'warning');
				}
			})
			.catch((e) => {
				setLoading(false);
				notify('Error While Updating Parking Status', 'warning')
			});
	};

	return (
		<>
			<AntSwitch checked={record.approved === 1 ? true : false} onChange={(e) => {
				setStatus(e.target.checked)
				openDialog()
			}} />
			<Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
				<DialogContent>
					<p>Are you sure you want to <strong>{record.approved ? "DeActivate" : "Activate"}</strong> this Parking.</p>
				</DialogContent>
				<DialogActions>
					<Button onClick={closeDialog} color="default">Close</Button>
					<Button onClick={toggleHandler} >Yes {loading && <CircularProgress size={20} />}</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

function ParkingZoneDialog(props) {
	const classes = useStyles()
	//const notify = useNotify()
	const [open, setOpen] = React.useState(false);
	const { parkingData, selectedIds } = props
	const [noParkingInfo, setNoParkingInfo] = useState(false)
	const [parkingNameSearched, setParkingNameSearched] = useState("")
	const [selectedParkingInfo, setSelectedParkingInfo] = useState("")

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleUpdate = (event) => {
		if ((selectedParkingInfo === "" || selectedParkingInfo == null) && !noParkingInfo) {
			notify("Please Select Parking from Options", 'warning');
			return
		}
		event.preventDefault();
		handleClose();
		const { dispatchCrudUpdate, basePath } = props;
		const data = {
			...parkingData,
		};
		if (noParkingInfo) {
			data.parking_info_id = ""
			data.noParkingInfo = noParkingInfo
			data.parkingNameSearched = parkingNameSearched
		} else {
			data.parking_info_id = selectedParkingInfo.id
		}
		dispatchCrudUpdate('parkings', parkingData.id, data, parkingData, basePath, "/parkings");
	};

	return (
		<div style={{ display: "flex", justifyContent: "center", alignItems: "center", columnGap: 1 }}>
			<IconButton style={{ color: selectedIds.length !== 1 ? "#BDBDBD" : "#18cc69" }} onClick={handleClickOpen} disabled={selectedIds.length !== 1}> <QueueIcon style={{ fontSize: "20px" }} /></IconButton>
			<Dialog
				open={open}
				onClose={handleClose}
				classes={{ paper: classes.dialogPaper }}
			>
				<SimpleForm toolbar={false}>
					<p>Please select a <strong>Zone</strong></p>
					<ParkingInfoSelector source="parking_info_id" resourceParam="parking_name" resourcePath="parkingInfo" label="Select Parking Group" setNoParkingInfo={setNoParkingInfo} setParkingNameSearched={setParkingNameSearched} setSelectedParkingInfo={setSelectedParkingInfo} getOptionValue={(option) => {
						return option["id"]
					}} getOptionLabel={option => option["name"]} />
				</SimpleForm>

				<DialogActions>
					<Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
						Close
					</Button>

					<Button onClick={handleUpdate} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
						{noParkingInfo ? "Create" : "Assign"}
					</Button>

				</DialogActions>
			</Dialog>
		</div>
	);
}
ParkingZoneDialog.defaultProps = {
	redirect: 'list',
	undoable: false
};
const AssignParkingZone = compose(
	connect(
		null,
		{ dispatchCrudUpdate: crudUpdate }
	),
	translate
)(ParkingZoneDialog);

// function TogglerButton(props) {
// 	const classes = useStyles()
// 	const { record } = props;
// 	const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));

// 	const [dialogVisible, setDialogVisible] = React.useState(false);
// 	const [providerName, setProviderName] = React.useState("ParkSmart");

// 	const openDialog = () => {
// 		setDialogVisible(true);
// 	};

// 	const closeDialog = () => {
// 		setDialogVisible(false);
// 	};

// 	const handleUpdate = (event) => {
// 		event.preventDefault();
// 		closeDialog();
// 		const { dispatchCrudUpdate, basePath } = props;
// 		const data = {
// 			...record,
// 			edc_provider_status: !record.edc_provider_status === false ? 0 : 1,
// 			edc_provider_name: !record.edc_provider_status === false ? "" : providerName
// 		};
// 		dispatchCrudUpdate('parkings', record.id, data, record, basePath, "/parkings");
// 	};

// 	if (!record) return null

// 	return (
// 		<div style={{ textAlign: "left", display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>

// 			{isSmallDevice && <div><span style={{ color: "#5a5a5a" }}>EDC Provider: </span></div>}

// 			<div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginLeft: isSmallDevice ? 10 : 0, fontFamily: "Poppins-Medium" }}>
// 				<AntSwitch checked={Boolean(record.edc_provider_status)} onChange={openDialog} />
// 				{
// 					record && record.edc_provider_name === "ParkSmart" ?
// 						<p style={{ marginLeft: 4 }}><span style={{ color: "#334d6e" }}>{record.edc_provider_name.slice(0, 4)}</span><span style={{ color: "#18cc69" }}>{record.edc_provider_name.slice(4, record.edc_provider_name.length)}</span></p>
// 						:
// 						<p style={{ marginLeft: 4 }}><span>{record.edc_provider_name ? record.edc_provider_name : "Unknown"}</span></p>
// 				}
// 			</div>

// 			<Dialog open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaper }}>
// 				<DialogContent>
// 					{record && (record.edc_provider_name === "" || record.edc_provider_name == null) &&
// 						<MuiTextField
// 							variant="outlined"
// 							size="small"
// 							label="EDC Provider Name"
// 							value={providerName}
// 							select
// 							onChange={(e) => setProviderName(e.target.value)}
// 							style={{ width: 200 }}>
// 							<MenuItem value="ParkSmart">ParkSmart</MenuItem>
// 							<MenuItem value="Park+">Park+</MenuItem>
// 							<MenuItem value="Other">Other</MenuItem>
// 						</MuiTextField>
// 					}
// 					<p>Are you sure you want to <strong>{record.edc_provider_status ? "Drop" : "Acquire"}</strong> this Parking?</p>
// 				</DialogContent>
// 				<DialogActions>
// 					<Button color="default" onClick={closeDialog}>No</Button>
// 					<Button color="secondary" onClick={handleUpdate}>Yes</Button>
// 				</DialogActions>
// 			</Dialog>
// 		</div>
// 	);
// }
// TogglerButton.defaultProps = {
// 	redirect: 'list',
// 	undoable: false
// };
// const EDCProviderToggle = compose(
// 	connect(
// 		null,
// 		{ dispatchCrudUpdate: crudUpdate }
// 	),
// 	translate
// )(TogglerButton);

const GetParkingTSBDCounts = ({ record }) => {
	const classes = useStyles()
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

	//const notify = useNotify();
	const [loading, setLoading] = useState(true);
	const [parkingInfo, setParkingInfo] = useState({})

	React.useEffect(() => {
		fetch(`${config.HOST_NAME}/crm/v3/parking/infoTSBD?parking_info_id=${record.parking_info_id ? record.parking_info_id : ''}&access_key_id=${record.id}&zone_id=${record.zone_id ? record.zone_id : ''}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
		})
			.then(response => {
				saveTokens(response)
				return response.json()
			})
			.then(json => {
				setLoading(false);
				if (json.success) {
					setParkingInfo(json.data)
				} 
				// else notify(json.message, 'warning');
				
			})
			.catch((error) => {
				setLoading(false);
				// notify('Error While Fetching Parking Info', 'warning');
			});
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	if (!record) return null

	return (<div style={{ display: "block" }}>
		{
			!isSmallDevice ?
				<>
					{loading ?
						<div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
							<Skeleton variant="text" height={30} width={30} style={{ display: "inline-block", transform: "none", borderRadius: 5 }} />
							<Skeleton variant="text" height={30} width={30} style={{ display: "inline-block", transform: "none", borderRadius: 5 }} />
							<Skeleton variant="text" height={30} width={30} style={{ display: "inline-block", transform: "none", borderRadius: 5 }} />
						</div>
						:
						<div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center", fontFamily: "Poppins-Medium" }}>
							<IconButton title="Transactions">
								<span style={{ width: 20, height: 20, color: parkingInfo.transactions_count > 0 ? "#18cc69" : "#de575e" }}>{isSmallDevice && <span style={{ color: "#5a5a5a" }}>Transactions: </span>} {parkingInfo.transactions_count > 500 ? "500+" : parkingInfo.transactions_count}</span>
							</IconButton>
							<Link to={`/parkingSlotBookings?${queryString.stringify({ parking: JSON.stringify(record) })}`} style={{ textDecoration: "none" }}>
								<IconButton title="Slot Booked">
									<span style={{ width: 20, height: 20, color: parkingInfo.slotbooked_count > 0 ? "#18cc69" : "#de575e" }}>{isSmallDevice && <span style={{ color: "#5a5a5a" }}>Slot Booked: </span>} {parkingInfo.slotbooked_count}</span>
								</IconButton>
							</Link>

							<div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
									<div style={{ width: 15 }}>
										<div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: parkingInfo && parkingInfo.devices_status?.count !== 0 && parkingInfo && parkingInfo.devices_status?.count === parkingInfo && parkingInfo.devices_status?.onlineCount ? `${customTheme.palette.primary.main}19` : parkingInfo && parkingInfo.devices_status?.count !== 0 && parkingInfo && parkingInfo.devices_status?.count !== parkingInfo && parkingInfo.devices_status?.onlineCount ? "#ffdb0319" : `${customTheme.palette.error.main}19` }}>
											<div className={classes.statusCircle} style={{ backgroundColor: parkingInfo && parkingInfo.devices_status?.count !== 0 && parkingInfo && parkingInfo.devices_status?.count === parkingInfo && parkingInfo.devices_status?.onlineCount ? customTheme.palette.primary.main : parkingInfo && parkingInfo.devices_status?.count !== 0 && parkingInfo && parkingInfo.devices_status?.count !== parkingInfo && parkingInfo.devices_status?.onlineCount ? "#ffdb03" : customTheme.palette.error.main }} />
										</div>
									</div>
								<Link to={`/operator/devices?${queryString.stringify({ parking: JSON.stringify(record) })}`} style={{ textDecoration: "none" }}>
									<IconButton title="Devices">
										<div style={{ color: parkingInfo && parkingInfo.devices_status?.count !== 0 && parkingInfo && parkingInfo.devices_status?.count === parkingInfo && parkingInfo.devices_status?.onlineCount ? customTheme.palette.primary.main : parkingInfo && parkingInfo.devices_status?.count !== 0 && parkingInfo && parkingInfo.devices_status?.count !== parkingInfo && parkingInfo.devices_status?.onlineCount ? "#ffdb03" : customTheme.palette.error.main }}>{parkingInfo && parkingInfo.devices_status?.onlineCount} / {parkingInfo && parkingInfo.devices_status?.count}</div>
									</IconButton>
								</Link>
							</div>

						</div>
					}
				</>
				: <>
					{<div style={{ color: parkingInfo.transactions_count > 0 ? "#18cc69" : "#de575e" }}><span style={{ color: "#5a5a5a" }}>Transactions: </span>{loading ? <Skeleton variant="text" height={8} width={8} style={{ display: "inline-block", transform: "none", borderRadius: 20 }} /> : parkingInfo.transactions_count}</div>}
					{<div style={{ color: parkingInfo && parkingInfo.devices_status?.count > 0 ? "#18cc69" : "#de575e" }}><span style={{ color: "#5a5a5a" }}>Devices: </span>{loading ? <Skeleton variant="text" height={8} width={8} style={{ display: "inline-block", transform: "none", borderRadius: 20 }} /> : parkingInfo && parkingInfo.devices_status?.count ? parkingInfo.devices_status.count : 0}</div>}
					{<div style={{ color: parkingInfo.slotbooked_count > 0 ? "#18cc69" : "#de575e" }}><span style={{ color: "#5a5a5a" }}>Slot Booked: </span>{loading ? <Skeleton variant="text" height={8} width={8} style={{ display: "inline-block", transform: "none", borderRadius: 20 }} /> : parkingInfo.slotbooked_count}</div>}
				</>
		}

	</div>
	);
};

const ParkingSetting = ({ record, label }) => {
	return <>
		{
			record &&
			<Link to={`/parkings/${record.id}`} style={{ textDecoration: "none" }}>
				<IconButton title="Settings" onClick={(e) => {
					e.stopPropagation()
				}} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
					<SettingsOutlinedIcon style={{ color: "#18cc69" }} />
				</IconButton>
			</Link>
		}
	</>
}

const ParkingInfoEdit = ({ record, label }) => {
	return <>
		{
			record.parking_info_id &&
			<Link to={`/parkingInfo/${record.parking_info_id}`} style={{ textDecoration: "none" }}>
				<IconButton title="Parking Info Edit" onClick={(e) => {
					e.stopPropagation()
				}} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
					<EditIcon style={{ color: "#18cc69" }} />
				</IconButton>
			</Link>
		}
	</>
}

function LedSettings(props) {
	const { record } = props;
	return (
		<>
			<Link to={`/parkingLeds/${record.led_id}`} style={{ textDecoration: "none" }}>
				<IconButton title="LED Settings" onClick={(e) => {
					e.stopPropagation()
				}} style={{ display: "flex", justifyContent: "center", alignItems: "center", pointer: "cursor" }}>
					<EmojiObjectsIcon style={{ color: record.led_id !== null ? "#18cc69" : "#d5d7d9" }} />
				</IconButton>
			</Link>
		</>
	);
}

function SettingDetails(props) {
	const { record } = props;
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

	const finalZones = JSON.parse(record.zones_obj)
	if (!record) return null;
	return (
		<div className='parkingOptions'>
			<Paper style={{ width: "100%", mb: 2, boxShadow: "none", padding: "0 1px", border: "1px solid #bfbfbf", borderRadius: 10, marginTop: 20 }}>

				<div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 450px))", gap: 20, padding: "20px 10px 20px 10px", justifyContent: "flex-start" }}>
					{finalZones.map((zone, index) => (
						<div key={zone.id} style={{ display: isSmallDevice ? "block" : "flex", justifyContent: "space-between", alignItems: "center" }}>
							{isSmallDevice ?
								<div>
									<ListItemText primary={zone.name} />
									<div style={{ display: "flex", justifyContent: 'flex-start', alignItems: "center", columnGap: 10 }}>
										<div style={{ fontSize: 14, color: "#777", marginTop: -3 }}>{zone.access_key}</div>
										<IconButton className='fileIconCss' style={{ color: "#888", padding: 0 }} onClick={(event) => { event.stopPropagation(); navigator.clipboard.writeText(zone.access_key) }}><ContentCopyIcon /></IconButton>
									</div>
									<div><span style={{ color: "#5a5a5a" }}>Device Limit: </span>{zone.device_limit}</div>
								</div>
								:
								<div style={{ flex: 1 }}>
									<ListItemText primary={zone.name} title={zone.name} />
									<div style={{ display: "flex", justifyContent: 'flex-start', alignItems: "center", columnGap: 10 }}>
										<div style={{ fontSize: 14, color: "#888", marginTop: -5 }}>{zone.access_key}</div>
										<IconButton className='fileIconCss' style={{ color: "#888", padding: 0 }} onClick={() => { navigator.clipboard.writeText(zone.access_key) }}><ContentCopyIcon /></IconButton>
									</div>
									<div><span style={{ color: "#5a5a5a" }}>Device Limit: </span>{zone.device_limit}</div>
								</div>
							}

							<div style={{ display: "flex" }}>
								<Link to={`/parkings/${zone.id}`} style={{ textDecoration: "none" }}>
									<IconButton title='Settings' onClick={(e) => { e.stopPropagation() }} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
										<SettingsOutlinedIcon style={{ color: "#18cc69" }} fontSize="small" />
									</IconButton>
								</Link>

								{
									zone.led_id &&
									<Link to={`/parkingLeds/${zone.led_id}`} style={{ textDecoration: "none" }}>
										<IconButton title="LED Settings" onClick={(e) => {
											e.stopPropagation()
										}} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
											<EmojiObjectsIcon style={{ color: zone.led_id !== null ? "#18cc69" : "#d5d7d9" }} fontSize="small" />
										</IconButton>
									</Link>
								}
							</div>
						</div>
					))}
				</div>
			</Paper>
		</div>
	);
}

// const EditButtonWithDialog = (props) => {
// 	const { basePath, label, record, icon = defaultIcon, ...rest } = props;

// 	const [dialogVisible, setDialogVisible] = React.useState(false);

// 	const zoneIds = record.zone_ids ? record.zone_ids.split(",") : [];
// 	const zoneLabels = record.zones ? record.zones.split(";") : [];
// 	const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
// 		{ id, name: zoneLabels[index] }
// 	)) : null;
// 	finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

// 	const hideDialog = event => {
// 		event.stopPropagation();
// 		setDialogVisible(false);
// 	};

// 	if (zoneIds.length > 1) {
// 		return (
// 			<>
// 				<RaButton
// 					label={label}
// 					onClick={event => {
// 						event.preventDefault();
// 						setDialogVisible(true)
// 					}}
// 					{...rest}
// 				>
// 					{icon}
// 				</RaButton>

// 				<Portal>
// 					<Dialog
// 						onClose={event => {
// 							event.preventDefault();
// 							event.stopPropagation();
// 							hideDialog(event);
// 						}}
// 						open={dialogVisible}
// 					>
// 						<MuiList>
// 							{finalZones.map((zone, index) => (
// 								<ListItem button key={zone.id} component={Link} to={linkToRecord(basePath, zone.id)} onClick={hideDialog}>
// 									<ListItemText primary={zone.name} />
// 								</ListItem>
// 							))}
// 						</MuiList>
// 					</Dialog>
// 				</Portal>
// 			</>
// 		);
// 	} else {
// 		return <EditButton {...props} />;
// 	}
// };

/*const exporter = parkings => {
	const parkingsForExport = parkings.map(parking => {
		const { crm_user_id, features, id, ...parkingForExport } = parking; // omit backlinks and author
		//parkingForExport.author_name = parking.author.name; // add a field
		return parkingForExport;
	});
	jsonExport(parkingsForExport, {
		headers: ['access_key', 'name'] // order fields in the export
	}, (err, csv) => {
		downloadCSV(csv, 'parkings'); // download as 'parkings.csv` file
	});
};*/

const validateParkingCreation = (values) => {
	const errors = {};
	if (!values.template_id) {
		errors.name = 'Please select the parking template';
	}
	if (!values.name) {
		errors.name = 'Name is required';
	}
	if(values.name && values.similar_parking_name){
		errors.name = 'Similar parking name found';
	}
	if (!values.access_key) {
		errors.access_key = 'Access Key is required';
	}
	if(values.access_key && values.similar_access_key){
		errors.access_key = 'Similar access key found';
	}
	if (!values.parking_info_id) {
		if (!values.parking_group_name) {
			errors.parking_group_name = 'Parking Group Name is required';
		}
		if(values.parking_group_name && values.similar_parking_group){
			errors.parking_group_name = 'Similar parking group name found';
		}
		if (!values.parking_address) {
			errors.parking_address = 'Parking Address is required';
		}
		if (!values.city) {
			errors.city = 'City is required';
		}

		// if (!values.longitude) {
		// 	errors.longitude = 'Longitude is required';
		// }
		// if (!values.latitude) {
		// 	errors.latitude = 'Latitude is required';
		// }
	}
	if (values.rfid_readers != null || values.rfid_readers !== "") {
		if (typeof values.rfid_readers === "string" && values.rfid_readers.search(/^\d*$/g) === -1) {
			errors.rfid_readers = 'Invalid Number of Rfid Readers';
		}
	}
	if (values.boom_barriers != null || values.boom_barriers !== "") {
		if (typeof values.boom_barriers === "string" && values.boom_barriers.search(/^\d*$/g) === -1) {
			errors.boom_barriers = 'Invalid Number of Boom Barriers';
		}
	}

	if (!values.client_id) {
		if (!values.owner_name && !values.client_name) {
			errors.owner_name = 'Either owner or client name';
			errors.client_name = 'Either owner or client name';
		}

		if (!values.owner_mobile && !values.client_mobile) {
			errors.owner_mobile = 'Either owner or client mobile is required';
			errors.client_mobile = 'Either owner or client mobile is required';
		}

		if (values.owner_mobile) {
			const mobileRegex = /^[0-9]{1,10}$/;
			if (!mobileRegex.test(values.owner_mobile)) errors.owner_mobile = "Valid Owner mobile no. require"
			if(values.owner_mobile.length !== 10) errors.owner_mobile = "Valid Owner mobile no. require"
		}
		if (values.client_mobile) {
			const mobileRegex = /^[0-9]{1,10}$/;
			if (!mobileRegex.test(values.client_mobile)) errors.values.client_mobile = "Valid Client mobile no. require"
			if(values.client_mobile.length !== 10) errors.client_mobile = "Valid Client mobile no. require"
		}
		if (values.client_email) {
			const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
			if (!emailRegex.test(values.client_email)) errors.client_email = "Valid Email require"
		}
		
	}
	console.log(errors)
	return errors
};

// const validateAccessKey = regex(/^[A-Z0-9]{3,10}$/, 'Must be all caps with only letters and numbers');

//const omitFields = ({ id, ...rest }) => rest;

let parkingTypes = [
	{ id: 'Private', name: 'Default' },
	{ id: 'Society', name: 'Society' },
	{ id: 'Government', name: 'Government' },
	{ id: 'Commercial', name: 'Commercial' },
	{ id: 'Hybrid', name: 'Hybrid' },
]

const CreateCustomToolbar = ({ buttonText, step, setStep, disabled = false, invalid, ...props }) => {
	const { input: { value: create_group } } = useInput({ ...props, id: "create_group", source: "create_group" });
	const { input: { value: create_client } } = useInput({ ...props, id: "create_client", source: "create_client" });
	const { input: { value: parking_info_id } } = useInput({ ...props, id: "parking_info_id", source: "parking_info_id" });
	const { input: { value: parking_type } } = useInput({ ...props, id: "parking_type", source: "parking_type" });
	const { input: { value: parking_group_name } } = useInput({ ...props, id: "parking_group_name", source: "parking_group_name" });
	const { input: { value: parking_address } } = useInput({ ...props, id: "parking_address", source: "parking_address" });
	// const { input: { value: longitude } } = useInput({ ...props, id: "longitude", source: "longitude" });
	// const { input: { value: latitude } } = useInput({ ...props, id: "latitude", source: "latitude" });
	const { input: { value: city } } = useInput({ ...props, id: "city", source: "city" });

	const { input: { value: name } } = useInput({ ...props, id: "name", source: "name" });
	const { input: { value: access_key, onChange: setAccessKey } } = useInput({ ...props, id: "access_key", source: "access_key" });

	const { input: { value: owner_name } } = useInput({ ...props, id: "owner_name", source: "owner_name" });
	const { input: { value: owner_mobile } } = useInput({ ...props, id: "owner_mobile", source: "owner_mobile" });
	const { input: { value: client_name } } = useInput({ ...props, id: "client_name", source: "client_name" });
	const { input: { value: client_mobile } } = useInput({ ...props, id: "client_mobile", source: "client_mobile" });
	const { input: { value: client_id } } = useInput({ ...props, id: "client_id", source: "client_id" });
	// const { input: { value: billing_name } } = useInput({ ...props, id: "billing_name", source: "billing_name" });
	const { input: { value: client_email } } = useInput({ ...props, id: "client_email", source: "client_email" });
	// const { input: { value: gstin } } = useInput({ ...props, id: "gstin", source: "gstin" });
	const { input: { value: template_id } } = useInput({ ...props, id: "template_id", source: "template_id" });

	const stepValidationHandler = () => {
		if(step === 1 && parking_info_id) setStep(3)
		if(step === 1 && create_group) setStep(2)
		if(step === 2) {
			if(!parking_type) return notify("Parking type require", "warning")
			if(!parking_group_name) return notify("Parking group name require", "warning")
			// if(!latitude) return notify("Latitude require", "warning")
			// if(!longitude) return notify("Longitude require", "warning")
			if(!parking_address) return notify("Parking address require", "warning")
			if(!city) return notify("City require", "warning")
			setStep(3)
		}

		if(step === 0) {
			if(!name) return notify("Parking name require", "warning")
			if(!access_key) return notify("Access key require", "warning")
			if(!template_id) return notify("Please select the parking template", "warning")
			setAccessKey(access_key.toUpperCase())
			setStep(1)
		}

		if(step === 3 && create_client) {
			setStep(4)
		}

		if(step === 4){
			if(!owner_name && !client_name) return notify("Either owner or client name require")
			if(!owner_mobile && !client_mobile) return notify("Either owner or client mobile no. require")
			if(owner_mobile){
				const mobileRegex = /^[0-9]{1,10}$/;
				if(!mobileRegex.test(owner_mobile)) return notify("Valid Owner mobile no. require")
			}
			if(client_mobile){
				const mobileRegex = /^[0-9]{1,10}$/;
				if(!mobileRegex.test(client_mobile)) return notify("Valid Client mobile no. require")
			}
			if (client_email) {
				const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
				if (!emailRegex.test(client_email)) return notify("Valid Email require")
			}
		}
	};

	const nextButtonDisableHandler = () =>{
		if ((client_id && step === 3) || step === 4) return true
		if (step === 1 && !create_group && !parking_info_id) return true
		if (step === 3 && !client_id && !create_client) return true
		if (step === 2) {
			if (!parking_type) return true
			if (!parking_group_name) return true
			// if (!latitude) return true
			// if (!longitude) return true
			if (!parking_address) return true
			if (!city) return true
		}

		if (step === 0) {
			if (!name) return true
			if (!access_key) return true
			if(!template_id) return true
		}

		if (step === 4) {
			if (!owner_name && !client_name) return true
			if (!owner_mobile && !client_mobile) return true
			if (owner_mobile) {
				const mobileRegex = /^[0-9]{1,10}$/;
				if (!mobileRegex.test(owner_mobile)) return true
			}
			if (client_mobile) {
				const mobileRegex = /^[0-9]{1,10}$/;
				if (!mobileRegex.test(client_mobile)) return true
			}
			if (client_email) {
				const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
				if (!emailRegex.test(client_email)) return true
			}
		}
	}

	return <Toolbar {...props} >
		<Button variant="contained" color="primary" onClick={() => {
			if (step === 3 && !create_group) setStep(1)
			else if (step !== 0) setStep(step - 1)
		}}
			disableElevation disabled={step === 0} style={{ marginTop: 15, marginBottom: 25, marginRight: 30 }}>Previous</Button>
		{((client_id && step === 3) || step === 4) ? 
			<SaveButton disableElevation style={{ marginTop: 15 }} disabled={invalid} />
		:
			<Button variant="contained" color="primary" onClick={stepValidationHandler} disableElevation style={{ marginTop: 15, marginBottom: 25, marginRight: 30 }} disabled={nextButtonDisableHandler()}>{buttonText}</Button>
		}
	</Toolbar>
}

const CreateOrExistingParkingGroup = (props) => {
	const { input: { value: createGroup, onChange: setCreateGroup } } = useInput({ ...props, id: "create_group", source: "create_group" });

	const [clearParkingInfo, setClearParkingInfo] = React.useState(false)
	const [selectedParkingInfo, setSelectedParkingInfo] = useState(null);

	const handleParkingInfoChange = (newValue) => {
		setSelectedParkingInfo(newValue);
		setCreateGroup(0)
	}

	const createGroupHandler = (event) =>{
		setCreateGroup(event.target.checked === true ? 1 : 0)
		if (event.target.checked === true) setClearParkingInfo(!clearParkingInfo)
	}


	React.useEffect(() => {
		setCreateGroup(0)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	return <div>
		<div className="formLabel-bold" style={{ marginTop: 20 }}>Please select one, then move on to the next step.</div>
		<div style={{ marginTop: 30, marginBottom: 30 }}>
		<ParkingInfoSelector source="parking_info_id" resourceParam="parking_name" resourcePath="parkingInfo" label="Select Parking Group" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} clearParkingInfo={clearParkingInfo} onChange={handleParkingInfoChange} value={selectedParkingInfo} />
		<Typography style={{ fontSize: 28, marginTop: 20, color: "#BDBDBD" }}>OR</Typography>
		<div style={{ marginTop: 20 }}>
			<FormControlLabel control={<Checkbox checked={createGroup === 1 ? true : false} />} label="Create New Parking Group" onChange={(e) => createGroupHandler(e)} />
		</div>
		</div>
	</div>
}

const CreateClientOrExitingClient = (props) => {
	const { input: { value: createClient, onChange: setCreateClient } } = useInput({ ...props, id: "create_client", source: "create_client" });
	const { input: { onChange: setClientId } } = useInput({ ...props, id: "client_id", source: "client_id" });

	const [clearClientInfo, setClearClientInfo] = React.useState(false)

	const handleClientInfoChange = (newValue) => {
		setCreateClient(0)
	}
	const createClientHandler = (event) => {
		setCreateClient(event.target.checked === true ? 1 : 0)
		if (event.target.checked === true) {
			setClearClientInfo(!clearClientInfo)
			setClientId(null)
		}
	}

	React.useEffect(() => {
		setCreateClient(0)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	return <div>
		<div className="formLabel-bold" style={{ marginTop: 20 }}>Please select one, then move on to the next step.</div>
		<div style={{ marginTop: 30, marginBottom: 30 }}>
			<RaAutocompleteInput source="client_id" resourceParam="owner_name" resourcePath="clientsInfo" label="Client Name" getOptionValue={option => option["id"]} getOptionLabel={option => {
				handleClientInfoChange(`${option["owner_name"]}`)
				return `${option["owner_name"]}`
			}} useAccessKeyId={false} clearClientInfo={clearClientInfo} style={{ maxWidth: 340, position: "relative", margin: "7px 0 25px" }} />
			<Typography style={{ fontSize: 28, marginBottom: 10, marginTop: 10, color: "#BDBDBD" }}>OR</Typography>
			<div>
				<FormControlLabel control={<Checkbox checked={createClient === 1 ? true : false} />} label="Create New Client" onChange={event => createClientHandler(event)} />
			</div>
		</div>
	</div>
}

const CreateParkingGroupInfo = (props) => {
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
	const { input: { onChange: setLatitude } } = useInput({ ...props, id: "latitude", source: "latitude" });
	const { input: { onChange: setLongitude } } = useInput({ ...props, id: "longitude", source: "longitude" });
	const { input: { onChange: setSimilarParkingGroup } } = useInput({ ...props, id: "similar_parking_group", source: "similar_parking_group" });
	const [parkingType, setParkingType] = useState("")

	const latHandler = (value) => {
		const isValidInput = /^[0-9.]*$/.test(value);
		if (isValidInput) setLatitude(value);
		else setLatitude(value ? value.slice(0, -1) : "")
	}

	const longHandler = (value) => {
		const isValidInput = /^[0-9.]*$/.test(value);
		if (isValidInput) setLongitude(value)
		else setLongitude(value ? value.slice(0, -1) : "")
	}

	const onBlurHandler = async (type, value, callback) => {
		const res = await findSimilarParking(type, value)
		if(res.success) callback(true)
		else callback(false)
	}

	return <>
		<div className="formLabel-bold" style={{ marginTop: 20 }}>Parking Group Information</div>
		<div style={{ marginTop: 30, marginBottom: 30 }}>
			<SelectInput variant='outlined' label="Parking Type" source="parking_type" choices={parkingTypes} defaultValue={parkingTypes[0].id} value={parkingType} onChange={event => setParkingType(event.target.value)} />
			<div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 250px))", gap: "1rem", width: "80%", marginTop: isSmallDevice ? 10 : 0 }}>
				<TextInput variant='outlined' source="parking_group_name" onBlur={(e) => onBlurHandler('SIMILAR_PARKING_GROUP', e.target.value, setSimilarParkingGroup)} />
				<TextInput variant='outlined' source="sub_type" />
				<TextInput variant='outlined' source="latitude" validate={latHandler} />
				<TextInput variant='outlined' source="longitude" validate={longHandler} />
				<TextInput variant='outlined' source="parking_address" />
				<TextInput variant='outlined' source="city" />
			</div>
		</div>
	</>
}

const CreateClientInfo = (props) => {

	const { input: { onChange: setOwnerMobile } } = useInput({ ...props, id: "owner_mobile", source: "owner_mobile" });
	const { input: { onChange: setClientMobile } } = useInput({ ...props, id: "client_mobile", source: "client_mobile" });

	const validateOwnerMobile = (value) => {
		const isValidInput = /^[0-9]*$/.test(value);
		if (value && value.length > 10) setOwnerMobile(value.slice(0, -1))

		if (isValidInput) setOwnerMobile(value);
		else setOwnerMobile(value ? value.slice(0, -1) : "")
	}

	const validateClientMobile = (value) => {
		const isValidInput = /^[0-9]*$/.test(value);
		if (value && value.length > 10) setClientMobile(value.slice(0, -1))

		if (isValidInput) setClientMobile(value)
		else setClientMobile(value ? value.slice(0, -1) : "")
	}

	return <>
		<div className="formLabel-bold" style={{ marginTop: 20 }}>Client Information</div>
		<div className="grid-250" style={{ marginTop: 30, marginBottom: 30 }}>
			<TextInput source="owner_name" variant="outlined" />
			<TextInput source="owner_mobile" variant="outlined" validate={validateOwnerMobile} />
			<TextInput source="client_name" variant="outlined" />
			<TextInput source="client_mobile" variant="outlined" validate={validateClientMobile} />
			<TextInput source="client_email" variant="outlined" />
			<TextInput source="billing_name" variant="outlined" />
			<TextInput source="gstin" variant="outlined" />
		</div>
	</>
}

const NameAndAccessKeyInput = (props) => {
	const { input: { value: similarParkingName, onChange: setSimilarParkingName } } = useInput({ ...props, id: "similar_parking_name", source: "similar_parking_name" });
	const { input: { value: similarAccessKey, onChange: setSimilarAccessKey } } = useInput({ ...props, id: "similar_access_key", source: "similar_access_key" });
	const { input: { value: accessKey, onChange: setAccessKey } } = useInput({ ...props, id: "access_key", source: "access_key" });
	const { input: { value: name, onChange: setName } } = useInput({ ...props, id: "name", source: "name" });

	const inputHandler = async (type, value) => {
		if(type === 'SIMILAR_ACCESS_KEY'){
			const isValidInput = /^[A-Z0-9]*$/.test(value.toUpperCase());
			if (isValidInput) setAccessKey(value.toUpperCase())
			else {
				setAccessKey(value ? value.slice(0, -1) : "")
				return
			}
		}
		if(type === 'SIMILAR_PARKING_NAME') setName(value)
	}

	const onBlurHandler = async (type, value, callback) => {
		const res = await findSimilarParking(type, value)
		if(res.success) callback(true)
		else callback(false)
	}

	return <>
		<MuiTextField variant='outlined' error={similarParkingName} helperText={similarParkingName ? "Similar parking name found" : ""} size='small' label="Name" value={name} onChange={(e) => inputHandler("SIMILAR_PARKING_NAME", e.target.value)} onBlur={(e) => onBlurHandler("SIMILAR_PARKING_NAME", e.target.value, setSimilarParkingName)} />
		<MuiTextField variant='outlined' error={similarAccessKey} helperText={similarAccessKey ? "Similar access key found" : ""} size='small' label="AccessKey" value={accessKey} onChange={(e) => inputHandler("SIMILAR_ACCESS_KEY", e.target.value)} onBlur={(e) => onBlurHandler("SIMILAR_ACCESS_KEY", e.target.value, setSimilarAccessKey)}/>
	</>
}

const DashboardTemplate = () => {
	return <div>
			<DashboardTemplateSelector source="template_id" resourceParam="name" resourcePath="dashboardTemplates" filter={{onlyExcludeCategory: ['Society']}} style={{ maxWidth: 340, position: "relative" }} />
		</div>
}

const findSimilarParking = async (type, value) => {
	let params = { filter: JSON.stringify({ validator_type: type, value }) }
	try {
		const res = await fetch(`${config.HOST_NAME}/crm/v3/findSimilarParking?${stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
		})
	 return await res.json()
	 
	} catch (error) {
		console.log(error)
		notify('Error fetching data', 'warning');
	}
}

export const ParkingCreate = (props) => {
	const classes = useStyles();
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
	const eventTracker = UseAnalyticsEvent()
	const [data, setData] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [parkingToCopy, setParkingToCopy] = React.useState("");
	const [filterParking, setFilterParking] = React.useState("");
	const [jsonFieldsVisible, setJsonFieldsVisible] = React.useState(true);
	const [step, setStep] = React.useState(0);
	const [copiedParkingDetails, setCopiedParkingDetails] = React.useState(null)
	const fetchParkingTimeout = useRef(null);

	const redirect = useRedirect();
	const onSuccess = () => {
		notify("Element Created", "success")
		redirect(props.basePath)
	}
	const onFailure = (error) => {
		notify(error.message, "warning")
	}

	const fetchParkings = () => {
		setLoading(true);
		var params = {
			user_id: sessionStorage.getItem("user_id"),
			filter: JSON.stringify({ zones: true, name: filterParking }),
		}
		fetch(`${config.HOST_NAME}/crm/v3/parkings?${stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
		}).then(response => {
			saveTokens(response)
			return response.json();
		}).then((responseJson) => {
			if (responseJson.success) {
				setData(responseJson.data);
				setLoading(false);
			} else {
				notify(responseJson.message, 'warning');
			}
		})
			.catch((e) => {
				notify('Error fetching Parkings', 'warning')
			});
	}

	const handleParkingChange = (event, value) => {
		setParkingToCopy(value);
	}

	const handleParkingFilterChange = (event, value) => {
		setFilterParking(value);
	}

	const copyParking = () => {
		var params = { access_key_id: parkingToCopy.id };
		fetch(`${config.HOST_NAME}/crm/v3/duplicateParking?${stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
		}).then(response => {
			saveTokens(response)
			return response.json();
		}).then((responseJson) => {
			if (responseJson.success) {
				const parking = responseJson.data;
				delete parking.access_key
				delete parking.id
				delete parking.name
				delete parking.parking_address
				delete parking.city
				delete parking.latitude
				delete parking.longitude
				delete parking.client_id
				delete parking.parking_info_id
				setCopiedParkingDetails(parking)
				// let url = window.location.href;
				// let parkingStringified = JSON.stringify(omitFields(parking));
				// window.location.href = url.split("/create")[0] + "/create" + (parking ? `?source=${encodeURIComponent(parkingStringified)}` : "");
				// if (url !== window.location.href)
				// 	setJsonFieldsVisible(false);
			} else {
				notify(responseJson.message, 'warning');
			}
		})
			.catch((e) => {
				notify('Error fetching Parkings', 'warning')
			});
	}

	React.useEffect(() => {
		setJsonFieldsVisible(true);
		eventTracker("PARKING SECTION", "CREATE PARKING")
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.location.search])

	React.useEffect(() => {
        if (fetchParkingTimeout.current)
            clearTimeout(fetchParkingTimeout.current);
        fetchParkingTimeout.current = setTimeout(fetchParkings, 500);
    }, [filterParking, notify]);  // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Create {...props} onFailure={onFailure} onSuccess={onSuccess} title="Create Parking Access Key" >
				<SimpleForm redirect="list" initialValues={copiedParkingDetails ? {...copiedParkingDetails} : false} validate={validateParkingCreation} toolbar={<CreateCustomToolbar buttonText={"Next"} step={step} setStep={(val) => setStep(val)} />}>

					{step === 0 && <>
						<div className="formLabel-bold">Parking Information</div>
							<div style={{ marginBottom: 10 }}>
							<Paper className={classes.inlineForm}>
								<Autocomplete
									blurOnSelect
									disableClearable
									loading={loading}
									noOptionsText="No Parkings Found"
									onChange={handleParkingChange}
									onInputChange={handleParkingFilterChange}
									options={data}
									getOptionLabel={p => p.name}
									value={parkingToCopy}
									renderInput={params => <MuiTextField {...params} label="Select a parking" variant="outlined" />}
									required
								/>
								<Button
									variant="contained"
									color="primary"
									style={{ width: "8%", minWidth: 80, margin: "6px 0 6px 30px" }}
									onClick={copyParking}
								>
									Copy
								</Button>
							</Paper>
							<div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 250px))", gap: "1rem", width: "80%", marginTop: isSmallDevice ? 10 : 0 }}>
							<DashboardTemplate/>
							</div>
							<div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 250px))", gap: "1rem", width: "80%", marginTop: isSmallDevice ? 20 : 20 }}>
							<NameAndAccessKeyInput/>
							</div>
							<div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 250px))", gap: "1rem", width: "80%", marginTop: isSmallDevice ? 10 : 10 }}>
								<TextInput variant='outlined' source="rfid_readers" label="Number of Rfid Readers" />
								<TextInput variant='outlined' source="boom_barriers" label="Number of Boom Barriers" />
							</div>
							{jsonFieldsVisible && <FeaturesFormField copiedData={copiedParkingDetails ? copiedParkingDetails.features : false} copyOnly={"Everything"} source="features" />}
							</div>
						</>}
					{step === 1 && <CreateOrExistingParkingGroup/>}
					{step === 2 && <CreateParkingGroupInfo/>}
					{step === 3 && <CreateClientOrExitingClient/>}
					{step === 4 && <CreateClientInfo/>}
					
				</SimpleForm>
			</Create>
		</>
	)
};

export const ParkingShow = (props) => {
	const classes = useStyles();
	const [allZones, setAllZones] = React.useState(true);

	return (
		<Show {...props} title="Parking Vehicle Summary" actions={null} component={props => <Box {...props} style={{ width: "100%" }} />} classes={{ main: classes.removeMargin }}>
			<SimpleShowLayout>
				<VehicleSummaryField source="access_key" allZones={allZones} setAllZones={setAllZones} />
			</SimpleShowLayout>
		</Show>
	)
};

const SUMMARY_COLUMNS = {
	"Vehicle Number": true,
	"Type": true,
	"Vehicle Image": true,
	"Entry Time": true,
	"Exit Time": true,
	"Duration": true,
	"Total Amount": true,
	"Entry Amount": false,
	"Exit Amount": false,
	"Lost Ticket Charges": false,
	"Entry Payment Mode": true,
	"Exit Payment Mode": true,
	"Images": true,
	"Entry Image": true,
	"Exit Image": true,
	"NFC UID": false,
	"Serial Number": true,
	"Category": true,
	"Entry User": true,
	"Exit User": true,
	"Remarks": true,
	"Violation": true,
	// "Violation Factor": true,
	"Violation Image": true,
	"Day Pass": true,
	"Visit Reason": true,
	"Visit Destination": true,
};
const CATEGORIES = {
	PAID: "Paid",
	FOC: "FOC",
	IDF: "Drop Off",
	UNPAID: "Unpaid"
};
const createSortable = (order, orderBy) => (a, b) => {
	const summaryColumns = {
		"Vehicle Number": "license_number",
		"Type": "vehicle_type",
		"Entry Time": "entry_time",
		"Exit Time": "exit_time",
		"Total Amount": "total_amount",
		"Entry Amount": "amount_at_entry",
		"Exit Amount": "amount_at_exit",
		"Lost Ticket Charges": "lost_ticket_cost",
		"Exit Payment Mode": "mode_of_payment",
		"Entry Payment Mode": "mode_of_payment_at_entry",
		"Category": "category",
		"Entry User": "entry_user_id",
		"Exit User": "exit_user_id"
	};

	const priority1 = orderBy !== "Exit Time" ? summaryColumns[orderBy] : "exit_time";
	const priority2 = orderBy !== "Exit Time" ? "exit_time" : "entry_time";
	const higherValue = order === "asc" ? 1 : -1;
	const lowerValue = order === "asc" ? -1 : 1;
	if (a[priority1] && b[priority1]) {
		if (a[priority1] > b[priority1]) {
			return higherValue;
		}
		if (a[priority1] < b[priority1]) {
			return lowerValue;
		}
	}
	if (a[priority1]) {
		return higherValue;
	}
	if (b[priority1]) {
		return lowerValue;
	}
	if (a[priority2] > b[priority2]) {
		return higherValue;
	}
	if (a[priority2] < b[priority2]) {
		return lowerValue;
	}
	return 0;
};
function uniqueBy(a, key, condition) {
	let seen = {};
	for (let i in a) {
		const item = a[i];
		if (seen[key(item)] == null || condition(item))
			seen[key(item)] = item;
	}
	return Object.keys(seen).map(key => seen[key]);
}
const getTypeCount = type => type && type.count ? type.count : 0;
const VehicleSummaryField = ({ source, record = {}, allZones, setAllZones }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	//const notify = useNotify();
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
	const [loading, setLoading] = React.useState(false);
	const [dataLoaded, setDataLoaded] = React.useState(false);
	const [graphLoading, setGraphLoading] = React.useState(false);
	const [graphListToggle, setGraphListToggle] = React.useState(true)

	const [data, setData] = React.useState(null);
	const [allVehicles, setAllVehicles] = React.useState(null);
	// const [prevAllVehicles, setPrevAllVehicles] = React.useState([])
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(25);
	const [order, setOrder] = React.useState('desc');
	const [orderBy, setOrderBy] = React.useState('Exit Time');

	const parkings = useSelector(state => state.parkings);
	const currentParking = !parkings.loading ? parkings.data.find(parking => parking.general_name === record.general_name) : record;
	const finalZones = currentParking.zones_obj ? JSON.parse(currentParking.zones_obj) : []
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

	const defaultCategoryFilter = sessionStorage.getItem("filter_category");

	const [devicesLoading, setDevicesLoading] = React.useState(false);
	const [devices, setDevices] = React.useState([]);
	const [amountByDevice, setAmountByDevice] = React.useState({});
	const [serialNumberToFilter, setSerialNumberToFilter] = React.useState("All");
	const [categoryToFilter, setCategoryToFilter] = React.useState(defaultCategoryFilter);
	const [actionFilter, setActionFilter] = React.useState(null);
	const [showAvgAmount] = React.useState(sessionStorage.getItem("show_avg_summary_amount") === "1");
	const [showDayPassColumn, setShowDayPassColumn] = React.useState(false);
	// const [anchorEl, setAnchorEl] = React.useState(null);
	const [showSeparateEntryExitImages] = useState(sessionStorage.getItem("separate_entry_exit_images") === "1");
	const [displayColumns, setDisplayColumns] = React.useState(localStorage.getItem("summaryColumns") ? JSON.parse(localStorage.getItem("summaryColumns")) : SUMMARY_COLUMNS);

	const [showTimeTillSeconds] = React.useState(sessionStorage.getItem("show_time_till_seconds") === "1");
	const [use24HourFormat] = React.useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [separateSummaryOfDevices] = React.useState(sessionStorage.getItem("separate_summary_of_devices") === "1");
	const [freeVehicleConfirmation, setFreeVehicleConfirmation] = React.useState(null);
	const [allowCurrentVehiclesUpdate] = React.useState(sessionStorage.getItem("allow_current_vehicles_update") === "1");
	const [paymentTypeSummary, setPaymentTypeSummary] = React.useState(null);
	const [selected, setSelected] = React.useState([]);
	const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
	const [vehicleTypesCount, setVehicleTypesCount] = React.useState(Object.keys(vehicleSvgs).filter(type => (!record.features || (record.features.vehicle_type[type] && record.features.vehicle_type[type].visible))).length);
	const [filterListValue, setFilterListValue] = useState(null)
	const [showPaidUnpaidAmount] = React.useState(sessionStorage.getItem("show_paid_unpaid_amount") === "1");
	const [showFastagPayment] = useState(sessionStorage.getItem("show_fastag_payment") === "1");
	const [unpaidAmount, setUnpaidAmount] = useState({});
	const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
	const [searchType, setSearchType] = useState("license_number");
	const [makeExitFree] = useState(sessionStorage.getItem("make_exit_free") === "1")
	const [isSurveillanceExit, setIsSurveillanceExit] = useState(false)
	//const [settingFilterFormat, setSettingFilterFormat] = useState({})
	//const [minDateValue] = useState(sessionStorage.getItem("data_period_allowed"));

	// const [vehicleDialogVisible, setVehicleDialogVisible] = React.useState(false);

	// let dataList = [{ name: "PAID", id: 1 }, { name: "DROP OFF", id: 2 }, { name: "FOC", id: 3 }, { name: "UNPAID", id: 4 }]
	// let dataListForCategoryFilter = dataList.filter((list) => list.name === categoryToFilter)
	let filterTypesInitState = [
		{
			filterType: "Actions",
			dataList: [{ name: "ENTERED", id: 1 }, { name: "EXITED", id: 2 }, { name: "NOT EXITED", id: 3 }],
			listType: "Static",
			caseType: "Static",
			showFilter: true
		},
		{
			filterType: "Category",
			dataList: [{ name: "PAID", id: 1 }, { name: "DROP OFF", id: 2 }, { name: "FOC", id: 3 }, { name: "UNPAID", id: 4 }, { name: "DIGITAL PAYMENTS", id: 5 }],
			listType: "Static",
			caseType: "Static",
			showFilter: currentParking && currentParking.category_filter === 1 && (defaultCategoryFilter == null || defaultCategoryFilter === "" || defaultCategoryFilter === "null"),
		},
		{
			filterType: "Display Columns",
			dataList: { "Parking Name": false, "RFID": false },
			listType: "CheckboxStatic",
			caseType: "CheckboxTypeStatic",
			showFilter: true,
			filterFormat: "Checkbox"
		},
	]

	React.useEffect(() => {
		if (record.features)
			setVehicleTypesCount(Object.keys(vehicleSvgs).filter(type => record.features.vehicle_type[type] && record.features.vehicle_type[type].visible).length);
	}, [record, setVehicleTypesCount]);

	const licenseNumber = useSelector(state => state.searchText);
	React.useEffect(() => setPage(0), [licenseNumber]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const accessKey = get(record, source);

	const [startDateTime, setStartDateTime] = React.useState(null);
	const [endDateTime, setEndDateTime] = React.useState(null);
	const [startDateTimeFilter, setStartDateTimeFilter] = React.useState(null);
	const [endDateTimeFilter, setEndDateTimeFilter] = React.useState(null);

	const [excel, setExcel] = React.useState(null);

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
		return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY ${use24HourFormat ? `HH:mm${secondsFormat}` : `hh:mm${secondsFormat} a`}`);
	};

	const fetchSummary = (graphVehicleType, type = "json") => {
		let userId = sessionStorage.getItem("user_id");
		if (!userId) {
			return;
		}

		const isJson = type === "json";
		if (isJson) {
			if (graphVehicleType) {
				setGraphLoading(true);
			} else {
				setLoading(true);
				setPage(0);
			}
			dispatch(fetchStart());
		}
		var params = {
			start_time: startDateTime ? moment(startDateTime).format('YYYY-MM-DD HH:mm:ss') : null,
			end_time: endDateTime ? moment(endDateTime).format('YYYY-MM-DD HH:mm:ss') : null,
			access_key: accessKey,
			zone_id: allZones ? record.zone_id : null,
			vehicle_type: graphVehicleType && graphVehicleType !== "All" ? JSON.stringify([graphVehicleType]) : null,
			device_serial_number: serialNumberToFilter !== "All" ? serialNumberToFilter : null,
			category: categoryToFilter !== "All" ? categoryToFilter : "All",
			action: actionFilter ? actionFilter : '',
			user_id: sessionStorage.getItem("user_id"),
			vehicle_number: !isJson && licenseNumber && licenseNumber !== "" ? licenseNumber : undefined,
		}

		fetch(`${config.HOST_NAME}/crm/v3/parkingSummary?${stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
				'Accept': `application/${type}`
			},
		})
			.then(response => {
				saveTokens(response)
				if (isJson)
					return response.json()
				else
					return response.blob()
			})
			.then(responseJson => {
				if (!isJson) {
					const url = URL.createObjectURL(responseJson);
					const tempLinkElement = document.createElement('a');
					tempLinkElement.href = url;

					const timeFormat = "Do MMM YYYY (h:mm A)";
					let startTime = startDateTime;
					if (startTime)
						startTime = moment(startTime).format(timeFormat);
					else
						startTime = moment().startOf("day").format(timeFormat);
					let endTime = endDateTime;
					if (endTime)
						endTime = moment(endTime).format(timeFormat);
					else
						endTime = moment().endOf("day").format(timeFormat);

					tempLinkElement.setAttribute('download', `${startTime} - ${endTime} - Collection Report - ${record.general_name}.${type}`);
					tempLinkElement.click();
				} else if (!responseJson.success) {
					notify(responseJson.message, 'warning')
				} else {
					setData(responseJson.data);
					let unpaidAmount = 0
					let unpaidAmountGraphData = []
					let vehiclesList = responseJson.data.all_vehicles
					for (let veh in vehiclesList) {
						if (vehiclesList[veh].unpaid === 1) {
							unpaidAmountGraphData.push({ x: moment(vehiclesList[veh].last_updated_at).format("Do MMM ha"), y: vehiclesList[veh].total_amount })
							unpaidAmount += vehiclesList[veh].total_amount
						}
					}
					setUnpaidAmount({ unpaidAmount: unpaidAmount, graphData: unpaidAmountGraphData })
					if (!graphVehicleType) {
						let tempVehicles = responseJson.data.all_vehicles;
						tempVehicles = tempVehicles.map(row => {
							let category = null;
							if (row.free_vehicle === true || row.free_vehicle === 1 || row.free_vehicle === "true")
								category = CATEGORIES.FOC;
							if (row.unpaid === true || row.unpaid === 1 || row.unpaid === "1" || row.unpaid === "true")
								category = CATEGORIES.UNPAID;
							else if (row.exit_time && row.exit_user_id !== "CLEARED") {
								if (!((row.amount_at_entry && parseFloat(row.amount_at_entry) > 0) || (row.amount_at_exit && parseFloat(row.amount_at_exit) > 0)))
									category = CATEGORIES.IDF;
								else
									category = CATEGORIES.PAID;
							}
							return {
								...row,
								category
							};
						});
						tempVehicles.sort(createSortable(order, orderBy));
						setAllVehicles(tempVehicles);
						// setPrevAllVehicles(tempVehicles)


						if (record.show_violation_details === 1 || record.show_payment_type_summary === 1) {
							const tempPaymentTypeSummary = {
								"FREE": { count: 0, types: {}, graphData: [] },
								"CASH": { count: 0, amount: 0, types: {}, graphData: [] },
								"CARD": { count: 0, amount: 0, types: {}, graphData: [] },
								"UPI": { count: 0, amount: 0, types: {}, graphData: [] },
								"WALLET": { count: 0, amount: 0, types: {}, graphData: [] },
								"FASTag": { count: 0, amount: 0, types: {}, graphData: [] },
							};

							for (let type in responseJson.data.entered_vehicle_types) {
								tempPaymentTypeSummary["FREE"].types[type] = { ...responseJson.data.entered_vehicle_types[type], count: 0 };
								tempPaymentTypeSummary["CASH"].types[type] = { ...responseJson.data.entered_vehicle_types[type], count: 0, amount: 0 };
								tempPaymentTypeSummary["CARD"].types[type] = { ...responseJson.data.entered_vehicle_types[type], count: 0, amount: 0 };
								tempPaymentTypeSummary["UPI"].types[type] = { ...responseJson.data.entered_vehicle_types[type], count: 0, amount: 0 };
								tempPaymentTypeSummary["WALLET"].types[type] = { ...responseJson.data.entered_vehicle_types[type], count: 0, amount: 0 };
								tempPaymentTypeSummary["FASTag"].types[type] = { ...responseJson.data.entered_vehicle_types[type], count: 0, amount: 0 };
							}

							for (let record of responseJson.data.all_entered_vehicles) {
								if (record["free_vehicle"] === true || record["free_vehicle"] === 1 || record["free_vehicle"] === "true") {
									tempPaymentTypeSummary["FREE"].count += 1;
									if (tempPaymentTypeSummary["FREE"].types[record["vehicle_type"]] && tempPaymentTypeSummary["FREE"].types[record["vehicle_type"]].count != null) {
										tempPaymentTypeSummary["FREE"].types[record["vehicle_type"]].count += 1;
									} else {
										tempPaymentTypeSummary["FREE"].types[record["vehicle_type"]] = { ...tempPaymentTypeSummary["FREE"].types[record["vehicle_type"]], count: 1 };
									}
								} else if (tempPaymentTypeSummary[record["mode_of_payment_at_entry"]]) {
									const amountAtEntry = (record["amount_at_entry"] && record["amount_at_entry"] !== "" ? parseFloat(record["amount_at_entry"]) : 0);
									const entryCount = amountAtEntry > 0 ? 1 : 0;
									if (amountAtEntry > 0) {
										tempPaymentTypeSummary[record["mode_of_payment_at_entry"]].graphData.push(amountAtEntry)
									}
									tempPaymentTypeSummary[record["mode_of_payment_at_entry"]].count += entryCount;
									tempPaymentTypeSummary[record["mode_of_payment_at_entry"]].amount += amountAtEntry;


									if (tempPaymentTypeSummary[record["mode_of_payment_at_entry"]].types[record["vehicle_type"]] && tempPaymentTypeSummary[record["mode_of_payment_at_entry"]].types[record["vehicle_type"]].count != null && tempPaymentTypeSummary[record["mode_of_payment_at_entry"]].types[record["vehicle_type"]].amount != null) {
										tempPaymentTypeSummary[record["mode_of_payment_at_entry"]].types[record["vehicle_type"]].count += entryCount;
										tempPaymentTypeSummary[record["mode_of_payment_at_entry"]].types[record["vehicle_type"]].amount += amountAtEntry;
									} else {
										tempPaymentTypeSummary[record["mode_of_payment_at_entry"]].types[record["vehicle_type"]] = { ...tempPaymentTypeSummary[record["mode_of_payment_at_entry"]].types[record["vehicle_type"]], count: entryCount, amount: amountAtEntry };
									}
								}
							}
							for (let record of responseJson.data.all_exited_vehicles) {
								if (record["free_vehicle"] === true || record["free_vehicle"] === 1 || record["free_vehicle"] === "true") {
									tempPaymentTypeSummary["FREE"].count += 1;
									if (tempPaymentTypeSummary["FREE"].types[record["vehicle_type"]] && tempPaymentTypeSummary["FREE"].types[record["vehicle_type"]].count != null) {
										tempPaymentTypeSummary["FREE"].types[record["vehicle_type"]].count += 1;
									} else {
										tempPaymentTypeSummary["FREE"].types[record["vehicle_type"]] = { ...tempPaymentTypeSummary["FREE"].types[record["vehicle_type"]], count: 1 };
									}
								} else if (tempPaymentTypeSummary[record["mode_of_payment"]]) {
									const amountAtExit = (record["amount_at_exit"] && record["amount_at_exit"] !== "" ? parseFloat(record["amount_at_exit"]) : 0);
									const exitCount = amountAtExit > 0 ? 1 : 0;
									if (amountAtExit > 0) {
										tempPaymentTypeSummary[record["mode_of_payment"]].graphData.push(amountAtExit)
									}
									tempPaymentTypeSummary[record["mode_of_payment"]].count += exitCount;
									tempPaymentTypeSummary[record["mode_of_payment"]].amount += amountAtExit;
									if (tempPaymentTypeSummary[record["mode_of_payment"]].types[record["vehicle_type"]] && tempPaymentTypeSummary[record["mode_of_payment"]].types[record["vehicle_type"]].count != null && tempPaymentTypeSummary[record["mode_of_payment"]].types[record["vehicle_type"]].amount != null) {
										tempPaymentTypeSummary[record["mode_of_payment"]].types[record["vehicle_type"]].count += exitCount;
										tempPaymentTypeSummary[record["mode_of_payment"]].types[record["vehicle_type"]].amount += amountAtExit;
									} else {
										tempPaymentTypeSummary[record["mode_of_payment"]].types[record["vehicle_type"]] = { ...tempPaymentTypeSummary[record["mode_of_payment"]].types[record["vehicle_type"]], count: exitCount, amount: amountAtExit };
									}
								}
							}
							setPaymentTypeSummary(tempPaymentTypeSummary);
							//console.log(tempPaymentTypeSummary);
						}

						setDataLoaded(true);
						if (!startDateTime) {
							setStartDateTime(responseJson.start_time);
							setStartDateTimeFilter(responseJson.start_time);
						} else {
							setStartDateTimeFilter(startDateTime);
						}
						if (!endDateTime) {
							setEndDateTime(responseJson.end_time);
							setEndDateTimeFilter(responseJson.end_time);;
						} else {
							setEndDateTimeFilter(endDateTime);
						}
					}
				}
			})
			.catch((e) => {
				console.log(e);
				notify('Error fetching Summary', 'warning')
			})
			.finally(() => {
				if (graphVehicleType)
					setGraphLoading(false);
				else
					setLoading(false);
				dispatch(fetchEnd());
			});
	};

	const getExcelFile = () => {
		fetchSummary(false, "xlsx");
	};

	const getPDF = () => {
		fetchSummary(false, "pdf");
	};

	const getGraphData = event => {
		fetchSummary(event.target.value);
	};

	const handleDeviceChange = (event) => {
		setSerialNumberToFilter(event.target.value);
	};

	// const handleCategoryChange = (event) => {
	// 	setCategoryToFilter(event.target.value);
	// };

	const fetchParkingDevices = () => {

		let token = sessionStorage.getItem('token')
		if (token) {
			setDevicesLoading(true);
			var params = {
				user_id: sessionStorage.getItem("user_id"),
				filter: JSON.stringify({ access_key: record.id, parking_info_id: allZones ? record.zone_id : null, status: false }),
				sort: JSON.stringify(["unique_user_id", "ASC"]),
				perPage: 100
			}
			fetch(`${config.HOST_NAME}/crm/v3/operator/devices?${stringify(params)}`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
					'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
				},
			})
				.then(response => {
					saveTokens(response)
					return response.json()
				})
				.then((responseJson) => {
					setDevicesLoading(false);
					if (responseJson.success) {
						setDevices(uniqueBy(responseJson.data, device => device["serial_number"], option => typeof option["unique_user_id"] === "string" && option["unique_user_id"] !== ""));
					} else {
						notify(responseJson.message, 'warning');
					}
				})
				.catch((e) => {
					setDevicesLoading(false);
					notify('Error fetching Devices', 'warning');
				});
		}
	};

	// const handleClose = () => {
	// 	setAnchorEl(null);
	// };

	// const toggleColumnVisibility = column => {
	// 	setDisplayColumns(dc => {
	// 		const temp = { ...dc };
	// 		temp[column] = !temp[column];
	// 		return temp;
	// 	});
	// };

	const handleRequestSort = (property) => {
		const isAsc = orderBy === property && order === 'asc';
		let tempOrder = isAsc ? 'desc' : 'asc';
		setOrder(tempOrder);
		setOrderBy(property);

		const tempVehicles = allVehicles;
		tempVehicles.sort(createSortable(tempOrder, property));
		setAllVehicles(tempVehicles);
	};

	const onFreeVehicleToggle = (id, checked, remarks, exit_user_id, license_number, entry_time, mode_of_payment_at_entry, amount_at_entry, exit_time, mode_of_payment) => {
		setFreeVehicleConfirmation({ id, free: checked, remarks: remarks, exit_user_id: exit_user_id, license_number: license_number, entry_time: entry_time, mode_of_payment_at_entry: mode_of_payment_at_entry, amount_at_entry: amount_at_entry, exit_time:exit_time, mode_of_payment: mode_of_payment });
	};

	const hideFreeVehicleConfirmation = event => {
		event.stopPropagation();
		setFreeVehicleConfirmation(null);
	};

	const toggleFreeVehicle = event => {
		event.stopPropagation();
		if (typeof freeVehicleConfirmation.remarks !== "string" || !new RegExp("[A-z]+").test(freeVehicleConfirmation.remarks)) {
			return notify("Please add remarks", "warning");
		}
		if(makeExitFree && freeVehicleConfirmation.exit_time !== '' && freeVehicleConfirmation.exit_time !== null && freeVehicleConfirmation.mode_of_payment && freeVehicleConfirmation.mode_of_payment !== 'CASH'){
			return notify(`FOC not allowed for Vehicle with ${freeVehicleConfirmation.mode_of_payment}`, "warning");
		}
		setFreeVehicleConfirmation({ ...freeVehicleConfirmation, loading: true });
		var params = {
			user_id: sessionStorage.getItem("user_id"),
			free_vehicle: freeVehicleConfirmation.free,
			remarks: freeVehicleConfirmation.remarks,
			exit_user_id: freeVehicleConfirmation.exit_user_id,
			access_key: currentParking.access_key,
			entry_time: freeVehicleConfirmation.entry_time,
			license_number: freeVehicleConfirmation.license_number,
			mode_of_payment_at_entry: freeVehicleConfirmation.mode_of_payment_at_entry,
			amount_at_entry: freeVehicleConfirmation.amount_at_entry,
			exit_time: freeVehicleConfirmation.exit_time,
			make_paid_amount: !freeVehicleConfirmation.free ? freeVehicleConfirmation.make_paid_amount : 0,
			mode_of_payment: freeVehicleConfirmation.mode_of_payment ? freeVehicleConfirmation.mode_of_payment : ''
		}
		const url = makeExitFree && freeVehicleConfirmation.exit_user_id !== 'CLEARED' && freeVehicleConfirmation.exit_time && freeVehicleConfirmation.exit_time !== '' && freeVehicleConfirmation.exit_time != null  ? `${config.HOST_NAME}/crm/v3/pastVehicles/${freeVehicleConfirmation.id}/freeVehicle` : `${config.HOST_NAME}/crm/v3/currentVehicles/${freeVehicleConfirmation.id}/freeVehicle`
		fetch(url, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
			body: JSON.stringify(params)
		})
			.then(response => {
				saveTokens(response)
				return response.json()
			})
			.then(json => {
				setFreeVehicleConfirmation({ ...freeVehicleConfirmation, loading: false });
				if (json.success) {
					hideFreeVehicleConfirmation(event);
					fetchSummary();
					notify("Record Updated", "success");
				} else {
					notify(json.message, 'warning');
				}
			})
			.catch(error => {
				console.log(error);
				setFreeVehicleConfirmation({ ...freeVehicleConfirmation, loading: false });
				notify('Error updating record', 'warning');
			});
	};

	// const EnhancedTableToolbar = (props) => {
	// 	if (selected.length === 0)
	// 		return null;

	// 	const selectedRow = visibleRows.find(row => row.id === selected[0]);
	// 	const freeVehicle = selectedRow && (selectedRow.free_vehicle === true || selectedRow.free_vehicle === 1 || selectedRow.free_vehicle === "1" || selectedRow.free_vehicle === "true");

	// 	return (
	// 		<Toolbar style={{ position: "sticky", top: 75, left: 0, width: "100%", padding: "2px 0", borderRadius: "12px 12px 12px 12px", backgroundColor: "#58ffaa", boxShadow: "0px 0px 5px 2px rgba(0,0,0,0.15)", zIndex: 1 }}>
	// 			<div style={{ padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
	// 				<Typography sx={{ flex: '1 1 100%' }} color="inherit" variant="subtitle1" component="div">{selected.length} Selected</Typography>

	// 				<div>
	// 					<Button
	// 						variant="text"
	// 						startIcon={freeVehicle ? <AttachMoneyIcon /> : <MoneyOffIcon />}
	// 						disabled={selected.length !== 1 || selectedRow === undefined || (selectedRow.entry_user_id !== 'CLEARED' && selectedRow.exit_user_id !== 'CLEARED') || !allowCurrentVehiclesUpdate}
	// 						onClick={event => onFreeVehicleToggle(selectedRow.id, !freeVehicle, selectedRow.remarks, selectedRow.exit_user_id, selectedRow.license_number, selectedRow.entry_time)}
	// 					>
	// 						{freeVehicle ? "Make Paid" : "Make Free"}

	// 					</Button>
	// 				</div>
	// 			</div>
	// 		</Toolbar>
	// 	);
	// };

	const EnhancedTableToolbarForMob = (props) => {
		if (selected.length === 0)
			return null;

		const selectedRow = visibleRows.find(row => row.id === selected[0]);
		const freeVehicle = selectedRow && (selectedRow.free_vehicle === true || selectedRow.free_vehicle === 1 || selectedRow.free_vehicle === "1" || selectedRow.free_vehicle === "true");

		return (
			<Toolbar style={{ position: "sticky", top: 75, left: 0, width: "100%", padding: "2px 0", borderRadius: "12px 12px 12px 12px", backgroundColor: "#58ffaa", zIndex: 1 }}>
				<div style={{ padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
					<Typography sx={{ flex: '1 1 100%' }} color="inherit" variant="subtitle1" component="div">{selected.length} Selected</Typography>

					<div>
						<Button
							variant="text"
							startIcon={freeVehicle ? <AttachMoneyIcon /> : <MoneyOffIcon />}
							disabled={makeExitFree && selectedRow.exit_user_id !== "CLEARED" && selectedRow.exit_time ? false : selected.length !== 1 || selectedRow === undefined || (selectedRow.entry_user_id !== 'CLEARED' && selectedRow.exit_user_id !== 'CLEARED')}
							onClick={event => onFreeVehicleToggle(selectedRow.id, !freeVehicle, selectedRow.remarks, selectedRow.exit_user_id, selectedRow.license_number, selectedRow.entry_time, selectedRow.mode_of_payment_at_entry, selectedRow.amount_at_entry,selectedRow.exit_time, selectedRow.mode_of_payment)}
						>
							{freeVehicle ? "Make Paid" : "Make Free"}
						</Button>
					</div>
				</div>
			</Toolbar>
		);
	};

	const isSelected = (id) => selected.indexOf(id) !== -1;

	const handleRowSelect = (event, name) => {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1),
			);
		}
		setSelected(newSelected);
	};

	const VehicleMakeFreeOrPaid = ({ tableRow }) => {
		const selectedRow = visibleRows.find(row => row.id === tableRow.id);
		const freeVehicle = selectedRow && (selectedRow.free_vehicle === true || selectedRow.free_vehicle === 1 || selectedRow.free_vehicle === "1" || selectedRow.free_vehicle === "true");

		return (
			<Button
				variant="text"
				startIcon={freeVehicle ? <AttachMoneyIcon /> : <MoneyOffIcon />}
				disabled={makeExitFree && selectedRow.exit_user_id !== "CLEARED" && selectedRow.exit_time ? false : selectedRow === undefined || (selectedRow.entry_time && selectedRow.exit_time && selectedRow.exit_user_id !== "CLEARED")}
				onClick={event => onFreeVehicleToggle(selectedRow.id, !freeVehicle, selectedRow.remarks, selectedRow.exit_user_id, selectedRow.license_number, selectedRow.entry_time, selectedRow.mode_of_payment_at_entry, selectedRow.amount_at_entry, selectedRow.exit_time, selectedRow.mode_of_payment)}
			>
				{freeVehicle ? "Make Paid" : "Make Free"}

			</Button>
		);
	};

	// const handleSelectAllClick = (event) => {
	// 	if (event.target.checked) {
	// 		const newSelecteds = visibleRows.map((n) => n.id);
	// 		setSelected(newSelecteds);
	// 		return;
	// 	}
	// 	setSelected([]);
	// };

	React.useEffect(() => {
		if (showSeparateEntryExitImages) {
			delete SUMMARY_COLUMNS["Vehicle Image"];
			delete SUMMARY_COLUMNS["Images"];
		} else {
			delete SUMMARY_COLUMNS["Entry Image"];
			delete SUMMARY_COLUMNS["Exit Image"];
		}

		const displayColumnsKeys = Object.keys(displayColumns);
		const summaryColumnsKeys = Object.keys(SUMMARY_COLUMNS);
		let isOutdated = false;
		for (let i in displayColumnsKeys) {
			if (displayColumnsKeys[i] !== summaryColumnsKeys[i])
				isOutdated = true;
		}
		for (let i in summaryColumnsKeys) {
			if (displayColumnsKeys[i] !== summaryColumnsKeys[i])
				isOutdated = true;
		}
		if (isOutdated) {
			const temp = { ...SUMMARY_COLUMNS };
			for (let column in SUMMARY_COLUMNS) {
				if (displayColumns[column] === false)
					temp[column] = false;
			}
			setDisplayColumns(temp);
			localStorage.setItem("summaryColumns", JSON.stringify(temp));
		} else {
			localStorage.setItem("summaryColumns", JSON.stringify(displayColumns));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [displayColumns]);

	React.useEffect(() => {
		if (record.features) {
			setShowDayPassColumn(record.features.parking_cost.normal_daily_pricing.day_pass && record.features.parking_cost.normal_daily_pricing.day_pass.enabled);
		}
	}, [record]); // eslint-disable-line react-hooks/exhaustive-deps

	React.useEffect(() => {
		fetchSummary();
		fetchParkingDevices();
	}, [accessKey, allZones]); // eslint-disable-line react-hooks/exhaustive-deps

	React.useEffect(() => {
		fetchSummary();
	}, [serialNumberToFilter, categoryToFilter, actionFilter]); // eslint-disable-line react-hooks/exhaustive-deps

	React.useEffect(() => {
		if (data && data.entry_amount_by_device) {
			const amountByDevice = {};
			amountByDevice["All"] = 0;
			for (let i in devices) {
				let amount = (data.entry_amount_by_device[devices[i].serial_number] ? data.entry_amount_by_device[devices[i].serial_number].amount_at_entry : 0) + (data.exit_amount_by_device[devices[i].serial_number] ? data.exit_amount_by_device[devices[i].serial_number].amount_at_exit : 0);
				if (data.entry_amount_by_serial_number)
					amount += (data.entry_amount_by_serial_number[devices[i].serial_number] ? data.entry_amount_by_serial_number[devices[i].serial_number].amount_at_entry : 0) + (data.exit_amount_by_serial_number[devices[i].serial_number] ? data.exit_amount_by_serial_number[devices[i].serial_number].amount_at_exit : 0);
				if (devices[i].unique_user_id && devices[i].unique_user_id !== "") {
					amount += (data.entry_amount_by_device[devices[i].unique_user_id] ? data.entry_amount_by_device[devices[i].unique_user_id].amount_at_entry : 0) + (data.exit_amount_by_device[devices[i].unique_user_id] ? data.exit_amount_by_device[devices[i].unique_user_id].amount_at_exit : 0);
					if (data.entry_amount_by_serial_number)
						amount += (data.entry_amount_by_serial_number[devices[i].unique_user_id] ? data.entry_amount_by_serial_number[devices[i].unique_user_id].amount_at_entry : 0) + (data.exit_amount_by_serial_number[devices[i].unique_user_id] ? data.exit_amount_by_serial_number[devices[i].unique_user_id].amount_at_exit : 0);
				}
				amountByDevice[devices[i].serial_number] = `${amount}`;
				amountByDevice["All"] += amount;
			}
			setAmountByDevice(amountByDevice);
		}
	}, [data, devices]); // eslint-disable-line react-hooks/exhaustive-deps

	React.useEffect(() => {
		setExcel(null);
	}, [excel]);

	React.useEffect(() => {
		//console.log("filterListValue", filterListValue)
		if (settingFilterFormat.actions) {
			setActionFilter(settingFilterFormat.actions)

			// let vehiclesStoreList = [...prevAllVehicles]

			// let filterList = vehiclesStoreList.filter((vehicle) => {

			// 	if (settingFilterFormat.actions === "NOT EXITED" && vehicle.entry_time && vehicle.exit_user_id === "CLEARED" && vehicle.exit_time) {
			// 		return vehicle
			// 	}
			// 	if (settingFilterFormat.actions === "EXITED" && vehicle.entry_time && vehicle.exit_time && vehicle.exit_user_id !== "CLEARED") {
			// 		return vehicle
			// 	}
			// 	if (settingFilterFormat.actions === "ENTERED" && vehicle.entry_time && ((vehicle.exit_time == null || vehicle.exit_time === "") && (vehicle.exit_user_id !== "CLEARED" || vehicle.exit_user_id === ""))) {
			// 		return vehicle
			// 	}
			// 	return false
			// })
			// setAllVehicles(filterList)
		}
		// if (!settingFilterFormat.actions) {
		// 	setAllVehicles(prevAllVehicles)
		// }

		if (settingFilterFormat.category) {
			setCategoryToFilter(settingFilterFormat.category)
		}
		if (filterListValue != null && !settingFilterFormat.category) {
			setCategoryToFilter("All")
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterListValue]);

	const notExitedTypes = {};
	let totalNotExited = 0;
	if (dataLoaded) {
		const keys = Object.keys(data.entered_vehicle_types);
		for (let i = 0; i < keys.length; i++) {
			const key = keys[i];
			notExitedTypes[key] = { ...data.entered_vehicle_types[key] };
			notExitedTypes[key].count = ((data.entered_vehicle_types[key].count ? data.entered_vehicle_types[key].count : 0) - (data.exited_vehicle_types[key].count_current_period ? data.exited_vehicle_types[key].count_current_period : 0));
			if (!(notExitedTypes[key].count >= 0))
				notExitedTypes[key].count = 0;
			totalNotExited += notExitedTypes[key].count;
		};
	}

	let visibleRows = [];
	if (!loading && allVehicles)
		visibleRows = allVehicles.filter(vehicle => typeof licenseNumber !== "string" || licenseNumber.length === 0 || (typeof vehicle[searchType] === "string" && vehicle[searchType].includes(licenseNumber))).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

	let settingFilterFormat = {};
	// Add more types based on the filters
	for (let val in filterListValue) {
		if (filterListValue[val].filterType === "Actions") {
			settingFilterFormat = { ...settingFilterFormat, actions: filterListValue[val].value ? filterListValue[val].value : undefined }
		} else if (filterListValue[val].filterType === "Category") {
			settingFilterFormat = { ...settingFilterFormat, category: filterListValue[val].value ? filterListValue[val].value === "DROP OFF" ? "IDF" : filterListValue[val].value : undefined }
		}
	}

	return (
		<div>
			<div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0 }}>
				{showFilter &&
					<FormControl variant="outlined">
						<InputLabel>Parking Name</InputLabel>
						<Select
							value={record.general_name}
							label="Parking Name"
							variant="outlined"
							renderValue={(value) => <div className={classes.asyncSelector}><span>{value}</span>{parkings.loading && <CircularProgress size={20} />}</div>}
						>
							{!parkings.loading ?
								parkings.data.map(parking => (
									<MenuItem key={parking.id} value={parking.general_name} component={Link} to={parking.general_name !== record.general_name ? `/parkings/${parking.id}/show` : null}>{parking.general_name}</MenuItem>
								))
								:
								<MenuItem value={record.general_name}>{record.general_name}</MenuItem>
							}
						</Select>
					</FormControl>
				}

				{currentParking.zone_ids && currentParking.zone_ids.includes(',') && <FormControl variant="outlined">
					<InputLabel>Zone Name</InputLabel>
					<Select
						value={(!record.zone_id || allZones) ? "All" : record.name}
						label="Zone Name"
						variant="outlined"
						renderValue={(value) => <div className={classes.asyncSelector}><span>{value}</span>{(parkings.loading && record.zone_id) && <CircularProgress size={20} />}</div>}
						disabled={!record.zone_id}
						defaultValue="All"
					>
						<MenuItem value="All" onClick={() => setAllZones(true)}>All</MenuItem>
						{finalZones && finalZones.map((zone, index) => (
							<MenuItem key={index} value={zone.name} onClick={() => setAllZones(false)} component={Link} to={`/parkings/${zone.id}/show`}>{zone.name}</MenuItem>
						))}
					</Select>
				</FormControl>
				}
			</div>

			<div className='customStyleForDataSearchDiv'>
				<CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} onChange={fetchSummary} />
				<SearchBar searchType={searchType} setSearchType={setSearchType} customStyle={{ flexGrow: 1, flexShrink: 0, borderRadius: 10, height: 45 }} />
			</div>
			{/* {currentParking && currentParking.category_filter === 1 && <div style={{ display: isSmallDevice ? "block" : "flex", alignItems: "center", marginTop: 24, marginBottom: 5 }}>
				<Typography>Category</Typography>
				<Select
					variant="outlined"
					onChange={handleCategoryChange}
					value={categoryToFilter}
					style={{ marginLeft: isSmallDevice ? 0 : 22, minWidth: 200, marginTop: isSmallDevice ? 6 : 0 }}
					classes={{ root: classes.smallSelectRoot }}
				>
					<MenuItem value="All">All</MenuItem>
					{Object.keys(CATEGORIES).map(category => (
						<MenuItem key={category} value={category}>{CATEGORIES[category]}</MenuItem>
					))}
				</Select>
			</div>} */}
			{dataLoaded && <>
				<div className='parkingTitleContainer'>
					<ParkingSummaryCard
						title="Vehicle In"
						data={loading ? null : data}
						getValue={data => data.entered_vehicles_length}
						getTypes={data => data.entered_vehicle_types}
						getTypeValue={getTypeCount}
						vehicleTypesCount={vehicleTypesCount}
						showGraph={true}
					/>
					<ParkingSummaryCard
						title="Vehicle Out"
						data={loading ? null : data}
						getValue={data => data.exited_vehicles_length}
						valueDescription={`(${data.exited_vehicles_current_period} + ${data.exited_vehicles_previous_period})`}
						valueDescriptionInfo={`Indicates No. of Vehicles Exited which were entered in the current time period + No. of Vehicles Exited which were entered before the current time period`}
						getTypes={data => data.exited_vehicle_types}
						getTypeValue={getTypeCount}
						getTypeValueDescription={type => type ? `(${type.count_current_period ? type.count_current_period : 0} + ${type.count_previous_period ? type.count_previous_period : 0})` : ""}
						subTypes={record.show_category_distribution ? CATEGORIES : undefined}
						getSubTypeValue={getTypeCount}
						vehicleTypesCount={vehicleTypesCount}
						showGraph={true}
					/>
					{record.show_foc_summary !== 1 && record.show_amount_in_crm === 1 && !showPaidUnpaidAmount && <ParkingSummaryCard
						title="Amount"
						data={loading ? null : data}
						getValue={data => `₹ ${data.exited_vehicles_amount.toFixed(2)}`}
						valueDescription={`(${data.amount_current_period.toFixed(2)} + ${data.amount_previous_period.toFixed(2)})`}
						valueDescriptionInfo={`Indicates Collection from the vehicles which entered in the current time period + Collection from the vehicles which entered before the current time period`}
						getTypes={data => data.exited_vehicle_types}
						getTypeValue={type => type.amount_at_exit ? `₹ ${type.amount_at_exit.toFixed(2)}` : 0.00}
						getTypeValueDescription={type => type ? `(${type.amount_current_period ? type.amount_current_period.toFixed(2) : 0} + ${type.amount_previous_period ? type.amount_previous_period.toFixed(2) : 0})` : ""}
						vehicleTypesCount={vehicleTypesCount}
						label2={showAvgAmount ? "Average (per vehicle)" : undefined}
						getValue2={showAvgAmount ? type => (type.amount_at_exit ? type.amount_at_exit : 0) / (type.count > 0 ? type.count : 1) : undefined}
					/>}
					{record.show_foc_summary !== 1 && record.show_amount_in_crm === 1 && showPaidUnpaidAmount && <ParkingSummaryCard
						title="Paid Amount"
						data={loading ? null : data}
						getValue={(data) => {
							let paidAmount = data.exited_vehicles_amount - unpaidAmount.unpaidAmount
							return `₹ ${paidAmount}`
						}}
						getTypes={data => data.exited_vehicle_types}
						getTypeValue={type => type.amount_at_exit ? `₹ ${type.amount_at_exit}` : 0.00}
						vehicleTypesCount={vehicleTypesCount}
						label2={showAvgAmount ? "Average (per vehicle)" : undefined}
						showGraph={true}

					/>}
					{record.show_foc_summary !== 1 && record.show_amount_in_crm === 1 && showPaidUnpaidAmount && <ParkingSummaryCard
						title="Unpaid Amount"
						data={loading ? null : { ...data, graphData: unpaidAmount.graphData }}
						getValue={data => `₹ ${unpaidAmount.unpaidAmount}`}
						getTypes={data => data.exited_vehicle_types}
						getTypeValue={type => type.UNPAID ? `₹ ${type.UNPAID.amount_at_exit}` : `₹ 0.00`}
						vehicleTypesCount={vehicleTypesCount}
						label2={showAvgAmount ? "Average (per vehicle)" : undefined}
						showGraph={true}
					/>}
					{record.show_foc_summary === 1 && paymentTypeSummary && <ParkingSummaryCard
						title="Free Vehicles"
						data={loading ? null : paymentTypeSummary["FREE"]}
						getValue={data => data.count}
						getTypes={data => data.types}
						getTypeValue={type => type.count >= 0 ? type.count : 0}
						vehicleTypesCount={vehicleTypesCount}
					/>}
				</div>

				<div className='parkingTitleContainer'>
					{/* {record.show_not_exited_in_crm === 1 && <ParkingSummaryCard
						title="Not Exited"
						data={loading ? null : { ...data }}
						getValue={data => data.notexited_vehicles_length}
						getTypes={data => data.notexited_vehicles_types}
						getTypeValue={type => type.count >= 0 ? type.count : 0}
						vehicleTypesCount={vehicleTypesCount}
						showGraph={false}
					/>} */}
					{record.show_not_exited_in_crm === 1 && <ParkingSummaryCard
						title="Not Exited"
						data={loading ? null : { ...data, graphData: [0, totalNotExited] }}
						getValue={data => totalNotExited}
						getTypes={data => notExitedTypes}
						getTypeValue={type => type.count >= 0 ? type.count : 0}
						vehicleTypesCount={vehicleTypesCount}
						showGraph={false}
					/>}
					{record.show_violation_details === 1 && <ParkingSummaryCard
						title="Violation"
						data={loading ? null : data}
						getValue={data => data.violation_vehicles_length}
						getTypes={data => data.violation_vehicles_types}
						getTypeValue={getTypeCount}
						vehicleTypesCount={vehicleTypesCount}
					/>}
					{record.show_foc_summary === 1 && record.show_amount_in_crm === 1 && <ParkingSummaryCard
						title="Amount"
						data={loading ? null : data}
						getValue={data => `₹ ${data.exited_vehicles_amount.toFixed(2)}`}
						getTypes={data => data.exited_vehicle_types}
						getTypeValue={type => type.amount_at_exit ? `₹ ${type.amount_at_exit.toFixed(2)}` : 0.00}
						vehicleTypesCount={vehicleTypesCount}
						label2={showAvgAmount ? "Average (per vehicle)" : undefined}
						getValue2={showAvgAmount ? type => (type.amount_at_exit ? type.amount_at_exit : 0) / (type.count > 0 ? type.count : 1) : undefined}
						showGraph={true}
					/>}
				</div>

				{record.show_payment_type_summary === 1 && paymentTypeSummary && <div className='parkingTitleContainer'>
					<ParkingSummaryCard
						title="CASH"
						data={loading ? null : paymentTypeSummary["CASH"]}
						getValue={data => data.count}
						getTypes={data => data.types}
						getTypeValue={getTypeCount}
						vehicleTypesCount={vehicleTypesCount}
						label2=""
						getAmount={type => type.amount ? `₹ ${type.amount}` : "₹ 0.00"}
						showGraph={true}
					/>
					<ParkingSummaryCard
						title="CARD"
						data={loading ? null : paymentTypeSummary["CARD"]}
						getValue={data => data.count}
						getTypes={data => data.types}
						getTypeValue={getTypeCount}
						vehicleTypesCount={vehicleTypesCount}
						label2=""
						getAmount={type => type.amount ? `₹ ${type.amount}` : "₹ 0.00"}
						showGraph={true}
					/>
					<ParkingSummaryCard
						title="UPI"
						data={loading ? null : paymentTypeSummary["UPI"]}
						getValue={data => data.count}
						getTypes={data => data.types}
						getTypeValue={getTypeCount}
						vehicleTypesCount={vehicleTypesCount}
						label2=""
						getAmount={type => type.amount ? `₹ ${type.amount}` : "₹ 0.00"}
						showGraph={true}
					/>
					<ParkingSummaryCard
						title={showFastagPayment ? "FASTag" : "WALLET"}
						data={loading ? null : paymentTypeSummary[showFastagPayment ? "FASTag" : "WALLET"]}
						getValue={data => data.count}
						getTypes={data => data.types}
						getTypeValue={getTypeCount}
						vehicleTypesCount={vehicleTypesCount}
						label2=""
						getAmount={type => type.amount ? `₹ ${type.amount}` : "₹ 0.00"}
						showGraph={true}
					/>
				</div>}
			</>}

			{currentParking && (currentParking.separate_summary_of_devices === 1 || separateSummaryOfDevices) && <div>
				<div style={{ marginTop: isSmallDevice ? 24 : 15, marginBottom: 10 }}>
					<Typography>Devices</Typography>
					<Select
						variant="outlined"
						renderValue={value => <div className={classes.asyncSelector}><span>{value}</span>{devicesLoading && <CircularProgress size={16} />}</div>}
						onChange={handleDeviceChange}
						value={serialNumberToFilter}
						style={{ minWidth: isSmallDevice ? 200 : 350, marginTop: isSmallDevice ? 6 : 0 }}
						classes={{ root: classes.smallSelectRoot }}
					>
						<MenuItem value="All"><span style={{ flex: 1 }}>All</span>  <span style={{ margin: "0 17px" }}>{amountByDevice["All"] != null && `₹ ${amountByDevice["All"]}`}</span></MenuItem>
						{devices.map((device, index) => (
							<MenuItem key={index} value={device.serial_number}><span style={{ flex: 1 }}>{device.unique_user_id && device.unique_user_id !== "" ? device.unique_user_id : device.serial_number}</span> <span style={{ margin: "0 17px" }}>{amountByDevice[device.serial_number] != null && amountByDevice[device.serial_number]}</span></MenuItem>
						))}
					</Select>
				</div>

				<div className='parkingTitleContainer'>
					{devices.map((device, index) => (
						// <Typography className={classes.searchParams} key={index} value={device.serial_number}>{device.unique_user_id && device.unique_user_id !== "" ? device.unique_user_id : device.serial_number}: {amountByDevice[device.serial_number] != null && amountByDevice[device.serial_number]}</Typography>
						<Paper style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0px 10px 0px 10px", flexWrap: 'wrap' }}>
							<div>
								<p style={{ lineHeight: "6px", fontSize: 10 }}>Device Name</p>
								<p style={{ lineHeight: "3px", fontSize: 12, fontWeight: "bold" }}>{device.unique_user_id && device.unique_user_id !== "" ? device.unique_user_id : device.serial_number}</p>
							</div>
							<p style={{ lineHeight: "3px", fontSize: 12, fontWeight: "bold", color: amountByDevice[device.serial_number] > 0 ? "#18cc69" : "#de575e" }}>₹ {amountByDevice[device.serial_number] != null && amountByDevice[device.serial_number]}</p>
						</Paper>
					))}
				</div>
			</div>}

			{loading ? <Loading /> : dataLoaded && <div className={classes.summaryListRoot}>
				<div className={classes.listActions} style={{ display: isSmallDevice ? "block" : "flex" }}>
					<div style={{ flex: 1 }}>
						<Typography className={classes.searchParamsTitle}>Showing Results for</Typography>
						{!!licenseNumber && licenseNumber !== "" && <Typography className={classes.searchParams}>License number: {licenseNumber}</Typography>}
						<Typography className={classes.searchParams}>Time Period: {moment(startDateTimeFilter).format("MMM Do, YYYY hh:mm a")} — {moment(endDateTimeFilter).format("MMM Do, YYYY hh:mm a")}</Typography>
					</div>
					<div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", marginTop: 8, flexWrap: !isSmallDevice ? "wrap" : "nowrap" }}>
						{isSmallDevice && <FormControl variant="outlined" style={{ flex: 1, marginRight: 10 }}>
							<InputLabel>Sort By</InputLabel>
							<Select
								value={orderBy}
								label="Sort By"
								variant="outlined"
								renderValue={(value) => (<div style={{ display: "flex", alignItems: "center", color: "#333" }}>
									<span style={{ marginRight: 5 }}>{value}</span>{order === "asc" ? <ArrowUpwardIcon style={{ fontSize: 18 }} /> : <ArrowDownwardIcon style={{ fontSize: 18 }} />}
								</div>)}
								classes={{ root: classes.smallSelectRoot }}
							>
								{["Entry Time", "Exit Time"].map((column, index) => (
									<MenuItem key={index} value={column} onClick={() => handleRequestSort(column)}>
										<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
											<span style={{ marginRight: 5 }}>{column}</span>{orderBy === column ? (order !== "asc" ? <ArrowUpwardIcon style={{ fontSize: 18 }} /> : <ArrowDownwardIcon style={{ fontSize: 18 }} />) : <ArrowUpwardIcon style={{ fontSize: 18 }} />}
										</div>
									</MenuItem>
								))}
							</Select>
						</FormControl>}


						<CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} defaultColumns={SUMMARY_COLUMNS} storageKey="summaryColumns" displayColumns={displayColumns} setDisplayColumns={setDisplayColumns} />
						{/* <RaButton variant='outlined' className='customStyleBtn' label="Display Columns" onClick={event => setAnchorEl(event.currentTarget)} style={{ alignSelf: "flex-end", marginRight: 10 }}><FilterListIcon /></RaButton>
						<Popover
							anchorEl={anchorEl}
							keepMounted
							open={Boolean(anchorEl)}
							onClose={handleClose}
						>
							{Object.keys(displayColumns)
								.map(column => (
									(record.show_amount_in_crm === 1 || !["Total Amount", "Entry Amount", "Exit Amount", "Lost Ticket Charges", "Exit Payment Mode", "Entry Payment Mode"].includes(column)) &&
									(record.show_violation_details === 1 || !["Violation", "Violation Image"].includes(column)) &&
									(showDayPassColumn || !["Day Pass"].includes(column)) &&
									(record.show_anpr_images === 1 || !["Images"].includes(column)) &&
									(!isSmallDevice || !["Vehicle Number", "Type", "Entry Time", "Exit Time"].includes(column)) &&
									<ListItem key={column} dense button onClick={() => toggleColumnVisibility(column)}>
										<ListItemIcon>
											<Checkbox
												edge="start"
												checked={displayColumns[column]}
												tabIndex={-1}
												disableRipple
											/>
										</ListItemIcon>
										<ListItemText primary={column} />
									</ListItem>
								))}
						</Popover> */}
						<div style={{ backgroundColor: "#F5F8FA", border: "1px solid #c2cfe0", display: "flex", justifyContent: "center", alignItems: "center", height: "24px", borderRadius: 5, marginRight: 10 }}>
							<div onClick={() => setGraphListToggle(true)} style={{ backgroundColor: graphListToggle === true ? "#334d6e" : "inherit", color: graphListToggle === true ? "#FFF" : "#c2cfe0", width: "50px", display: "flex", justifyContent: "center", alignItems: "center", height: "inherit", borderRadius: "inherit" }}>
								<DehazeIcon />
							</div>
							<div onClick={() => setGraphListToggle(false)} style={{ backgroundColor: graphListToggle === false ? "#334d6e" : "inherit", color: graphListToggle === false ? "#FFF" : "#c2cfe0", width: "50px", display: "flex", justifyContent: "center", alignItems: "center", height: "inherit", borderRadius: "inherit" }}>
								<AssessmentIcon />
							</div>
						</div>
						{sessionStorage.getItem("allow_download_parkings") === "1" && <CustomExportButton getCSV={getExcelFile} getPDF={getPDF} />}
					</div>
				</div>

				{sessionStorage.getItem('check_vehicle_exit') === "1" &&
					<div style={{ display: 'flex', justifyContent:'flex-start', alignItems:'center', marginTop: 10, marginBottom: 10 }}>
						<AntSwitch checked={isSurveillanceExit} onChange={(e) => {
							setIsSurveillanceExit(e.target.checked)
						}} />
						<Typography style={{ fontSize: 14, marginLeft: 10 }}>Check Surveillance Exit</Typography>
					</div>
				}

				{isSmallDevice ?
					<MuiList style={{ marginTop: 20 }}>
						{allowCurrentVehiclesUpdate && <EnhancedTableToolbarForMob />}
						{visibleRows.map((row, index) => {
							const isItemSelected = isSelected(row.id);
							return (<ListItem alignItems="flex-start" style={{ paddingLeft: 10, paddingRight: 10, borderBottom: "1px solid #18cc69" }}>
								<ListItemAvatar style={{ marginRight: 17, minWidth: 0 }}>
									<Avatar alt={data.entered_vehicle_types[row.vehicle_type].label} src={vehicleSvgs[row.vehicle_type]} style={{ width: 28, height: 28, overflow:"visible" }} />
								</ListItemAvatar>
								<ListItemText
									primary={hideVehicleNumber(row.license_number)}
									secondary={<div>
										<div><span style={{ color: "#5a5a5a" }}>Entry: </span>{renderTime(row.entry_time)}{displayColumns["Entry Amount"] && record.show_amount_in_crm === 1 && row.amount_at_entry ? ` — ₹ ${parseFloat(row.amount_at_entry)}` : ""}</div>
										{row.exit_time && row.exit_user_id !== "CLEARED" && <div><span style={{ color: "#5a5a5a" }}>Exit: </span> {renderTime(row.exit_time)}{displayColumns["Exit Amount"] && record.show_amount_in_crm === 1 && row.amount_at_exit ? ` — ₹ ${parseFloat(row.amount_at_exit)}` : ""}</div>}
										{displayColumns["Entry Payment Mode"] && record.show_amount_in_crm === 1 && <div><span style={{ color: "#5a5a5a" }}>Entry Payment Mode: </span> {(row.amount_at_entry > 0 || ["FASTag"].includes(row.mode_of_payment_at_entry)) ? row.mode_of_payment_at_entry : "-"}</div>}
										{displayColumns["Exit Payment Mode"] && record.show_amount_in_crm === 1 && <div><span style={{ color: "#5a5a5a" }}>Exit Payment Mode: </span> {((row.amount_at_exit > 0 && row.category === "Paid") || ["FASTag"].includes(row.mode_of_payment)) ? row.mode_of_payment : "-"}</div>}
										{displayColumns["NFC UID"] && row.nfc_uid && row.nfc_uid.trim() !== "" && <div><span style={{ color: "#5a5a5a" }}>NFC UID: </span>{row.nfc_uid}</div>}
										{displayColumns["Serial Number"] && row.serial_number && row.serial_number.trim() !== "" && <div><span style={{ color: "#5a5a5a" }}>Serial Number: </span>{row.serial_number}</div>}
										{displayColumns["Entry User"] && <div><span style={{ color: "#5a5a5a" }}>Entry User: </span>{row.entry_user_id}</div>}
										{displayColumns["Exit User"] && row.exit_user_id !== "CLEARED" && <div><span style={{ color: "#5a5a5a" }}>Exit User: </span>{row.exit_user_id}</div>}
										{displayColumns["Remarks"] && row.remarks && row.remarks.trim() !== "" && <div><span style={{ color: "#5a5a5a" }}>Remarks: </span>{row.remarks}</div>}
										{record.show_violation_details === 1 && displayColumns["Violation"] && row.violation && <div><span style={{ color: "#5a5a5a" }}>Violation: </span>{row.violation}</div>}
										{record.show_violation_details === 1 && displayColumns["Violation Image"] && row.violation_image && <div><span style={{ color: "#5a5a5a" }}>Violation Image: </span><ImageGalleryDialog record={row} getImages={record => [record.violation_image]} /></div>}
										{showDayPassColumn && displayColumns["Day Pass"] && <div><span style={{ color: "#5a5a5a" }}>Day Pass: </span>{row.day_pass === 1 ? "Yes" : "No"}</div>}
										{/* {displayColumns["Free Vehicle"] && row.entry_time && !row.exit_time && !allowCurrentVehiclesUpdate ? null : <>Free Vehicle: <Checkbox color="secondary" disabled={makeExitFree && row.exit_user_id !== 'CLEARED' && row.exit_time ? false : row.entry_user_id !== 'CLEARED' && row.exit_user_id !== 'CLEARED'} checked={row.free_vehicle === true || row.free_vehicle === 1 || row.free_vehicle === "true"} onChange={(event, checked) => onFreeVehicleToggle(row.id, checked, row.remarks)} /></>} */}
										{record.show_anpr_images === 1 && displayColumns["Images"] && <ImageGalleryDialog record={row} getImages={record => showSeparateEntryExitImages ? [record.vehicle_image_url] : [record.vehicle_entry_image_url, record.vehicle_exit_image_url, record.vehicle_image_url]} style={{ textAlign: "left" }} />}
										{record.show_anpr_images === 1 && showSeparateEntryExitImages && displayColumns["Entry Image"] && <ImageGalleryDialog record={row} getImages={record => [record.vehicle_entry_image_url]} />}
										{record.show_anpr_images === 1 && showSeparateEntryExitImages && displayColumns["Exit Image"] && <ImageGalleryDialog record={row} getImages={record => [record.vehicle_exit_image_url]} />}
										{displayColumns["Visit Reason"] && row.visit_reason && row.visit_reason.trim() !== "" && <div><span style={{ color: "#5a5a5a" }}>Visit Reason: </span>{row.visit_reason}</div>}
										{displayColumns["Visit Destination"] && row.visit_destination && row.visit_destination.trim() !== "" && <div><span style={{ color: "#5a5a5a" }}>Visit Destination: </span>{row.visit_destination}</div>}
										{displayColumns["Exit Time"] &&
												<div style={{display:'flex'}}><span style={{ color: "#5a5a5a" }}>Exit Time:  </span>
													{
														row.exit_time && row.exit_user_id !== "CLEARED" ? renderTime(row.exit_time)
															: sessionStorage.getItem('check_vehicle_exit') === "1" && isSurveillanceExit && row.entry_time && (!row.exit_time || row.exit_user_id === 'CLEARED') ? <CheckVehicleExited row={row} isSurveillanceExit={isSurveillanceExit} />
																: "-"
													}
												</div>
											}
										{!viewOnly && <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
										{!allowCurrentVehiclesUpdate ? null : <Checkbox color="primary" checked={isItemSelected} onClick={(event) => handleRowSelect(event, row.id)} />}
											{(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('role') === "sales") &&
												<VehicleEdit fetchSummary={() => fetchSummary()} licenseNumber={row.license_number} vehicleEntryTime={row.entry_time} vehicleExitTime={row.exit_time} vehicleId={row.id} accessKeyName={record.access_key} oldValues={row} />
											}
											{(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('role') === "sales") &&
												<VehicleDelete fetchSummary={() => fetchSummary()} licenseNumber={row.license_number} vehicleId={row.id} accessKeyName={row.access_key} oldValues={row} />}
										{sessionStorage.getItem('check_vehicle_exit') === "1" && isSurveillanceExit && row.entry_time && (!row.exit_time || row.exit_user_id === 'CLEARED') && <CheckVehicleExited row={row} isSurveillanceExit={isSurveillanceExit} />}
										</div>}
									</div>}
								/>
							</ListItem>)
						})}
						<TablePagination
							rowsPerPageOptions={[25]}
							count={allVehicles.filter(vehicle => typeof licenseNumber !== "string" || licenseNumber.length === 0 || (typeof vehicle[searchType] === "string" && vehicle[searchType].includes(licenseNumber))).length}
							rowsPerPage={rowsPerPage}
							page={page}
							onChangePage={handleChangePage}
							style={{ display: "flex", justifyContent: "flex-end", borderBottom: 0 }}
						/>
					</MuiList>
					:
					<>
						{
							graphListToggle &&
							<Paper style={{ width: "100%", mb: 2, boxShadow: "0px 4px 15px #0000001a", }}>
								{/* <EnhancedTableToolbar /> */}
								<TableContainer component={ScrollableTable} style={{ boxShadow: "none" }}>
									<Table size="small" style={{ padding: 0 }}>
										<TableHead style={{
											position: 'sticky',
											top: 0,
											zIndex: 2,
											backgroundColor: "#fff"
										}}>
												<TableRow>
													{Object.keys(displayColumns).map(column => (displayColumns[column] && (record.show_amount_in_crm === 1 || !["Total Amount", "Entry Amount", "Exit Amount", "Lost Ticket Charges", "Entry Payment Mode", "Exit Payment Mode"].includes(column)) && (record.show_anpr_images === 1 || !["Images"].includes(column)) && (showSeparateEntryExitImages || !["Entry Image", "Exit Image"].includes(column)) && (showDayPassColumn || !["Day Pass"].includes(column)) && (record.show_violation_details === 1 || !["Violation", "Violation Image"].includes(column)) &&
														(!["Vehicle Image", "Duration", "Images", "NFC UID", "Serial Number", "Remarks", "Day Pass", "Visit Reason", "Visit Destination"].includes(column) ?
															<StyledTableCell key={column} sortDirection={orderBy === column ? order : false}>
																<TableSortLabel
																	active={orderBy === column}
																	direction={orderBy === column ? order : 'asc'}
																	onClick={() => handleRequestSort(column)}
																>
																	{column}
																</TableSortLabel>
															</StyledTableCell>
															: showSeparateEntryExitImages && ['Entry Image', 'Exit Image'].includes(column) ?
																<StyledTableCell key={column}>{column}</StyledTableCell> : <StyledTableCell key={column}>{column}</StyledTableCell>
														)
													))}
												{/* {(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('role') === "sales") && <StyledTableCell >Edit</StyledTableCell>} */}

												{/* {(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('role') === "sales") && <StyledTableCell >Delete</StyledTableCell>} */}

											</TableRow>
										</TableHead>
										<TableBody className={!viewOnly ? 'vehicleSummaryFieldDataGrid' : ''}>
											{visibleRows.map((row, index) => {
												const isItemSelected = isSelected(row.id);
												return (
													<TableRow key={index} selected={isItemSelected}>
														{displayColumns["Vehicle Number"] && <StyledTableCell component="th" scope="row" className={classes.mainTableCell}>{hideVehicleNumber(row.license_number)}</StyledTableCell>}
														{displayColumns["Type"] && <StyledTableCell><img className={classes.listVehicleIcon} src={vehicleSvgs[row.vehicle_type]} alt={data.entered_vehicle_types[row.vehicle_type] ? data.entered_vehicle_types[row.vehicle_type].label : ""} title={data.entered_vehicle_types[row.vehicle_type] ? data.entered_vehicle_types[row.vehicle_type].label : ""} /></StyledTableCell>}
														{displayColumns["Vehicle Image"] && <StyledTableCell><ImageDialog record={row} source="vehicle_image_url" /></StyledTableCell>}
														{displayColumns["Entry Time"] && <StyledTableCell>{renderTime(row.entry_time)}</StyledTableCell>}
														{displayColumns["Exit Time"] &&
															<StyledTableCell>
																{
																	row.exit_time && row.exit_user_id !== "CLEARED" ? renderTime(row.exit_time)
																		: sessionStorage.getItem('check_vehicle_exit') === "1" && isSurveillanceExit && row.entry_time && (!row.exit_time || row.exit_user_id === 'CLEARED') ? <CheckVehicleExited row={row} isSurveillanceExit={isSurveillanceExit} />
																			: "-"
																}
															</StyledTableCell>
														}
														{displayColumns["Duration"] && <StyledTableCell>{row.exit_time && row.exit_user_id !== "CLEARED" ? moment(row.exit_time).to(row.entry_time, true) : "-"}</StyledTableCell>}
														{record.show_amount_in_crm === 1 && <>
															{displayColumns["Total Amount"] && <StyledTableCell>{row.total_amount != null ? `₹${parseFloat(parseFloat(row.total_amount))}` : (row.amount_at_entry ? `₹${parseFloat(parseFloat(row.amount_at_entry))}` : "-")}</StyledTableCell>}
															{displayColumns["Entry Amount"] && <StyledTableCell>{row.amount_at_entry ? `₹${parseFloat(parseFloat(row.amount_at_entry))}` : "-"}</StyledTableCell>}
															{displayColumns["Exit Amount"] && <StyledTableCell>{row.exit_time && row.exit_user_id !== "CLEARED" && row.amount_at_exit ? `₹${parseFloat(row.amount_at_exit)}` : "-"}</StyledTableCell>}
															{displayColumns["Lost Ticket Charges"] && <StyledTableCell>{[true, 1, "true", "1"].includes(row.lost_ticket) && row.lost_ticket_cost ? `₹${parseFloat(parseFloat(row.lost_ticket_cost))}` : "-"}</StyledTableCell>}
															{displayColumns["Entry Payment Mode"] && <StyledTableCell>
																{
																	(row.amount_at_entry > 0 || ["FASTag"].includes(row.mode_of_payment_at_entry)) ? <div
																		className={classes.chipCell}
																		style={paymentModeColors[row.mode_of_payment_at_entry] ? { color: paymentModeColors[row.mode_of_payment_at_entry], backgroundColor: (paymentModeColors[row.mode_of_payment_at_entry] + "19") } : { color: "#555555", backgroundColor: "#55555519" }}
																	>
																		{row.mode_of_payment_at_entry}
																	</div> : "-"
																}
															</StyledTableCell>}
															{displayColumns["Exit Payment Mode"] && <StyledTableCell>
																{
																	((row.amount_at_exit > 0 && row.category === "Paid") || ["FASTag"].includes(row.mode_of_payment)) ? <div
																		className={classes.chipCell}
																		style={paymentModeColors[row.mode_of_payment] ? { color: paymentModeColors[row.mode_of_payment], backgroundColor: (paymentModeColors[row.mode_of_payment] + "19") } : { color: "#555555", backgroundColor: "#55555519" }}
																	>
																		{row.mode_of_payment}
																	</div> : "-"
																}
															</StyledTableCell>}
														</>}
														{record.show_anpr_images === 1 && displayColumns["Images"] && <StyledTableCell><ImageGalleryDialog record={row} getImages={record => showSeparateEntryExitImages ? [record.vehicle_image_url] : [record.vehicle_entry_image_url, record.vehicle_exit_image_url, record.vehicle_image_url]} /></StyledTableCell>}
														{record.show_anpr_images === 1 && showSeparateEntryExitImages && displayColumns["Entry Image"] && <StyledTableCell><ImageGalleryDialog record={row} getImages={record => [record.vehicle_entry_image_url]} /></StyledTableCell>}
														{record.show_anpr_images === 1 && showSeparateEntryExitImages && displayColumns["Exit Image"] && <StyledTableCell><ImageGalleryDialog record={row} getImages={record => [record.vehicle_exit_image_url]} /></StyledTableCell>}
														{displayColumns["NFC UID"] && <StyledTableCell>{row.nfc_uid}</StyledTableCell>}
														{displayColumns["Serial Number"] && <StyledTableCell>{row.serial_number}</StyledTableCell>}
														{displayColumns["Category"] && <StyledTableCell style={{ textAlign: "center" }}>
															{row.category ? <div
																className={classes.chipCell}
																style={{ color: customTheme.palette.secondary.main, backgroundColor: customTheme.palette.secondary.main + "20" }}
															>
																{row.category}
															</div> : ""}
															{[true, 1, "true", "1"].includes(row.lost_ticket) ? <div style={{ marginTop: 4, fontSize: 13, color: "#777" }}>Lost Ticket</div> : null}
														</StyledTableCell>}
														{displayColumns["Entry User"] && <StyledTableCell style={{ textAlign: "center" }}><div style={{ color: "#727272" }}>{row.entry_user_id}</div>{row.entry_device_id && <div style={{ marginTop: 1 }}>{row.entry_device_id}</div>}</StyledTableCell>}
														{displayColumns["Exit User"] && <StyledTableCell style={{ textAlign: "center" }}>{row.exit_user_id !== "CLEARED" ? <><div style={{ color: "#727272" }}>{row.exit_user_id}</div>{row.exit_device_id && <div style={{ marginTop: 1 }}>{row.exit_device_id}</div>}</> : "-"}</StyledTableCell>}
														{displayColumns["Remarks"] && <StyledTableCell>{row.remarks}</StyledTableCell>}
														{record.show_violation_details === 1 && displayColumns["Violation"] && <StyledTableCell>{row.violation}</StyledTableCell>}
														{/* {record.show_violation_details === 1 && displayColumns["Violation Factor"] && <StyledTableCell>{row.violation_factor}</StyledTableCell>} */}
														{record.show_violation_details === 1 && displayColumns["Violation Image"] && <StyledTableCell><ImageGalleryDialog record={row} getImages={record => [record.violation_image]} /></StyledTableCell>}
														{showDayPassColumn && displayColumns["Day Pass"] && <StyledTableCell>{row.day_pass === 1 ? "Yes" : "No"}</StyledTableCell>}
														{displayColumns["Visit Reason"] && <StyledTableCell>{row.visit_reason}</StyledTableCell>}
														{displayColumns["Visit Destination"] && <StyledTableCell>{row.visit_destination}</StyledTableCell>}
														{!viewOnly && <StyledTableCell className='ListIconsContainerVehicleSummaryFieldData'>
															<div className="ListIcons" style={{padding : !allowCurrentVehiclesUpdate && (sessionStorage.getItem('role') !== "admin" || sessionStorage.getItem('role') !== "sales") ? 0 : '10px 15px'}}>
																{!allowCurrentVehiclesUpdate ? null : <VehicleMakeFreeOrPaid tableRow={row} />}
																{(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('role') === "sales") &&
																	<VehicleEdit fetchSummary={() => fetchSummary()} licenseNumber={row.license_number} vehicleEntryTime={row.entry_time} vehicleExitTime={row.exit_time} vehicleId={row.id} accessKeyName={record.access_key} oldValues={row} />
																}
																{(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('role') === "sales") && <VehicleDelete fetchSummary={() => fetchSummary()} licenseNumber={row.license_number} vehicleId={row.id} accessKeyName={row.access_key} oldValues={row} />}
															</div>
														</StyledTableCell>}

													</TableRow>
												);
											})}
										</TableBody>
									</Table>
								</TableContainer>
								<TablePagination
									rowsPerPageOptions={[25, 50, 100]}
									count={allVehicles.filter(vehicle => typeof licenseNumber !== "string" || licenseNumber.length === 0 || (typeof vehicle[searchType] === "string" && vehicle[searchType].includes(licenseNumber))).length}
									rowsPerPage={rowsPerPage}
									page={page}
									onChangePage={handleChangePage}
									onChangeRowsPerPage={handleChangeRowsPerPage}
								/>
							</Paper>
						}
					</>
				}
				{excel}

				{record.show_graph === 1 && graphListToggle === false && <div id="graphContainer" style={{ marginTop: 45 }}>
					<div style={{ display: "flex", alignItems: "center" }}>
						<FormControl variant="outlined" style={{ marginLeft: 10, marginRight: 20 }}>
							<InputLabel>Vehicle Type</InputLabel>
							<Select
								variant="outlined"
								classes={{ root: classes.selectWithIcon }}
								defaultValue="All"
								onChange={getGraphData}
								label="Vehicle Type"
								style={{ minWidth: 200 }}
							>
								<MenuItem value="All" style={{ display: "flex", justifyContent: "space-between" }}><div>All</div><img style={{ width: 19, height: 18 }} src={vehicleSvgs["All"]} alt="" /></MenuItem>
								{Object.keys(data.entered_vehicle_types).map(key => (
									<MenuItem key={key} value={key} style={{ display: "flex", justifyContent: "space-between", columnGap: 30 }}><div>{data.entered_vehicle_types[key].label}</div><img style={{ width: 19, height: 18 }} src={vehicleSvgs[key]} alt={data.entered_vehicle_types[key].label} /></MenuItem>
								))}
							</Select>
						</FormControl>

						{graphLoading && <CircularProgress size={26} />}
					</div>

					<div style={{ display: isSmallDevice ? "block" : "flex", justifyContent: "center", marginTop: 10, overflowX: "auto", overflowY: "hidden" }}>
						<LineChart width={isSmallDevice ? (window.innerWidth - 45) : (400 + (window.innerWidth - 350) / 6)} height={300} data={data.vehicleSummaryByPeriod} margin={{ top: 10, right: isSmallDevice ? 0 : 30, left: isSmallDevice ? -25 : 0, bottom: 0 }}>
							{data.hourly_period ?
								<XAxis dataKey="date" interval={0} tickFormatter={text => (text.length > 4 || (text === "12pm" && data.vehicleSummaryByPeriod.length <= 50) || (["6am", "6pm"].includes(text) && data.vehicleSummaryByPeriod.length <= 30) || (["2am", "2pm", "4am", "4pm", "8am", "8pm"].includes(text) && data.vehicleSummaryByPeriod.length <= 12) ? text : "")} tickSize={4} />
								:
								<XAxis dataKey="date" />
							}
							<YAxis domain={['auto', 'auto']} />
							<CartesianGrid strokeDasharray="2 5" />
							<Tooltip />
							<Legend verticalAlign="top" align="right" height={36} />
							<Line dataKey="Entered" stroke={GRAPH_COLORS["Entered"]} dot={false} />
							<Line dataKey="Exited" stroke={GRAPH_COLORS["Exited"]} dot={false} />
						</LineChart>

						<LineChart width={isSmallDevice ? (window.innerWidth - 45) : (400 + (window.innerWidth - 350) / 6)} height={300} data={data.vehicleSummaryByPeriod} margin={{ top: 10, right: isSmallDevice ? 0 : 30, left: isSmallDevice ? -25 : 0, bottom: 0 }}>
							{data.hourly_period ?
								<XAxis dataKey="date" interval={0} tickFormatter={text => (text.length > 4 || (text === "12pm" && data.vehicleSummaryByPeriod.length <= 50) || (["6am", "6pm"].includes(text) && data.vehicleSummaryByPeriod.length <= 30) || (["2am", "2pm", "4am", "4pm", "8am", "8pm"].includes(text) && data.vehicleSummaryByPeriod.length <= 12) ? text : "")} tickSize={4} />
								:
								<XAxis dataKey="date" />
							}
							<YAxis domain={['auto', 'auto']} />
							<CartesianGrid strokeDasharray="2 5" />
							<Tooltip />
							<Legend verticalAlign="top" align="right" height={36} />
							<Line dataKey="Amount" stroke={GRAPH_COLORS["Amount"]} dot={false} />
						</LineChart>
					</div>
				</div>}

				<Portal>
					<Dialog
						onClose={hideFreeVehicleConfirmation}
						open={freeVehicleConfirmation != null}
					>
						<DialogContent>
							<DialogContentText>
								Are you sure you want to mark it as <b>{freeVehicleConfirmation && freeVehicleConfirmation.free ? "Free" : "Paid"} Vehicle</b>?
							</DialogContentText>
							<MuiTextField
								autoFocus
								multiline
								rowsMax={3}
								margin="dense"
								variant="outlined"
								label="Remarks*"
								value={freeVehicleConfirmation && freeVehicleConfirmation.remarks ? freeVehicleConfirmation.remarks : ""}
								onChange={event => {
									setFreeVehicleConfirmation({ ...freeVehicleConfirmation, remarks: event.target.value });
								}}
							/>
							{makeExitFree && freeVehicleConfirmation && !freeVehicleConfirmation.free &&
								<MuiTextField
									autoFocus
									multiline
									rowsMax={3}
									margin="dense"
									variant="outlined"
									label="Amount*"
									value={freeVehicleConfirmation && freeVehicleConfirmation.make_paid_amount ? freeVehicleConfirmation.make_paid_amount : ""}
									onChange={event => {
										if (event.target.value && !isNaN(event.target.value)) {
											setFreeVehicleConfirmation({ ...freeVehicleConfirmation, make_paid_amount: event.target.value });
										}
									}}
									onKeyDown={(e) => {
										if (e.code === 'Space') e.preventDefault()
									}}
									style={{ marginLeft: 20 }}
								/>}
						</DialogContent>
						<DialogActions>
							<Button onClick={hideFreeVehicleConfirmation} color="default">Cancel</Button>
							<Button onClick={toggleFreeVehicle} color="primary">Make {freeVehicleConfirmation && freeVehicleConfirmation.free ? "Free" : "Paid"}{freeVehicleConfirmation && freeVehicleConfirmation.loading && <CircularProgress size={20} style={{ marginLeft: 5 }} />}</Button>
						</DialogActions>
					</Dialog>
				</Portal>
			</div>}
		</div>
	)
}

const toolbarStyles = {
	toolbar: {
		display: 'flex',
		justifyContent: 'space-between',
	},
};

const CustomToolbar = withStyles(toolbarStyles)(props => (
	<Toolbar {...props}>
		<SaveButton />
	</Toolbar>
));

const TabPanel = props => {
	const { children, value, index, ...other } = props;

	return (
		<div
			hidden={value !== index}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					{children}
				</Box>
			)}
		</div>
	);
};

const TimeInputField = props => {
	const [helperText, setHelperText] = React.useState(null);
	const { onChange, onBlur, ...rest } = props;

	const handleChange = (e) => {
		if (new RegExp("^[0-9]{2}:[0-9]{2}:[0-9]{2}$").test(e.target.value))
			setHelperText(null);
		else
			setHelperText("Input should be in the format hh:mm:ss");
		onChange(e);
	}

	const handleBlur = (e) => {
		setHelperText(null);
		onBlur(e);
	}

	return (
		<MuiTextField
			{...rest}
			error={helperText != null}
			helperText={helperText}
			onChange={handleChange}
			onBlur={helperText ? handleBlur : null}
			size='small'
		/>
	);
}

const HolidaysDateTimeInputField = props => {
	const [helperText, setHelperText] = React.useState(null);
	const { onChange, onBlur, ...rest } = props;

	const handleChange = (e) => {
		const sanitizedValue = e.target.value.replace(/[^0-9-]/g, '');
		const newEvent = {
			...e,
			target: {
				...e.target,
				value: sanitizedValue
			}
		};
		if (/^\d{4}-\d{2}-\d{2}$/.test(sanitizedValue)) {
			setHelperText(null);
		} else {
			setHelperText("Input should be in the format YYYY-MM-DD");
		}
		onChange(newEvent);
	};

	const handleBlur = (e) => {
		setHelperText(null);
		onBlur(e);
	};

	return (
		<MuiTextField
			{...rest}
			error={helperText != null}
			helperText={helperText}
			onChange={handleChange}
			onBlur={helperText ? handleBlur : onBlur}
		/>
	);
};


const CheckIconButton = props => {
	const { children, checked, onClick } = props;
	const classes = useStyles();

	return (
		<div onClick={onClick} style={{ backgroundColor: checked ? "#0000001a" : "transparent", borderRadius: 4, marginRight: 8 }}>
			<div className={classes.checkIconButton}>
				{children}
			</div>
		</div>
	);
};
const costModelKey = {
	"Normal Daily Pricing": "normal_daily_pricing",
	"Weekday Weekend Pricing": "weekday_pricing",
	"Day Night Pricing": "day_pricing"
};

const CustomPeriodicDialog = ({ open, handleClose, onAddCustomPeriod, customVehicleTypes }) => {
	const classes = useStyles();
	const [getIndex, setIndex] = useState(1);
	//const notify = useNotify();

	const addHandler = () => {
		if (getIndex === "0") {
			notify('Invalid Input', 'warning');
			return;
		}
		else if (!new RegExp("^[0-9]*$").test(getIndex)) {
			notify('Invalid Input', 'warning');
			return;
		}
		onAddCustomPeriod(customVehicleTypes, getIndex - 1);
		handleClose();
	};

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			fullWidth
			classes={{ paper: classes.dialogPaper }}
			BackdropProps={{
				classes: {
					root: classes.backDrop
				}
			}}
		>
			<div style={{ width: "100%" }}>
				<SimpleForm style={{ padding: '0 22px' }} toolbar={false}>
					<div style={{ width: "100%" }}>
						<p style={{ fontSize: 15, color: "#272727", fontWeight: "bold" }}>Enter position where you want to add a New Row.</p>
						<MuiTextField variant='outlined' value={getIndex} onChange={(e) => setIndex(e.target.value)} />
					</div>
				</SimpleForm>
			</div>
			<DialogActions style={{ padding: "22px 35px" }}>
				<Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
					Cancel
				</Button>
				<Button onClick={addHandler} color="contained" variant='contained' style={{ backgroundColor: '#18cc69', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
					Add
				</Button>
			</DialogActions>
		</Dialog>
	);
}

const PricingModelForm = ({ pricingModel, vehicleTypes, updateDailyPricing }) => {

	const updateAmount = (key, type, amount, nested) => {
		if (isNaN(amount))
			return;

		const amounts = nested ? { ...pricingModel[key][nested] } : {};
		amounts[type] = { amount };

		let keyValue = {};
		if (nested)
			keyValue[nested] = amounts;
		else
			keyValue = amounts;
		updateDailyPricing(key, keyValue);
	};

	const updateTime = (key, type, time, timeType) => {
		const keyValue = {};
		keyValue[key] = { ...pricingModel.period_cost[key] };
		keyValue[key][type] = {};
		keyValue[key][type][timeType] = time;

		updateDailyPricing("period_cost", keyValue);
	};

	const addCustomPeriod = (type) => {
		const period_cost_list = { ...pricingModel.period_cost.period_cost_list };
		if (period_cost_list[type] == null) period_cost_list[type] = [];
		period_cost_list[type].push({ period_end_time: "23:59:59", period_cost: 0 });
		updateDailyPricing("period_cost", { period_cost_list });
	};

	const addCustomPeriodAtIndex = (type, index) => {
		const period_cost_list = { ...pricingModel.period_cost.period_cost_list };
		if (period_cost_list[type] == null) period_cost_list[type] = [];
		period_cost_list[type].splice(index, 0, { period_end_time: "23:59:59", period_cost: 0 });
		updateDailyPricing("period_cost", { period_cost_list });
	};

	const removeCustomPeriod = (type, index) => {
		const period_cost_list = { ...pricingModel.period_cost.period_cost_list };
		period_cost_list[type].splice(index, 1);
		updateDailyPricing("period_cost", { period_cost_list });
	};

	const updateCustomCostList = (type, index, key, keyValue) => {
		if (key === "period_cost" && isNaN(keyValue))
			return;

		const period_cost_list = { ...pricingModel.period_cost.period_cost_list };
		period_cost_list[type][index][key] = keyValue;
		updateDailyPricing("period_cost", { period_cost_list });
	};

	const [open, setOpen] = React.useState(false);
	const [customVehicleTypes, setCustomVehicleTypes] = React.useState("")

	return (
		<div style={{ marginTop: 20 }}>
			<Accordion expanded={pricingModel.entry_cost.enabled}>
				<AccordionSummary style={{ cursor: "default" }}>
					<FormControlLabel
						checked={pricingModel.entry_cost.enabled}
						onChange={e => updateDailyPricing("entry_cost", { enabled: e.target.checked })}
						control={<Checkbox />}
						label="Entry Cost"
					/>
				</AccordionSummary>
				<AccordionDetails style={{ display: "grid", gridTemplateColumns: "33% 33% 33%", gridColumnGap: 10, justifyContent: "space-between", alignItems: "center", gridRowGap: 12, paddingBottom: 20 }}>
					{Object.keys(vehicleTypes).map(key => (vehicleTypes[key].visible &&
						<div key={key}>
							<Typography>{vehicleTypes[key].label}</Typography>
							<MuiTextField
								variant="outlined"
								size="small"
								placeholder="Amount"
								value={pricingModel.entry_cost.entry_cost[vehicleTypes[key].name]?.amount}
								onChange={e => updateAmount("entry_cost", vehicleTypes[key].name, e.target.value, "entry_cost")}
								onBlur={e => updateAmount("entry_cost", vehicleTypes[key].name, parseFloat(e.target.value), "entry_cost")}
							/>
						</div>
					))}
				</AccordionDetails>
			</Accordion>
			<Accordion expanded={pricingModel.fixed_cost.enabled}>
				<AccordionSummary style={{ cursor: "default" }}>
					<FormControlLabel
						checked={pricingModel.fixed_cost.enabled}
						onChange={e => updateDailyPricing("fixed_cost", { enabled: e.target.checked })}
						control={<Checkbox />}
						label="Fixed Cost"
					/>
				</AccordionSummary>
				<AccordionDetails style={{ display: "grid", gridTemplateColumns: "33% 33% 33%", gridColumnGap: 10, justifyContent: "space-between", alignItems: "center", gridRowGap: 12, paddingBottom: 20 }}>
					{Object.keys(vehicleTypes).map(key => (vehicleTypes[key].visible &&
						<div key={key}>
							<Typography>{vehicleTypes[key].label}</Typography>
							<MuiTextField
								variant="outlined"
								size="small"
								placeholder="Amount"
								value={pricingModel.fixed_cost[vehicleTypes[key].name]?.amount}
								onChange={e => updateAmount("fixed_cost", vehicleTypes[key].name, e.target.value)}
								onBlur={e => updateAmount("fixed_cost", vehicleTypes[key].name, parseFloat(e.target.value))}
							/>
						</div>
					))}
				</AccordionDetails>
			</Accordion>
			<Accordion expanded={pricingModel.period_cost.enabled}>
				<AccordionSummary style={{ cursor: "default" }}>
					<FormControlLabel
						checked={pricingModel.period_cost.enabled}
						onChange={e => updateDailyPricing("period_cost", { enabled: e.target.checked })}
						control={<Checkbox />}
						label="Periodic Cost"
					/>
				</AccordionSummary>
				<AccordionDetails style={{ display: "block", paddingLeft: 30, paddingRight: 30, paddingBottom: 20 }}>
					<Typography style={{ fontWeight: "bold", marginBottom: "20px" }}>Constant Periodic Duration For Vehicles</Typography>
					<div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
						{
							Object.keys(vehicleTypes).map(key =>
							(vehicleTypes[key].visible &&
								<div style={{ display: "flex", justifyContent: "start", alignItems: "center", marginBottom: "20px" }}>
									<Checkbox
										checked={pricingModel.period_cost.is_period_duration_constant_for_vehicle && pricingModel.period_cost.is_period_duration_constant_for_vehicle[vehicleTypes[key].name]}
										onChange={(e) => {
											const is_period_duration_constant_for_vehicle = { ...pricingModel.period_cost.is_period_duration_constant_for_vehicle };
											is_period_duration_constant_for_vehicle[vehicleTypes[key].name] = e.target.checked;
											updateDailyPricing("period_cost", { is_period_duration_constant_for_vehicle })
										}}
										inputProps={{ 'aria-label': 'controlled' }}

									/>
									<Typography>{vehicleTypes[key].label}</Typography>
								</div>
							)
							)
						}
					</div>
					<RadioGroup
						row
						value={pricingModel.period_cost.is_period_duration_constant}
						onChange={e => updateDailyPricing("period_cost", { is_period_duration_constant: e.target.value === "true" })}
					>
						<FormControlLabel value={true} control={<Radio />} label="Constant Periodic Duration" />
						<FormControlLabel value={false} control={<Radio />} label="Custom Periodic Duration" />
					</RadioGroup>

					{pricingModel.period_cost.is_period_duration_constant ?
						<div style={{ display: "grid", gridTemplateColumns: "33% 32% 32%", justifyContent: "space-between", gap: "20px 10px", marginTop: 15 }}>
							{Object.keys(vehicleTypes).map(key => (vehicleTypes[key].visible &&
								<div key={key} style={{ borderRadius: 15, border: `1px solid #ccc`, padding: "17px 20px 20px", display: "grid", gridRowGap: 15 }}>
									<Typography style={{ fontSize: "1.1rem", marginBottom: 5 }}>{vehicleTypes[key].label}</Typography>
									<TimeInputField
										variant="outlined"
										size="small"
										label="Duration"
										value={pricingModel.period_cost.constant_period_duration[vehicleTypes[key].name]?.duration}
										onChange={e => updateTime("constant_period_duration", vehicleTypes[key].name, e.target.value, "duration")}
										onBlur={e => updateTime("constant_period_duration", vehicleTypes[key].name, "01:00:00", "duration")}
									/>
									<MuiTextField
										variant="outlined"
										size="small"
										placeholder="Amount"
										value={pricingModel.period_cost.constant_period_cost[vehicleTypes[key].name]?.amount}
										onChange={e => updateAmount("period_cost", vehicleTypes[key].name, e.target.value, "constant_period_cost")}
										onBlur={e => updateAmount("period_cost", vehicleTypes[key].name, parseFloat(e.target.value), "constant_period_cost")}
									/>
									<TimeInputField
										variant="outlined"
										size="small"
										label="Delay"
										value={pricingModel.period_cost.period_cost_delay[vehicleTypes[key].name]?.delay}
										onChange={e => updateTime("period_cost_delay", vehicleTypes[key].name, e.target.value, "delay")}
										onBlur={e => updateTime("period_cost_delay", vehicleTypes[key].name, "00:00:00", "delay")}
									/>
								</div>
							))}
						</div>
						:
						<div style={{ display: "grid", gridRowGap: 20, marginTop: 15 }}>
							{Object.keys(vehicleTypes).map(key =>
							(vehicleTypes[key].visible &&
								<div key={key} style={{ borderRadius: 10, border: `1px solid #ccc`, padding: "17px 20px 20px" }}>
									<Typography style={{ fontSize: "1.1rem", marginBottom: 15 }}>{vehicleTypes[key].label}</Typography>
									<div style={{ display: "grid", gridTemplateColumns: "45% 45% 10%", gap: "12px 22px" }}>
										<Typography style={{ fontSize: "0.84rem", padding: "12px 0", color: "#555" }}>Period End Time</Typography>
										<Typography style={{ fontSize: "0.84rem", padding: "12px 0", color: "#555" }}>Period Cost</Typography>
										<div>
											<IconButton onContextMenu={(e) => {
												e.preventDefault()
												setOpen(true)
												setCustomVehicleTypes(vehicleTypes[key].name)
											}}
												onClick={() => addCustomPeriod(vehicleTypes[key].name)}>
												<AddIcon />
											</IconButton>
											<CustomPeriodicDialog open={open} customVehicleTypes={customVehicleTypes} handleClose={() => setOpen(false)} onAddCustomPeriod={(val, index) => {
												addCustomPeriodAtIndex(val, index);
											}} />

										</div>
										{pricingModel.period_cost.period_cost_list[vehicleTypes[key].name] && pricingModel.period_cost.period_cost_list[vehicleTypes[key].name].map((period, index) => (
											<React.Fragment key={index}>
												<TimeInputField
													variant="outlined"
													size="small"
													label="Time"
													value={period.period_end_time}
													onChange={e => updateCustomCostList(vehicleTypes[key].name, index, "period_end_time", e.target.value)}
													onBlur={e => updateCustomCostList(vehicleTypes[key].name, index, "period_end_time", "23:59:59")}
												/>
												<MuiTextField
													variant="outlined"
													size="small"
													placeholder="Amount"
													value={period.period_cost}
													onChange={e => updateCustomCostList(vehicleTypes[key].name, index, "period_cost", e.target.value)}
													onBlur={e => updateCustomCostList(vehicleTypes[key].name, index, "period_cost", parseFloat(e.target.value))}
												/>
												<div>
													<IconButton onClick={() => removeCustomPeriod(vehicleTypes[key].name, index)}>
														<CloseIcon />
													</IconButton>
												</div>
											</React.Fragment>
										))}
									</div>
									{(pricingModel.period_cost.period_cost_list[vehicleTypes[key].name] == null || pricingModel.period_cost.period_cost_list[vehicleTypes[key].name].length === 0) && <Typography style={{ fontSize: "1rem", padding: "12px 0", color: "#555", textAlign: "center" }}>No Data</Typography>}
								</div>
							))}

							<Typography style={{ fontSize: "1.1rem", marginTop: 22 }}>Max Custom Period Cost</Typography>
							<div style={{ display: "grid", gridTemplateColumns: "33% 33% 33%", gridColumnGap: 10, justifyContent: "space-between", alignItems: "center", gridRowGap: 12, paddingBottom: 20 }}>
								{Object.keys(vehicleTypes).map(key => (vehicleTypes[key].visible &&
									<div key={key}>
										<Typography>{vehicleTypes[key].label}</Typography>
										<MuiTextField
											variant="outlined"
											size="small"
											placeholder="Amount"
											value={pricingModel.period_cost.max_period_cost && pricingModel.period_cost.max_period_cost[vehicleTypes[key].name] ? pricingModel.period_cost.max_period_cost[vehicleTypes[key].name].amount : ""}
											onChange={e => updateAmount("period_cost", vehicleTypes[key].name, e.target.value, "max_period_cost")}
											onBlur={e => updateAmount("period_cost", vehicleTypes[key].name, parseFloat(e.target.value), "max_period_cost")}
										/>
									</div>
								))}
							</div>

							<Typography style={{ fontSize: "1.1rem", marginTop: 22 }}>Repeat Custom Period</Typography>
							<div style={{ display: "grid", gridTemplateColumns: "33% 33% 33%", gridColumnGap: 10, justifyContent: "space-between", alignItems: "center", gridRowGap: 12, paddingBottom: 20 }}>
								{Object.keys(vehicleTypes).map(key => (vehicleTypes[key].visible &&
									<div key={key}>
										<FormControlLabel
											color="secondary"
											control={<Checkbox />}
											label={vehicleTypes[key].label}
											onChange={e => {
												const repeat_custom_period = { ...pricingModel.period_cost.repeat_custom_period };
												repeat_custom_period[vehicleTypes[key].name] = e.target.checked;
												updateDailyPricing("period_cost", { repeat_custom_period });
											}}
											checked={pricingModel.period_cost.repeat_custom_period && pricingModel.period_cost.repeat_custom_period[vehicleTypes[key].name]}
										/>
									</div>
								))}
							</div>
						</div>
					}
				</AccordionDetails>
			</Accordion>
			<Accordion expanded={!!pricingModel.max_24_hour_cost && pricingModel.max_24_hour_cost.enabled}>
				<AccordionSummary style={{ cursor: "default" }}>
					<FormControlLabel
						checked={!!pricingModel.max_24_hour_cost && pricingModel.max_24_hour_cost.enabled}
						onChange={e => updateDailyPricing(
							"max_24_hour_cost",
							{ enabled: e.target.checked },
							featureData.parking_cost["normal_daily_pricing"].max_24_hour_cost,
						)}
						control={<Checkbox />}
						label="Max 24 Hour Cost"
					/>
				</AccordionSummary>
				<AccordionDetails style={{ display: "grid", gridTemplateColumns: "33% 33% 33%", gridColumnGap: 10, justifyContent: "space-between", alignItems: "center", gridRowGap: 12, paddingBottom: 20 }}>
					{Object.keys(vehicleTypes).map(key => (vehicleTypes[key].visible &&
						<div key={key}>
							<Typography>{vehicleTypes[key].label}</Typography>
							<MuiTextField
								variant="outlined"
								size="small"
								placeholder="Amount"
								value={pricingModel.max_24_hour_cost ? pricingModel.max_24_hour_cost[vehicleTypes[key].name]?.amount : ""}
								onChange={e => updateAmount("max_24_hour_cost", vehicleTypes[key].name, e.target.value)}
								onBlur={e => updateAmount("max_24_hour_cost", vehicleTypes[key].name, parseFloat(e.target.value))}
							/>
						</div>
					))}
				</AccordionDetails>
			</Accordion>
			<Accordion expanded={!!pricingModel.night_charges && pricingModel.night_charges.enabled}>
				<AccordionSummary style={{ cursor: "default" }}>
					<FormControlLabel
						checked={!!pricingModel.night_charges && pricingModel.night_charges.enabled}
						onChange={e => updateDailyPricing(
							"night_charges",
							{ enabled: e.target.checked },
							featureData.parking_cost["normal_daily_pricing"].night_charges,
						)}
						control={<Checkbox />}
						label="Night Charges"
					/>
				</AccordionSummary>
				<AccordionDetails style={{ display: "block" }}>
					<div style={{ display: "grid", gridTemplateColumns: "45% 46%", gridColumnGap: 20, justifyContent: "space-between", paddingBottom: 20 }}>
						<TimeInputField
							variant="outlined"
							label="Start Time"
							value={pricingModel.night_charges ? pricingModel.night_charges.start_time : "00:00:00"}
							onChange={e => updateDailyPricing("night_charges", { start_time: e.target.value })}
							onBlur={e => updateDailyPricing("night_charges", { start_time: "00:00:00" })}
						/>
						<TimeInputField
							variant="outlined"
							label="End Time"
							value={pricingModel.night_charges ? pricingModel.night_charges.end_time : "00:00:00"}
							onChange={e => updateDailyPricing("night_charges", { end_time: e.target.value })}
							onBlur={e => updateDailyPricing("night_charges", { end_time: "00:00:00" })}
						/>
					</div>

					<div style={{ display: "grid", gridTemplateColumns: "33% 33% 33%", gridColumnGap: 10, justifyContent: "space-between", alignItems: "center", gridRowGap: 12, paddingBottom: 20 }}>
						{Object.keys(vehicleTypes).map(key => (vehicleTypes[key].visible &&
							<div key={key}>
								<Typography>{vehicleTypes[key].label}</Typography>
								<MuiTextField
									variant="outlined"
									size="small"
									placeholder="Amount"
									value={pricingModel.night_charges ? pricingModel.night_charges.night_charges[vehicleTypes[key].name]?.amount : ""}
									onChange={e => updateAmount("night_charges", vehicleTypes[key].name, e.target.value, "night_charges")}
									onBlur={e => updateAmount("night_charges", vehicleTypes[key].name, parseFloat(e.target.value), "night_charges")}
								/>
							</div>
						))}
					</div>
				</AccordionDetails>
			</Accordion>
			<Accordion expanded={!!pricingModel.pricing_start_end_time}>
				<AccordionSummary style={{ cursor: "default" }}>
					<FormControlLabel
						checked={!!pricingModel.pricing_start_end_time}
						onChange={e => updateDailyPricing(
							"pricing_start_end_time",
							e.target.checked ? { start_time: "00:00:00", end_time: "05:00:00" } : null,
						)}
						control={<Checkbox />}
						label="Pricing Start and End Time"
					/>
				</AccordionSummary>
				<AccordionDetails style={{ display: "grid", gridTemplateColumns: "45% 46%", gridColumnGap: 20, justifyContent: "space-between", paddingBottom: 20 }}>
					<TimeInputField
						variant="outlined"
						label="Start Time"
						value={pricingModel.pricing_start_end_time ? pricingModel.pricing_start_end_time.start_time : "00:00:00"}
						onChange={e => updateDailyPricing("pricing_start_end_time", { start_time: e.target.value })}
						onBlur={e => updateDailyPricing("pricing_start_end_time", { start_time: "00:00:00" })}
					/>
					<TimeInputField
						variant="outlined"
						label="End Time"
						value={pricingModel.pricing_start_end_time ? pricingModel.pricing_start_end_time.end_time : "00:00:00"}
						onChange={e => updateDailyPricing("pricing_start_end_time", { end_time: e.target.value })}
						onBlur={e => updateDailyPricing("pricing_start_end_time", { end_time: "00:00:00" })}
					/>
				</AccordionDetails>
			</Accordion>
			<Accordion expanded={false}>
				<AccordionSummary style={{ cursor: "default" }}>
					<FormControlLabel
						checked={!!pricingModel.free_vehicle && pricingModel.free_vehicle.enabled}
						onChange={e => updateDailyPricing(
							"free_vehicle",
							{ enabled: e.target.checked },
						)}
						control={<Checkbox />}
						label="Free Vehicle"
					/>
				</AccordionSummary>
			</Accordion>
			<Accordion expanded={!!pricingModel.day_pass && pricingModel.day_pass.enabled}>
				<AccordionSummary style={{ cursor: "default" }}>
					<FormControlLabel
						checked={!!pricingModel.day_pass && pricingModel.day_pass.enabled}
						onChange={e => updateDailyPricing(
							"day_pass",
							{ enabled: e.target.checked },
							featureData.parking_cost["normal_daily_pricing"].day_pass,
						)}
						control={<Checkbox />}
						label="Day Pass"
					/>
				</AccordionSummary>
				<AccordionDetails style={{ display: "grid", gridTemplateColumns: "33% 33% 33%", gridColumnGap: 10, justifyContent: "space-between", alignItems: "center", gridRowGap: 12, paddingBottom: 20 }}>
					{Object.keys(vehicleTypes).map(key => (vehicleTypes[key].visible &&
						<div key={key}>
							<Typography>{vehicleTypes[key].label}</Typography>
							<MuiTextField
								variant="outlined"
								size="small"
								placeholder="Amount"
								value={pricingModel.day_pass ? pricingModel.day_pass[vehicleTypes[key].name]?.amount : ""}
								onChange={e => updateAmount("day_pass", vehicleTypes[key].name, e.target.value)}
								onBlur={e => updateAmount("day_pass", vehicleTypes[key].name, parseFloat(e.target.value))}
							/>
						</div>
					))}
				</AccordionDetails>
			</Accordion>

			<Accordion expanded={!!pricingModel.cost_more_than_24_hours && pricingModel.cost_more_than_24_hours.enabled}>
				<AccordionSummary style={{ cursor: "default" }}>
					<FormControlLabel
						checked={!!pricingModel.cost_more_than_24_hours && pricingModel.cost_more_than_24_hours.enabled}
						//onChange={e => updateDailyPricing("period_cost", { enabled: e.target.checked }, featureData.parking_cost["normal_daily_pricing"].period_cost.cost_more_than_24_hours, 'cost_more_than_24_hours')}
						onChange={e => updateDailyPricing(
							"cost_more_than_24_hours",
							{ enabled: e.target.checked },
							featureData.parking_cost["normal_daily_pricing"].cost_more_than_24_hours,
						)}
						control={<Checkbox />}
						label="More Than 24 Hours"
					/>
				</AccordionSummary>
				<AccordionDetails style={{ display: "grid", gridTemplateColumns: "33% 33% 33%", gridColumnGap: 10, justifyContent: "space-between", alignItems: "center", gridRowGap: 12, paddingBottom: 20 }}>
					{Object.keys(vehicleTypes).map(key => {
						return (vehicleTypes[key].visible &&
							<div key={key}>
								<Typography>{vehicleTypes[key].label}</Typography>
								<MuiTextField
									variant="outlined"
									size="small"
									placeholder="Amount"
									value={pricingModel && pricingModel.cost_more_than_24_hours && pricingModel.cost_more_than_24_hours[vehicleTypes[key].name] && pricingModel.cost_more_than_24_hours[vehicleTypes[key].name].amount ? pricingModel.cost_more_than_24_hours[vehicleTypes[key].name].amount : ""}
									onChange={e => updateAmount("cost_more_than_24_hours", vehicleTypes[key].name, e.target.value)}
									onBlur={e => updateAmount("cost_more_than_24_hours", vehicleTypes[key].name, parseFloat(e.target.value))}
								/>
							</div>
						)
					})}
				</AccordionDetails>
			</Accordion>

			<Accordion expanded={!!pricingModel.repeat_pricing && pricingModel.repeat_pricing.enabled}>
				<AccordionSummary style={{ cursor: "default" }}>
					<FormControlLabel
						checked={!!pricingModel.repeat_pricing && pricingModel.repeat_pricing.enabled}
						onChange={e => updateDailyPricing("repeat_pricing",{ enabled: e.target.checked })}
						control={<Checkbox />}
						label="Repeat Pricing"
					/>
				</AccordionSummary>
				<AccordionDetails style={{ display: "grid", gridTemplateColumns: "45% 46%", gridColumnGap: 20, justifyContent: "space-between", paddingBottom: 20 }}>
					<TimeInputField
						variant="outlined"
						label="Time"
						value={pricingModel.repeat_pricing && pricingModel.repeat_pricing.repeat_timestamp ? pricingModel.repeat_pricing.repeat_timestamp : "00:00:00"}
						onChange={e => updateDailyPricing("repeat_pricing", { repeat_timestamp : e.target.value })}
						onBlur={e => updateDailyPricing("repeat_pricing", { repeat_timestamp : "00:00:00" })}
					/>
				</AccordionDetails>
			</Accordion>

			<Accordion expanded={!!pricingModel.valet && pricingModel.valet.enabled}>
				<AccordionSummary style={{ cursor: "default" }}>
					<FormControlLabel
						checked={!!pricingModel.valet && pricingModel.valet.enabled}
						onChange={e => updateDailyPricing("valet", { enabled: e.target.checked })}
						control={<Checkbox />}
						label="Valet"
					/>
				</AccordionSummary>
				<AccordionDetails style={{ flexDirection: "column" }}>
					<div>
						<FormControlLabel
							checked={!!pricingModel.valet && !!pricingModel.valet.pre_payment && pricingModel.valet.pre_payment.enabled}
							onChange={e => {
								updateDailyPricing("valet", { pre_payment: { enabled: e.target.checked }, mid_way_payment: { enabled: false }, payment_at_end: { enabled: false }, link_with_visitor: { enabled: false } })
							}}
							control={<Checkbox />}
							label="Pre Payment"
						/>
						<FormControlLabel
							checked={!!pricingModel.valet && !!pricingModel.valet.mid_way_payment && pricingModel.valet.mid_way_payment.enabled}
							onChange={e => {
								updateDailyPricing("valet", { pre_payment: { enabled: false }, mid_way_payment: { enabled: e.target.checked }, payment_at_end: { enabled: false }, link_with_visitor: { enabled: false } })
							}}
							control={<Checkbox />}
							label="Mid Way Payment"
						/>
						<FormControlLabel
							checked={!!pricingModel.valet && !!pricingModel.valet.payment_at_end && pricingModel.valet.payment_at_end.enabled}
							onChange={e => {
								updateDailyPricing("valet", { pre_payment: { enabled: false }, mid_way_payment: { enabled: false }, link_with_visitor: { enabled: false }, payment_at_end: { enabled: e.target.checked } })
							}}
							control={<Checkbox />}
							label="Payment At End"
						/>
						<FormControlLabel
							checked={!!pricingModel.valet && !!pricingModel.valet.link_with_visitor && pricingModel.valet.link_with_visitor.enabled}
							onChange={e => {
								updateDailyPricing("valet", { pre_payment: { enabled: false }, mid_way_payment: { enabled: false }, payment_at_end: { enabled: e.target.checked }, link_with_visitor: { enabled: e.target.checked } })
							}}
							control={<Checkbox />}
							label="Link with Visitor"
						/>
					</div>
					<div style={{marginTop:"20px", display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "20px" }}>
						<div>
							<TimeInputField
								variant="outlined"
								label="Start Time"
								value={pricingModel.valet && pricingModel.valet.start_time ? pricingModel.valet.start_time : "00:00:00"}
								onChange={e => updateDailyPricing("valet", { start_time: e.target.value })}
								onBlur={e => updateDailyPricing("valet", { start_time: "00:00:00" })}
							/>
						</div>
						<div>
							<TimeInputField
								variant="outlined"
								label="End Time"
								value={pricingModel.valet && pricingModel.valet.end_time ? pricingModel.valet.end_time : "00:00:00"}
								onChange={e => updateDailyPricing("valet", { end_time: e.target.value })}
								onBlur={e => updateDailyPricing("valet", { end_time: "00:00:00" })}
							/>
						</div>
					</div>
					<div style={{marginTop:"20px", display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "20px" }}>
						<div>
							<MuiTextField
								variant="outlined"
								size="small"
								placeholder="Amount"
								label="Amount"
								value={pricingModel && pricingModel.valet && pricingModel.valet.amount ? pricingModel.valet.amount : ""}
								onChange={e => updateDailyPricing("valet", { amount: e.target.value })}
								onBlur={e => updateDailyPricing("valet", { amount: parseFloat(e.target.value) })}
							/>
						</div>
					</div>
					<div style={{marginTop:"20px", display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "20px" }}>
						<div>
							<MuiTextField
								type='number'
								value={pricingModel && pricingModel.valet && pricingModel.valet.recall_time ? pricingModel.valet.recall_time : ""}
								onChange={e => updateDailyPricing("valet", { recall_time: e.target.value })}
								onBlur={e => updateDailyPricing("valet", { recall_time: parseFloat(e.target.value) })}
								variant="outlined"
								size="small"
								label="Recall Time (In Mins)"
							/>
						</div>
						<div>
							<MuiTextField
								type='number'
								value={pricingModel && pricingModel.valet && pricingModel.valet.parking_slot_area_screen ? pricingModel.valet.parking_slot_area_screen : ""}
								onChange={e => updateDailyPricing("valet", { parking_slot_area_screen: e.target.value })}
								onBlur={e => updateDailyPricing("valet", { parking_slot_area_screen: parseFloat(e.target.value) })}
								variant="outlined"
								size="small"
								label="Slot Area Screen No."
								disabled={pricingModel?.valet?.skip_car_parked_activity?.enabled}
							/>
						</div>
					</div>

					<div style={{ fontWeight: "600", fontSize: "14px", marginTop: "20px" }}>Optional Flags</div>
					<div>
						<FormControlLabel
							checked={!!pricingModel.valet && !!pricingModel.valet.skip_car_parked_activity && pricingModel.valet.skip_car_parked_activity.enabled}
							onChange={e => {
								updateDailyPricing("valet", { skip_car_parked_activity: { enabled: e.target.checked }, parking_slot_area_screen : e.target.checked ? 1 : pricingModel?.valet?.parking_slot_area_screen || 1})
							}}
							control={<Checkbox />}
							label="Skip Car Parked Activity"
						/>
						<FormControlLabel
							checked={!!pricingModel.valet && !!pricingModel.valet.is_required_parking_area && pricingModel.valet.is_required_parking_area.enabled}
							onChange={e => {
								updateDailyPricing("valet", { is_required_parking_area: { enabled: e.target.checked } })
							}}
							control={<Checkbox />}
							label="Is Required Parking Area"
						/>
						<FormControlLabel
							checked={!!pricingModel.valet && !!pricingModel.valet.is_required_parking_slot && pricingModel.valet.is_required_parking_slot.enabled}
							onChange={e => {
								updateDailyPricing("valet", { is_required_parking_slot: { enabled: e.target.checked } })
							}}
							control={<Checkbox />}
							label="Is Required Parking Slot"
						/>
						<FormControlLabel
							checked={!!pricingModel.valet && !!pricingModel.valet.is_monthly_pass_enabled && pricingModel.valet.is_monthly_pass_enabled.enabled}
							onChange={e => {
								updateDailyPricing("valet", { is_monthly_pass_enabled: { enabled: e.target.checked } })
							}}
							control={<Checkbox />}
							label="Enable Monthly Pass"
						/>
					</div>
					<div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-start", alignItems: "flex-start", gap: "20px" }}>
						<ValetParkingArea />
					</div>
					<div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-start", alignItems: "flex-start", gap: "20px" }}>
						<ValetKeys />
						<ValetDrivers />
					</div>
				</AccordionDetails>
			</Accordion>
		</div>
	);
};

const FeaturesFormField = props => {
	const eventTracker = UseAnalyticsEvent()
	const { input: { value, onChange } } = useInput(props);
	const { input: { value: show_amount_in_crm, onChange: set_show_amount_in_crm } } = useInput({ ...props, id: "show_amount_in_crm", source: "show_amount_in_crm" });
	const { input: { value: category_filter, onChange: set_category_filter } } = useInput({ ...props, id: "category_filter", source: "category_filter" });
	const { input: { value: feature_digital_pay, onChange: set_feature_digital_pay } } = useInput({ ...props, id: "feature_digital_pay", source: "feature_digital_pay" });
	const { input: { value: feature_monthly_pass, onChange: set_feature_monthly_pass } } = useInput({ ...props, id: "feature_monthly_pass", source: "feature_monthly_pass" });
	const { input: { value: separate_summary_of_devices, onChange: set_separate_summary_of_devices } } = useInput({ ...props, id: "separate_summary_of_devices", source: "separate_summary_of_devices" });
	const { input: { value: show_anpr_images, onChange: set_show_anpr_images } } = useInput({ ...props, id: "show_anpr_images", source: "show_anpr_images" });
	const { input: { value: show_category_distribution, onChange: set_show_category_distribution } } = useInput({ ...props, id: "show_category_distribution", source: "show_category_distribution" });
	const { input: { value: show_foc_summary, onChange: set_show_foc_summary } } = useInput({ ...props, id: "show_foc_summary", source: "show_foc_summary" });
	const { input: { value: show_not_exited_in_crm, onChange: set_show_not_exited_in_crm } } = useInput({ ...props, id: "show_not_exited_in_crm", source: "show_not_exited_in_crm" });
	const { input: { value: show_payment_type_summary, onChange: set_show_payment_type_summary } } = useInput({ ...props, id: "show_payment_type_summary", source: "show_payment_type_summary" });
	const { input: { value: show_violation_details, onChange: set_show_violation_details } } = useInput({ ...props, id: "show_violation_details", source: "show_violation_details" });
	const { input: { value: use_latest_version, onChange: set_use_latest_version } } = useInput({ ...props, id: "use_latest_version", source: "use_latest_version" });
	const { input: { value: fastag_allow_entry, onChange: set_fastag_allow_entry } } = useInput({ ...props, id: "fastag_allow_entry", source: "fastag_allow_entry" });
	const { input: { value: fastag_allow_exit, onChange: set_fastag_allow_exit } } = useInput({ ...props, id: "fastag_allow_exit", source: "fastag_allow_exit" });
	const { input: { value: fastag_allow_chassis, onChange: set_fastag_allow_chassis } } = useInput({ ...props, id: "fastag_allow_chassis", source: "fastag_allow_chassis" });
	const { input: { value: fastag_allow_exit_after_24hrs, onChange: set_fastag_allow_exit_after_24hrs } } = useInput({ ...props, id: "fastag_allow_exit_after_24hrs", source: "fastag_allow_exit_after_24hrs" });
	const { input: { value: anpr_allow_entry, onChange: set_anpr_allow_entry } } = useInput({ ...props, id: "anpr_allow_entry", source: "anpr_allow_entry" });
	const { input: { value: check_short_vehicle_number, onChange: set_check_short_vehicle_number } } = useInput({ ...props, id: "check_short_vehicle_number", source: "check_short_vehicle_number" });
	const { input: { value: check_similar_vehicle_number, onChange: set_check_similar_vehicle_number } } = useInput({ ...props, id: "check_similar_vehicle_number", source: "check_similar_vehicle_number" });
	const { input: { value: is_anpr_only, onChange: set_is_anpr_only } } = useInput({ ...props, id: "is_anpr_only", source: "is_anpr_only" });
	const { input: { value: allow_anpr_rfid_permit, onChange: set_allow_anpr_rfid_permit } } = useInput({ ...props, id: "allow_anpr_rfid_permit", source: "allow_anpr_rfid_permit" });
	const { input: { value: is_required_parking_slot_number, onChange: set_is_required_parking_slot_number } } = useInput({ ...props, id: "is_required_parking_slot_number", source: "is_required_parking_slot_number" });
	const { input: { value: allow_permit_sub_types, onChange: set_allow_permit_sub_types } } = useInput({ ...props, id: "allow_permit_sub_types", source: "allow_permit_sub_types" });
	const { input: { value: fastag_allow_vaahan_api, onChange: set_fastag_allow_vaahan_api } } = useInput({ ...props, id: "fastag_allow_vaahan_api", source: "fastag_allow_vaahan_api" });
	const { input: { value: fastag_allow_new_entries, onChange: set_fastag_allow_new_entries } } = useInput({ ...props, id: "fastag_allow_new_entries", source: "fastag_allow_new_entries" });
	const { input: { value: anpr_allow_new_entries, onChange: set_anpr_allow_new_entries } } = useInput({ ...props, id: "anpr_allow_new_entries", source: "anpr_allow_new_entries" });
	const { input: { value: use_pass_as_permit, onChange: set_use_pass_as_permit } } = useInput({ ...props, id: "use_pass_as_permit", source: "use_pass_as_permit" });
	const { input: { value: maruti_integrated, onChange: set_maruti_integrated } } = useInput({ ...props, id: "maruti_integrated", source: "maruti_integrated" });
	const { input: { value: show_pass_in_vehicle_summary, onChange: set_show_pass_in_vehicle_summary } } = useInput({ ...props, id: "show_pass_in_vehicle_summary", source: "show_pass_in_vehicle_summary" });
	const { input: { value: delete_entry_of_pass_vehicle, onChange: set_delete_entry_of_pass_vehicle } } = useInput({ ...props, id: "delete_entry_of_pass_vehicle", source: "delete_entry_of_pass_vehicle" });
	const { input: { value: allow_pass_update_by_device, onChange: set_allow_pass_update_by_device } } = useInput({ ...props, id: "allow_pass_update_by_device", source: "allow_pass_update_by_device" });
	const { input: { value: aeria_integrated, onChange: set_aeria_integrated } } = useInput({ ...props, id: "aeria_integrated", source: "aeria_integrated" });
	const { input: { value: verify_visitor_vehicle_type, onChange: set_verify_visitor_vehicle_type } } = useInput({ ...props, id: "verify_visitor_vehicle_type", source: "verify_visitor_vehicle_type" });
	const { input: { value: verify_surveillance_vehicle_type, onChange: set_verify_surveillance_vehicle_type } } = useInput({ ...props, id: "verify_surveillance_vehicle_type", source: "verify_surveillance_vehicle_type" });
	const { input: { value: explicit_anpr_permits, onChange: set_explicit_anpr_permits } } = useInput({ ...props, id: "explicit_anpr_permits", source: "explicit_anpr_permits" });
	const { input: { value: show_parksmart_tag_type, onChange: set_show_parksmart_tag_type } } = useInput({ ...props, id: "show_parksmart_tag_type", source: "show_parksmart_tag_type" });
	const { input: { value: show_fastag_type, onChange: set_show_fastag_type } } = useInput({ ...props, id: "show_fastag_type", source: "show_fastag_type" });
	const { input: { value: show_lf_tag_type, onChange: set_show_lf_tag_type } } = useInput({ ...props, id: "show_lf_tag_type", source: "show_lf_tag_type" });
	const { input: { value: allow_exit_without_entry, onChange: set_allow_exit_without_entry } } = useInput({ ...props, id: "allow_exit_without_entry", source: "allow_exit_without_entry" });
	const { input: { value: strictly_populate_parksmart_tags, onChange: set_strictly_populate_parksmart_tags } } = useInput({ ...props, id: "strictly_populate_parksmart_tags", source: "strictly_populate_parksmart_tags" });
	const { input: { value: occupancy_enable, onChange: set_occupancy_enable }} = useInput({...props,id: "occupancy_enable",source: "occupancy_enable"});
	const {input: {value: allow_fetch_fastag, onChange: set_allow_fetch_fastag}} = useInput({...props,id: "allow_fetch_fastag",source: "allow_fetch_fastag"});

	const [currentTab, setCurrentTab] = React.useState(0);
	const [currentCostModel, setCurrentCostModel] = React.useState(value.parking_cost && costModelKey[value.parking_cost.cost_model] ? costModelKey[value.parking_cost.cost_model] : null);
	const [previewReceiptTime, setPreviewReceiptTime] = React.useState("entry");
	const [previewReceiptVehicleType, setPreviewReceiptVehicleType] = React.useState(" ");
	const [availableProperties, setAvailableProperties] = React.useState([]);
	const [newProperty, setNewProperty] = React.useState("");
	const [receiptMenuAnchor, setReceiptMenuAnchor] = React.useState({});
	const [currentReceiptText, setCurrentReceiptText] = React.useState(null);
	const [availableReceiptProperties, setAvailableReceiptProperties] = React.useState([]);
	const [receiptProperty, setReceiptProperty] = React.useState("");
	const classes = useStyles();

	React.useEffect(() => {
		if (props.copiedData && props.copiedData.vehicle_type) {
			if (props.copyOnly === "Everything") {
				onChange(props.copiedData)
			}
			if (props.copyOnly === "footer") {
				onChange({ ...value, receipt: { ...value.receipt, footer: props.copiedData.receipt.footer } });
			}
			if (props.copyOnly === "parking_cost") {
				onChange({ ...value, parking_cost: props.copiedData.parking_cost });
			}
			if (props.copyOnly === "parking_manager") {
				onChange({ ...value, parking_manager: props.copiedData.parking_manager });
			}
			if (props.copyOnly === "header") {
				onChange({ ...value, receipt: { ...value.receipt, header: props.copiedData.receipt.header } });
			}

		}
		else if (!props.edit && (typeof value !== 'object' || value == null)) {
			onChange(featureData);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.edit, props.copiedData]);

	const changeTab = (event, newValue) => {
		setCurrentTab(newValue);
	};

	const updateData = data => {
		onChange({
			...value,
			...data,
		});
	};

	const updatePricing = (data, defaultValues = {}) => {
		updateData({
			parking_cost: {
				...defaultValues,
				...value.parking_cost,
				...data,
			}
		});
	};

	const updateDailyPricing = (key, data, defaultValues, subKey) => {
		const pricingModel = { ...value.parking_cost[currentCostModel] };
		if (pricingModel[key] == null)
			pricingModel[key] = defaultValues;
		if (data == null)
			pricingModel[key] = null;
		if (subKey && pricingModel[key][subKey] == null)
			pricingModel[key][subKey] = defaultValues;
		if (subKey && pricingModel[key][subKey] != null) {
			pricingModel[key][subKey] = {
				...defaultValues,
				...pricingModel[key][subKey],
				...data,
			};
		} else if (data) {
			pricingModel[key] = {
				...pricingModel[key],
				...data,
			};
		}
		console.log(pricingModel)
		updatePricing({ [currentCostModel]: pricingModel });
	};

	const updateDayNightPricing = (key, data, defaultValues) => {
		const pricingModel = { ...value.parking_cost.day_night_pricing[currentCostModel] };
		if (pricingModel[key] == null)
			pricingModel[key] = defaultValues;
		if (data == null)
			pricingModel[key] = null;
		else
			pricingModel[key] = {
				...pricingModel[key],
				...data,
			};
		updatePricing({ day_night_pricing: { ...value.parking_cost.day_night_pricing, [currentCostModel]: pricingModel } });
	};

	const updateReceipt = data => {
		updateData({
			receipt: {
				...value.receipt,
				...data,
			}
		});
	};

	const updateReceiptText = (type, index, key, keyValue) => {
		const receipt = {};
		receipt[type] = [...value.receipt[type]];
		receipt[type][index][key] = keyValue;
		updateReceipt(receipt);
	};

	const addReceiptText = type => {
		const receipt = {};
		receipt[type] = [...value.receipt[type]];
		receipt[type].push(sampleReceiptText);
		updateReceipt(receipt);
	};

	const updateConfigurationProperty = (key, data) => {
		if (key != null && key !== "") {
			const parking_manager = { ...value.parking_manager };
			parking_manager[key] = data;
			updateData({ parking_manager });
		}
	};

	const updateNumberProperty = (key, data) => {
		if (data === "")
			data = -1;
		if (!isNaN(data))
			updateConfigurationProperty(key, data === "" ? data : parseInt(data));
	};

	const removeConfigurationProperty = (key) => {
		const parking_manager = { ...value.parking_manager };
		delete parking_manager[key];
		updateData({ parking_manager });
	};

	const openReceiptTextMenu = (event, type, index) => {
		event.preventDefault();
		setReceiptMenuAnchor({ mouseX: event.clientX - 2, mouseY: event.clientY - 4 });
		setCurrentReceiptText({ type, index });
	};

	const closeReceiptTextMenu = () => {
		setReceiptMenuAnchor({});
	};

	const removeReceiptText = () => {
		const receipt = {};
		receipt[currentReceiptText.type] = [...value.receipt[currentReceiptText.type]];
		receipt[currentReceiptText.type].splice(currentReceiptText.index, 1);
		updateReceipt(receipt);

		closeReceiptTextMenu();
		setCurrentReceiptText(null);
	};

	const moveUpReceiptText = () => {
		const receipt = {};
		receipt[currentReceiptText.type] = [...value.receipt[currentReceiptText.type]];
		const temp = receipt[currentReceiptText.type][currentReceiptText.index];
		receipt[currentReceiptText.type].splice(currentReceiptText.index, 1);
		receipt[currentReceiptText.type].splice(currentReceiptText.index - 1, 0, temp);
		updateReceipt(receipt);

		closeReceiptTextMenu();
		setCurrentReceiptText({ ...currentReceiptText, index: currentReceiptText.index - 1 });
	};

	const moveDownReceiptText = () => {
		const receipt = {};
		receipt[currentReceiptText.type] = [...value.receipt[currentReceiptText.type]];
		const temp = receipt[currentReceiptText.type][currentReceiptText.index];
		receipt[currentReceiptText.type].splice(currentReceiptText.index, 1);
		receipt[currentReceiptText.type].splice(currentReceiptText.index + 1, 0, temp);
		updateReceipt(receipt);

		closeReceiptTextMenu();
		setCurrentReceiptText({ ...currentReceiptText, index: currentReceiptText.index + 1 });
	};

	const duplicateReceiptText = () => {
		const receipt = {};
		receipt[currentReceiptText.type] = [...value.receipt[currentReceiptText.type]];
		const temp = { ...receipt[currentReceiptText.type][currentReceiptText.index] };
		receipt[currentReceiptText.type].splice(currentReceiptText.index + 1, 0, temp);
		updateReceipt(receipt);

		closeReceiptTextMenu();
	};

	const updateVehicleType = (key, data, defaultValue) => {
		if (value.vehicle_type[key]) {
			value.vehicle_type[key] = {
				...value.vehicle_type[key],
				...data,
			}
			updateData(value);
		} else {
			value.vehicle_type[key] = {
				...defaultValue,
				...data,
			}
			key = value.vehicle_type[key].name

			// Add Vehicle Type in JSON if not present
			const costModels = ["normal_daily_pricing", "weekday_pricing", "weekend_pricing"];
			for (let i in costModels) {
				if (value["parking_cost"][costModels[i]]) {
					value["parking_cost"][costModels[i]]["entry_cost"]["entry_cost"][key] = { amount: 0 };
					value["parking_cost"][costModels[i]]["fixed_cost"][key] = { amount: 0 };
					value["parking_cost"][costModels[i]]["period_cost"]["period_cost_delay"][key] = { delay: "00:00:00" };
					value["parking_cost"][costModels[i]]["period_cost"]["constant_period_duration"][key] = { duration: "01:00:00" };
					value["parking_cost"][costModels[i]]["period_cost"]["constant_period_cost"][key] = { amount: 0 };
					value["parking_cost"][costModels[i]]["period_cost"]["period_cost_list"][key] = [{ "period_end_time": "06:00:00", "period_cost": 0 }, { "period_end_time": "12:00:00", "period_cost": 0 }, { "period_end_time": "23:59:59", "period_cost": 0 }];
					if (value["parking_cost"][costModels[i]]["max_24_hour_cost"])
						value["parking_cost"][costModels[i]]["max_24_hour_cost"][key] = { amount: 0 };
					if (value["parking_cost"][costModels[i]]["night_charges"])
						value["parking_cost"][costModels[i]]["night_charges"]["night_charges"][key] = { amount: 0 };
					if (value["parking_cost"][costModels[i]]["day_pass"])
						value["parking_cost"][costModels[i]]["day_pass"][key] = { amount: 0 };
				}
			}

			for (let i = 0; i < value.receipt.header.length; i++)
				value["receipt"]["header"][i][key] = false;
			for (let i = 0; i < value.receipt.footer.length; i++)
				value["receipt"]["footer"][i][key] = false;
			updateData(value);
		}
	};

	const computeAvaialbleProperties = async () => {
		if (value.parking_manager) {
			setAvailableProperties(Object.keys(parkingConfigurationProperties).filter(p => (value.parking_manager[p] == null)));
			setNewProperty("");
		}
	};

	const computeAvaialbleReceiptProperties = async () => {
		if (value.receipt) {
			setAvailableReceiptProperties(Object.keys(parkingReceiptProperties).filter(p => (value.receipt[p] == null)));
			setReceiptProperty("");
		}
	};

	const updateRootKey = (key, params, defaultValue) => {
		const temp = {};
		temp[key] = value[key] == null ? { ...defaultValue, ...params } : { ...value[key], ...params };
		if (key === "rfid_manager") temp["rfid"] = value["rfid"] == null ? { ...defaultValue, ...params } : { ...value[key], ...params };
		updateData(temp);
	};

	const addPassType = (vehicleType) => {
		const pass_types = { ...value.monthly_pass.pass_types };
		if (pass_types[vehicleType] == null) pass_types[vehicleType] = [];
		pass_types[vehicleType].push({ type: "", price: 0 });
		updateRootKey("monthly_pass", { pass_types });
	};

	const updatePassType = (type, index, key, keyValue) => {
		const pass_types = { ...value.monthly_pass.pass_types };
		pass_types[type][index][key] = keyValue;
		updateRootKey("monthly_pass", { pass_types });
	};

	const removePassType = (type, index) => {
		const pass_types = { ...value.monthly_pass.pass_types };
		pass_types[type].splice(index, 1);
		updateRootKey("monthly_pass", { pass_types });
	};

	const updateReceiptProperty = (key, data) => {
		if (key != null && key !== "") {
			const receipt = { ...value.receipt };
			receipt[key] = data;
			updateData({ receipt });
		}
	};

	const updateReceiptNumberProperty = (key, data) => {
		if (data === "")
			data = -1;
		if (!isNaN(data))
			updateReceiptProperty(key, data === "" ? data : parseInt(data));
	};

	const removeReceiptProperty = (key) => {
		const receipt = { ...value.receipt };
		delete receipt[key];
		updateData({ receipt });
	};

	const updateSubConfigurationProperty = (key, subKey, data) => {
		if (key != null && key !== "" && subKey != null && subKey !== "") {
			const parking_manager = { ...value.parking_manager };
			parking_manager[key] = { ...parking_manager[key] };
			parking_manager[key][subKey] = data;
			updateData({ parking_manager });
		}
	};

	const updateInnerSubConfigurationProperty = (key, subKey, innerSubKey, data) => {
		if (key != null && key !== "" && subKey != null && subKey !== "") {
			const parking_manager = { ...value.parking_manager };
			parking_manager[key] = { ...parking_manager[key] };
			parking_manager[key][subKey][innerSubKey] = data;
			updateData({ parking_manager });
		}
	};

	const updateSubNumberProperty = (key, subKey, data) => {
		if (data === "")
			data = -1;
		if (!isNaN(data))
			updateSubConfigurationProperty(key, subKey, data === "" ? data : parseFloat(data));
	};

	const addSubArrayConfigurationProperty = (key) => {
		const parking_manager = { ...value.parking_manager };
		parking_manager[key] = [...parking_manager[key]];
		parking_manager[key].push(parkingConfigurationProperties[key][0]);
		updateData({ parking_manager });
	};

	const addInnerSubArrayConfigurationProperty = (key, subProperty) => {
		const parking_manager = { ...value.parking_manager };
		parking_manager[key][subProperty] = [...parking_manager[key][subProperty]];
		parking_manager[key][subProperty].push(parkingConfigurationProperties[key][subProperty][0]);
		updateData({ parking_manager });
	};

	const removeSubArrayConfigurationProperty = (key, index) => {
		const parking_manager = { ...value.parking_manager };
		parking_manager[key] = [...parking_manager[key]];
		parking_manager[key].splice(index, 1);
		updateData({ parking_manager });
	};

	const removeInnerSubArrayConfigurationProperty = (key, subProperty, index) => {
		const parking_manager = { ...value.parking_manager };
		parking_manager[key][subProperty] = [...parking_manager[key][subProperty]];
		parking_manager[key][subProperty].splice(index, 1);
		updateData({ parking_manager });
	};

	const updateSubArrayConfigurationProperty = (key, subIndex, subKey2, data) => {
		if (key != null && key !== "" && subIndex != null && subIndex !== "") {
			const parking_manager = { ...value.parking_manager };
			parking_manager[key] = [...parking_manager[key]];
			parking_manager[key][subIndex] = { ...parking_manager[key][subIndex], [subKey2]: data };
			updateData({ parking_manager });
		}
	};

	const updateSubArrayNumberProperty = (key, subIndex, subKey2, data) => {
		if (data === "")
			data = -1;
		if (!isNaN(data))
			updateSubArrayConfigurationProperty(key, subIndex, subKey2, data === "" ? data : parseFloat(data));
	};

	React.useEffect(() => {
		computeAvaialbleProperties();
		computeAvaialbleReceiptProperties();
	}, [value]); // eslint-disable-line react-hooks/exhaustive-deps

	React.useEffect(() => {
		if (value.vehicle_type) {
			// Set Default Vehicle Type
			const temp = Object.keys(value.vehicle_type).filter(key => value.vehicle_type[key].visible).map(key => value.vehicle_type[key].name);
			if (previewReceiptVehicleType === " " || !temp.includes(previewReceiptVehicleType))
				setPreviewReceiptVehicleType(temp.length > 0 ? temp[0] : " ");

			// Add Parking Manager if not exist
			if (!value.parking_manager) {
				updateData({ parking_manager: {} });
			}
		}
	}, [value.vehicle_type]); // eslint-disable-line react-hooks/exhaustive-deps

	React.useEffect(() => {
		if (currentCostModel === null && value.parking_cost && costModelKey[value.parking_cost.cost_model])
			setCurrentCostModel(costModelKey[value.parking_cost.cost_model]);
	}, [currentCostModel, value.parking_cost]);

	React.useEffect(() => {
		// set_show_amount_in_crm(1)
		// set_show_not_exited_in_crm(1)
		eventTracker("PARKING SECTION", "FEATURES TABS CHANGES")
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			<AppBar position="static" style={{ width: "100%" }}>
				<Tabs value={currentTab} onChange={changeTab}>
					<Tab label="Vehicle Types" />
					<Tab label="Pricing" />
					<Tab label="Receipt" />
					<Tab label="Parking Manager" />
					<Tab label="Billings" />
					<Tab label="Password Manager" />
					<Tab label="NFC" />
					<Tab label="RFID" />
					<Tab label="Configuration" />
					
				</Tabs>
			</AppBar>
			{value.vehicle_type && <TabPanel value={currentTab} index={0}>
				<div style={{ display: "grid", gridRowGap: 20 }}>
					{Object.keys(featureData.vehicle_type).map(key => (
						<div key={key} style={{ display: "grid", gridAutoFlow: "column", gridColumnGap: 10, justifyContent: "flex-start", alignItems: "center" }}>
							<Checkbox
								title="Visible For Parking"
								color="primary"
								checked={!!(value.vehicle_type[key] && value.vehicle_type[key].visible)}
								onChange={e => updateVehicleType(key, { visible: e.target.checked }, featureData.vehicle_type[key])}
							/>
							<Checkbox
								title="Visible For Group"
								color="primary"
								checked={!!(value.vehicle_type[key] && value.vehicle_type[key].visible_for_group)}
								onChange={e => updateVehicleType(key, { visible_for_group: e.target.checked }, featureData.vehicle_type[key])}
							/>
							<MuiTextField
								variant="outlined"
								size="small"
								label="Label"
								value={value.vehicle_type[key] ? value.vehicle_type[key].label : featureData.vehicle_type[key].label}
								onChange={e => updateVehicleType(key, { label: e.target.value })}
								disabled={!(value.vehicle_type[key] && value.vehicle_type[key].visible)}
							/>
							<img src={vehicleSvgs[key]} style={{ width: 30, height: 30, marginLeft: 10 , overflow:"visible"}} alt={featureData.vehicle_type[key].label} />
						</div>
					))}
				</div>
			</TabPanel>}

			{value.parking_cost && <TabPanel value={currentTab} index={1}>
				<FormControl fullWidth style={{ marginBottom: 15 }}>
					<InputLabel style={{ top: 12, left: 18, fontSize: "1.05rem" }}>Pricing Model</InputLabel>
					<Select
						variant="filled"
						value={value.parking_cost.cost_model}
						onChange={e => {
							updatePricing(
								{ cost_model: e.target.value },
								{
									normal_daily_pricing: featureData.parking_cost.normal_daily_pricing,
									weekday_pricing: JSON.parse(JSON.stringify(featureData.parking_cost.normal_daily_pricing)),
									weekend_pricing: JSON.parse(JSON.stringify(featureData.parking_cost.normal_daily_pricing)),
									day_night_pricing: { day_start_time: "10:00:00", day_pricing: JSON.parse(JSON.stringify(featureData.parking_cost.normal_daily_pricing)), night_start_time: "22:56:00", night_pricing: JSON.parse(JSON.stringify(featureData.parking_cost.normal_daily_pricing)) }
								});
							setCurrentCostModel(costModelKey[e.target.value]);
						}}
						className="largeDropDown"
					>
						<MenuItem value="Normal Daily Pricing">Normal Daily Pricing</MenuItem>
						<MenuItem value="Weekday Weekend Pricing">Weekday Weekend Pricing</MenuItem>
						<MenuItem value="Day Night Pricing">Day Night Pricing</MenuItem>
					</Select>
				</FormControl>

				{value.parking_cost.cost_model === "Weekday Weekend Pricing" && <AppBar position="static" color="secondary" style={{ width: "100%" }}>
					<Tabs value={currentCostModel} onChange={(event, newValue) => setCurrentCostModel(newValue)}>
						<Tab label="Weekday" value="weekday_pricing" />
						<Tab label="Weekend" value="weekend_pricing" />
					</Tabs>
				</AppBar>}

				{value.parking_cost.cost_model === "Day Night Pricing" && <>
					<div style={{ display: "flex", columnGap: 20, margin: "10px 0 20px" }}>
						<TimeInputField
							variant="outlined"
							label="Day Start Time"
							value={value.parking_cost.day_night_pricing.day_start_time}
							onChange={e => updatePricing({ day_night_pricing: { ...value.parking_cost.day_night_pricing, "day_start_time": e.target.value } })}
							onBlur={e => updatePricing({ day_night_pricing: { ...value.parking_cost.day_night_pricing, "day_start_time": "00:00:00" } })}
						/>

						<TimeInputField
							variant="outlined"
							label="Night Start Time"
							value={value.parking_cost.day_night_pricing.night_start_time}
							onChange={e => updatePricing({ day_night_pricing: { ...value.parking_cost.day_night_pricing, "night_start_time": e.target.value } })}
							onBlur={e => updatePricing({ day_night_pricing: { ...value.parking_cost.day_night_pricing, "night_start_time": "00:00:00" } })}
						/>
					</div>

					<AppBar position="static" color="secondary" style={{ width: "100%" }}>
						<Tabs value={currentCostModel} onChange={(event, newValue) => setCurrentCostModel(newValue)}>
							<Tab label="Day" value="day_pricing" />
							<Tab label="Night" value="night_pricing" />
						</Tabs>
					</AppBar>
				</>}

				{currentCostModel && (value.parking_cost.cost_model === "Day Night Pricing" ?
					(value.parking_cost.day_night_pricing[currentCostModel] &&
						<PricingModelForm
							vehicleTypes={value.vehicle_type}
							pricingModel={value.parking_cost.day_night_pricing[currentCostModel]}
							updateDailyPricing={updateDayNightPricing}
						/>
					)
					:
					(value.parking_cost[currentCostModel] &&
						<PricingModelForm
							vehicleTypes={value.vehicle_type}
							pricingModel={value.parking_cost[currentCostModel]}
							updateDailyPricing={updateDailyPricing}
						/>
					)
				)}
				
				<Accordion expanded={!!value.parking_cost.discount && value.parking_cost.discount?.enabled}>
					<AccordionSummary style={{ cursor: "default" }}>
						<FormControlLabel
							checked={!!value.parking_cost.discount && value.parking_cost.discount.enabled}
							onChange={e => updatePricing({ discount: { enabled: e.target.checked, manual: { enabled: false }, fixed: { enabled: false, amount: 0 } } })}
							control={<Checkbox />}
							label="Discount"
						/>
					</AccordionSummary>
					<AccordionDetails style={{ flexDirection:"column", paddingBottom: 20 }}>
						<div style={{ display: "grid", gridTemplateColumns: "45% 46%", gridColumnGap: 20, justifyContent: "space-between" }}>
						<FormControlLabel
							checked={!!value.parking_cost.discount && !!value.parking_cost.discount?.manual && value.parking_cost.discount.manual?.enabled}
							onChange={e => updatePricing({ discount: { ...value.parking_cost.discount, manual: { enabled: true }, fixed: { enabled: false, amount: 0 } } })}
							control={<Checkbox />}
							label="Manual"
						/>

						<FormControlLabel
							checked={!!value.parking_cost.discount && !!value.parking_cost.discount?.fixed && value.parking_cost.discount.fixed?.enabled}
							onChange={e => updatePricing({ discount: { ...value.parking_cost.discount, manual: { enabled: false }, fixed: { enabled: true, amount: 0 } } })}
							control={<Checkbox />}
							label="Fixed"
						/>

						<FormControlLabel
							checked={!!value.parking_cost.discount && !!value.parking_cost.discount?.entry && value.parking_cost.discount.entry?.enabled}
							onChange={e => updatePricing({ discount: { ...value.parking_cost.discount, entry: { enabled: e.target.checked}}})}
							control={<Checkbox />}
							label="Entry"
						/>

						<FormControlLabel
							checked={!!value.parking_cost.discount && !!value.parking_cost.discount?.exit && value.parking_cost.discount.exit?.enabled}
							onChange={e => updatePricing({ discount: { ...value.parking_cost.discount, exit: { enabled: e.target.checked } } })}
							control={<Checkbox />}
							label="Exit"
						/>
						</div>

							{value.parking_cost && value.parking_cost.discount && value.parking_cost.discount.fixed?.enabled &&
								<div>
									<MuiTextField
									variant="outlined"
									size="small"
									placeholder="Percentage"
									value={value.parking_cost && value.parking_cost.discount.fixed && value.parking_cost.discount.fixed.amount ? value.parking_cost.discount.fixed.amount : ""}
									onChange={e => updatePricing({ discount: { ...value.parking_cost.discount, manual: { enabled: false }, fixed: { enabled: true, amount: parseFloat(e.target.value) } } })}
									style={{ marginTop: 20 }}
								/>
								</div>
							}

						<div style={{marginTop: 20}}>
							<Typography style={{ color: customTheme.palette.secondary }}>Payment Modes</Typography>

							<div>
								{
									value.parking_cost && value.parking_cost.discount &&
									Object.keys(
										value.parking_cost.discount.discount_payment_modes ?
											value.parking_cost.discount.discount_payment_modes
											: discountPaymentModes
									).map((paymentModes) => {
										return <FormControlLabel
											checked={!!value.parking_cost.discount && value.parking_cost.discount.discount_payment_modes && value.parking_cost.discount.discount_payment_modes[paymentModes]}
											onChange={e => {
												updatePricing({ discount: { ...value.parking_cost.discount, discount_payment_modes: { ...discountPaymentModes, ...value.parking_cost.discount.discount_payment_modes, [paymentModes]: e.target.checked } } })
											}}
											control={<Checkbox />}
											label={paymentModes}
										/>
									})
								}
							</div>
						</div>
						
					</AccordionDetails>
				</Accordion>
			</TabPanel>}

			{value.receipt && <TabPanel value={currentTab} index={2}>
				<FormControlLabel
					checked={value.receipt.enabled}
					onChange={e => updateReceipt({ enabled: e.target.checked })}
					control={<Checkbox />}
					label="Enabled"
				/>
				{value.receipt.enabled && <div>
					<div style={{ display: "grid", gridTemplateColumns: "67% 30%", justifyContent: "space-between", margin: "20px 0" }}>
						<div>
							<div style={{ display: "flex", justifyContent: "space-between", marginBottom: 7, alignItems: "center" }}>
								<Typography style={{ fontSize: "1.4rem", color: customTheme.palette.secondary }}>Header Details</Typography>
								<IconButton onClick={e => addReceiptText("header")} style={{ padding: 8 }}><AddIcon style={{ fontSize: 30 }} /></IconButton>
							</div>
							{value.receipt.header.map((line, index) => (
								<div
									key={index}
									className={classes.receiptTextContainer}
									onContextMenu={e => openReceiptTextMenu(e, "header", index)}
									style={currentReceiptText && currentReceiptText.type === "header" && currentReceiptText.index === index ? { backgroundColor: "#336DAE20" } : null}>
									<div>
										<div style={{ display: "grid", gridAutoFlow: "column", gridColumnGap: 10 }}>
											<div>
												<Typography style={{ fontSize: "0.84rem", marginBottom: 6, color: "#555" }}>Text {index + 1}</Typography>
												<MuiTextField
													variant="outlined"
													size="small"
													value={line.text}
													onChange={e => updateReceiptText("header", index, "text", e.target.value)}
												/>
											</div>
											<div>
												<Typography style={{ fontSize: "0.84rem", marginBottom: 6, color: "#555" }}>Font Size</Typography>
												<Select
													variant="outlined"
													classes={{ root: classes.smallSelectRoot }}
													value={line.size}
													onChange={e => updateReceiptText("header", index, "size", e.target.value)}
												>
													{[1, 2, 3, 4, 5].map(size => (
														<MenuItem key={size} value={size}>{size}</MenuItem>
													))}
												</Select>
											</div>
											<div>
												<Typography style={{ fontSize: "0.84rem", marginBottom: 6, color: "#555" }}>Font Style</Typography>
												<div style={{ display: "flex", alignItems: "center" }}>
													<CheckIconButton checked={line.bold} onClick={e => updateReceiptText("header", index, "bold", !line.bold)}>
														<FormatBoldIcon />
													</CheckIconButton>
													<CheckIconButton checked={line.underline} onClick={e => updateReceiptText("header", index, "underline", !line.underline)}>
														<FormatUnderlinedIcon />
													</CheckIconButton>
													<Select
														variant="outlined"
														value={line.alignment}
														onChange={e => updateReceiptText("header", index, "alignment", e.target.value)}
														className="noOutlineDropDown"
													>
														<MenuItem value="LEFT"><FormatAlignLeftIcon /></MenuItem>
														<MenuItem value="CENTER"><FormatAlignCenterIcon /></MenuItem>
														<MenuItem value="RIGHT"><FormatAlignRightIcon /></MenuItem>
													</Select>
												</div>
											</div>
											<div>
												<Typography style={{ fontSize: "0.84rem", marginBottom: 6, color: "#555" }}>Grayscale</Typography>
												<Select
													variant="outlined"
													classes={{ root: classes.smallSelectRoot }}
													value={line.grayscale}
													onChange={e => updateReceiptText("header", index, "grayscale", e.target.value)}
												>
													{[1, 2].map(size => (
														<MenuItem key={size} value={size}>{size}</MenuItem>
													))}
												</Select>
											</div>
										</div>
										<div>
											<div style={{ display: "flex", marginTop: 15 }}>
												<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 15px 7px 0" }}>Print During:</Typography>
												<FormControlLabel
													checked={line.entry}
													onChange={e => updateReceiptText("header", index, "entry", e.target.checked)}
													control={<Checkbox size="small" />}
													label="Entry"
												/>
												<FormControlLabel
													checked={line.exit}
													onChange={e => updateReceiptText("header", index, "exit", e.target.checked)}
													control={<Checkbox size="small" />}
													label="Exit"
												/>
											</div>
											<div style={{ display: "flex" }}>
												<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Single Entry:</Typography>
												<Checkbox size="small" checked={line.single_entry === undefined || line.single_entry === true} onChange={e => updateReceiptText("header", index, "single_entry", e.target.checked)} />
											</div>
											<div style={{ display: "flex" }}>
												<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Day Pass:</Typography>
												<Checkbox size="small" checked={line.day_pass === undefined || line.day_pass === true} onChange={e => updateReceiptText("header", index, "day_pass", e.target.checked)} />
											</div>
											{value.nfc && value.nfc.enabled && value.nfc.monthly_pass && <>
												<div style={{ display: "flex" }}>
													<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Monthly Pass Issue:</Typography>
													<Checkbox size="small" checked={line.monthly_pass_issue === undefined || line.monthly_pass_issue === true} onChange={e => updateReceiptText("header", index, "monthly_pass_issue", e.target.checked)} />
												</div>
												<div style={{ display: "flex" }}>
													<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Monthly Pass Recharge:</Typography>
													<Checkbox size="small" checked={line.monthly_pass_recharge === undefined || line.monthly_pass_recharge === true} onChange={e => updateReceiptText("header", index, "monthly_pass_recharge", e.target.checked)} />
												</div>
												<div style={{ display: "flex" }}>
													<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Monthly Pass Entry:</Typography>
													<Checkbox size="small" checked={line.monthly_pass_entry === undefined || line.monthly_pass_entry === true} onChange={e => updateReceiptText("header", index, "monthly_pass_entry", e.target.checked)} />
												</div>
												<div style={{ display: "flex" }}>
													<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Monthly Pass Exit:</Typography>
													<Checkbox size="small" checked={line.monthly_pass_exit === undefined || line.monthly_pass_exit === true} onChange={e => updateReceiptText("header", index, "monthly_pass_exit", e.target.checked)} />
												</div>
											</>}
											{value.parking_cost.cost_model === "Weekday Weekend Pricing" && <div style={{ display: "flex" }}>
												<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Weekday:</Typography>
												<Checkbox size="small" checked={line.weekday === undefined || line.weekday === true} onChange={e => updateReceiptText("header", index, "weekday", e.target.checked)} />

												<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 25px" }}>Weekend:</Typography>
												<Checkbox size="small" checked={line.weekend === undefined || line.weekend === true} onChange={e => updateReceiptText("header", index, "weekend", e.target.checked)} />
											</div>}
											<div style={{ display: "flex" }}>
												<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 15px 7px 0" }}>Print On:</Typography>
												<div>
													<RadioGroup
														row
														value={line.all_vehicles}
														onChange={e => updateReceiptText("header", index, "all_vehicles", e.target.value === "true")}
													>
														<FormControlLabel value={true} control={<Radio size="small" />} label="All Vehicles" />
														<FormControlLabel value={false} control={<Radio size="small" />} label="Custom" />
													</RadioGroup>
													<div style={{ display: "grid", gridTemplateColumns: "33% 33% 33%", width: 460 }}>
														{!line.all_vehicles && Object.keys(value.vehicle_type).map(key => (value.vehicle_type[key].visible &&
															<FormControlLabel
																key={key}
																checked={line[value.vehicle_type[key].name]}
																onChange={e => updateReceiptText("header", index, value.vehicle_type[key].name, e.target.checked)}
																control={<Checkbox size="small" />}
																label={value.vehicle_type[key].label}
															/>
														))}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							))}
							{value.receipt.header.length === 0 && <Typography style={{ color: "#484848" }}>No Data</Typography>}


							<div style={{ display: "flex", justifyContent: "space-between", margin: "60px 0 7px", alignItems: "center" }}>
								<Typography style={{ fontSize: "1.4rem", color: customTheme.palette.secondary }}>Footer Details</Typography>
								<IconButton onClick={e => addReceiptText("footer")} style={{ padding: 8 }}><AddIcon style={{ fontSize: 30 }} /></IconButton>
							</div>
							{value.receipt.footer.map((line, index) => (
								<div key={index} className={classes.receiptTextContainer} onContextMenu={e => openReceiptTextMenu(e, "footer", index)}>
									<div>
										<div style={{ display: "grid", gridAutoFlow: "column", gridColumnGap: 10 }}>
											<div>
												<Typography style={{ fontSize: "0.84rem", marginBottom: 6, color: "#555" }}>Text {index + 1}</Typography>
												<MuiTextField
													variant="outlined"
													size="small"
													value={line.text}
													onChange={e => updateReceiptText("footer", index, "text", e.target.value)}
												/>
											</div>
											<div>
												<Typography style={{ fontSize: "0.84rem", marginBottom: 6, color: "#555" }}>Font Size</Typography>
												<Select
													variant="outlined"
													classes={{ root: classes.smallSelectRoot }}
													value={line.size}
													onChange={e => updateReceiptText("footer", index, "size", e.target.value)}
												>
													{[1, 2, 3, 4, 5].map(size => (
														<MenuItem key={size} value={size}>{size}</MenuItem>
													))}
												</Select>
											</div>
											<div>
												<Typography style={{ fontSize: "0.84rem", marginBottom: 6, color: "#555" }}>Font Style</Typography>
												<div style={{ display: "flex", alignItems: "center" }}>
													<CheckIconButton checked={line.bold} onClick={e => updateReceiptText("footer", index, "bold", !line.bold)}>
														<FormatBoldIcon />
													</CheckIconButton>
													<CheckIconButton checked={line.underline} onClick={e => updateReceiptText("footer", index, "underline", !line.underline)}>
														<FormatUnderlinedIcon />
													</CheckIconButton>
													<Select
														variant="outlined"
														value={line.alignment}
														onChange={e => updateReceiptText("footer", index, "alignment", e.target.value)}
														className="noOutlineDropDown"
													>
														<MenuItem value="LEFT"><FormatAlignLeftIcon /></MenuItem>
														<MenuItem value="CENTER"><FormatAlignCenterIcon /></MenuItem>
														<MenuItem value="RIGHT"><FormatAlignRightIcon /></MenuItem>
													</Select>
												</div>
											</div>
											<div>
												<Typography style={{ fontSize: "0.84rem", marginBottom: 6, color: "#555" }}>Grayscale</Typography>
												<Select
													variant="outlined"
													classes={{ root: classes.smallSelectRoot }}
													value={line.grayscale}
													onChange={e => updateReceiptText("footer", index, "grayscale", e.target.value)}
												>
													{[1, 2].map(size => (
														<MenuItem key={size} value={size}>{size}</MenuItem>
													))}
												</Select>
											</div>
										</div>
										<div>
											<div style={{ display: "flex", marginTop: 15 }}>
												<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 15px 7px 0" }}>Print During:</Typography>
												<FormControlLabel
													checked={line.entry}
													onChange={e => updateReceiptText("footer", index, "entry", e.target.checked)}
													control={<Checkbox size="small" />}
													label="Entry"
												/>
												<FormControlLabel
													checked={line.exit}
													onChange={e => updateReceiptText("footer", index, "exit", e.target.checked)}
													control={<Checkbox size="small" />}
													label="Exit"
												/>
											</div>
											<div style={{ display: "flex" }}>
												<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Single Entry:</Typography>
												<Checkbox size="small" checked={line.single_entry === undefined || line.single_entry === true} onChange={e => updateReceiptText("footer", index, "single_entry", e.target.checked)} />
											</div>
											<div style={{ display: "flex" }}>
												<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Day Pass:</Typography>
												<Checkbox size="small" checked={line.day_pass === undefined || line.day_pass === true} onChange={e => updateReceiptText("footer", index, "day_pass", e.target.checked)} />
											</div>
											{value.nfc && value.nfc.enabled && value.nfc.monthly_pass && <>
												<div style={{ display: "flex" }}>
													<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Monthly Pass Issue:</Typography>
													<Checkbox size="small" checked={line.monthly_pass_issue === undefined || line.monthly_pass_issue === true} onChange={e => updateReceiptText("footer", index, "monthly_pass_issue", e.target.checked)} />
												</div>
												<div style={{ display: "flex" }}>
													<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Monthly Pass Recharge:</Typography>
													<Checkbox size="small" checked={line.monthly_pass_recharge === undefined || line.monthly_pass_recharge === true} onChange={e => updateReceiptText("footer", index, "monthly_pass_recharge", e.target.checked)} />
												</div>
												<div style={{ display: "flex" }}>
													<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Monthly Pass Entry:</Typography>
													<Checkbox size="small" checked={line.monthly_pass_entry === undefined || line.monthly_pass_entry === true} onChange={e => updateReceiptText("footer", index, "monthly_pass_entry", e.target.checked)} />
												</div>
												<div style={{ display: "flex" }}>
													<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Monthly Pass Exit:</Typography>
													<Checkbox size="small" checked={line.monthly_pass_exit === undefined || line.monthly_pass_exit === true} onChange={e => updateReceiptText("footer", index, "monthly_pass_exit", e.target.checked)} />
												</div>
											</>}
											{value.parking_cost.cost_model === "Weekday Weekend Pricing" && <div style={{ display: "flex" }}>
												<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 0" }}>Weekday:</Typography>
												<Checkbox size="small" checked={line.weekday === undefined || line.weekday === true} onChange={e => updateReceiptText("footer", index, "weekday", e.target.checked)} />

												<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 5px 7px 25px" }}>Weekend:</Typography>
												<Checkbox size="small" checked={line.weekend === undefined || line.weekend === true} onChange={e => updateReceiptText("footer", index, "weekend", e.target.checked)} />
											</div>}
											<div style={{ display: "flex" }}>
												<Typography style={{ fontSize: "0.84rem", color: "#555", padding: "7px 15px 7px 0" }}>Print On:</Typography>
												<div>
													<RadioGroup
														row
														value={line.all_vehicles}
														onChange={e => updateReceiptText("footer", index, "all_vehicles", e.target.value === "true")}
													>
														<FormControlLabel value={true} control={<Radio size="small" />} label="All Vehicles" />
														<FormControlLabel value={false} control={<Radio size="small" />} label="Custom" />
													</RadioGroup>
													<div style={{ display: "grid", gridTemplateColumns: "33% 33% 33%", width: 460 }}>
														{!line.all_vehicles && Object.keys(value.vehicle_type).map(key => (value.vehicle_type[key].visible &&
															<FormControlLabel
																key={key}
																checked={line[value.vehicle_type[key].name]}
																onChange={e => updateReceiptText("footer", index, value.vehicle_type[key].name, e.target.checked)}
																control={<Checkbox size="small" />}
																label={value.vehicle_type[key].label}
															/>
														))}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							))}
							{value.receipt.footer.length === 0 && <Typography style={{ color: "#484848" }}>No Data</Typography>}

							<Menu
								anchorReference="anchorPosition"
								anchorPosition={receiptMenuAnchor.mouseY !== null && receiptMenuAnchor.mouseX !== null ? { top: receiptMenuAnchor.mouseY, left: receiptMenuAnchor.mouseX } : { top: 0, left: 0 }}
								keepMounted
								open={Boolean(receiptMenuAnchor.mouseX)}
								onClose={closeReceiptTextMenu}
							>
								<MenuItem onClick={moveUpReceiptText} disabled={currentReceiptText && currentReceiptText.index === 0}>Move Up</MenuItem>
								<MenuItem onClick={moveDownReceiptText} disabled={currentReceiptText && currentReceiptText.index === value.receipt[currentReceiptText.type].length - 1}>Move Down</MenuItem>
								<Divider />
								<MenuItem onClick={duplicateReceiptText}>Duplicate</MenuItem>
								<MenuItem onClick={removeReceiptText}>Delete</MenuItem>
							</Menu>
						</div>
						<div id="receipt-preview" style={{ position: "sticky", top: 80, alignSelf: "flex-start" }}>
							<Typography style={{ fontSize: "1.4rem", color: customTheme.palette.secondary }}>Receipt Preview</Typography>
							<div style={{ display: 'grid', gridTemplateColumns: "47% 47%", justifyContent: "space-between", marginTop: 20 }}>
								<FormControl variant="outlined">
									<InputLabel>Receipt Time</InputLabel>
									<Select
										variant="outlined"
										classes={{ root: classes.smallSelectRoot }}
										value={previewReceiptTime}
										onChange={e => setPreviewReceiptTime(e.target.value)}
										label="Receipt Time"
									>
										<MenuItem value="entry">Entry</MenuItem>
										<MenuItem value="exit">Exit</MenuItem>
										<MenuItem value="day_pass">Day Pass</MenuItem>
									</Select>
								</FormControl>
								<FormControl variant="outlined">
									<InputLabel>Vehicle Type</InputLabel>
									<Select
										variant="outlined"
										classes={{ root: classes.smallSelectRoot }}
										value={previewReceiptVehicleType}
										onChange={e => setPreviewReceiptVehicleType(e.target.value)}
										label="Vehicle Type"
									>
										{Object.keys(value.vehicle_type).map(key => (value.vehicle_type[key].visible &&
											<MenuItem key={key} value={value.vehicle_type[key].name}>{value.vehicle_type[key].label}</MenuItem>
										))}
									</Select>
								</FormControl>
							</div>

							<div style={{ backgroundColor: "#eee", padding: "25px 0", margin: "25px 15px"}}>
								<div style={{ backgroundColor: "#eee", padding: "25px 20px", borderColor: customTheme.palette.primary.main, borderStyle: "dashed", borderWidth: "3px 0" }}>
									{value.receipt.header.map((textObj, index) => (textObj[previewReceiptTime] && (textObj.all_vehicles || textObj[previewReceiptVehicleType]) &&
										<div
											key={index}
											style={{
												textAlign: textObj.alignment,
												fontWeight: textObj.bold ? "bold" : "normal",
												fontSize: `${(textObj.size * 5.6) + 5}px`,
												textDecorationLine: textObj.underline ? "underline" : "none",
												marginBottom: 7,
											}}
										>
											{textObj.text}
										</div>
									))}

									<div style={{ margin: "27px 0" }}>
										{["70%", "50%", "90%", "45%", "65%"].map((width, index) => (
											<div
												key={index}
												style={{ margin: "10px auto", width, height: 21, backgroundColor: "#ddd", borderRadius: 5 }}
											/>
										))}
									</div>

									{value.receipt.footer.map((textObj, index) => (textObj[previewReceiptTime] && (textObj.all_vehicles || textObj[previewReceiptVehicleType]) &&
										<div
											key={index}
											style={{
												textAlign: textObj.alignment,
												fontWeight: textObj.bold ? "bold" : "normal",
												fontSize: `${(textObj.size * 5.6) + 5}px`,
												textDecorationLine: textObj.underline ? "underline" : "none",
												marginBottom: 3,
											}}
										>
											{textObj.text}
										</div>
									))}
								</div>
							</div>
						</div>
					</div>

					<Typography style={{ fontSize: "1.4rem", color: customTheme.palette.secondary }}>Receipt Manager</Typography>
					<div style={{ display: "flex", alignItems: "center", margin: "10px 0 45px" }}>
						<FormControl variant="outlined">
							<InputLabel>Select Property</InputLabel>
							<Select
								variant="outlined"
								value={receiptProperty}
								onChange={e => setReceiptProperty(e.target.value)}
								label="Select Property"
								style={{ minWidth: 300, textTransform: "capitalize" }}
							>
								{availableReceiptProperties.sort().map((property, index) => (
									<MenuItem key={index} value={property} style={{ textTransform: "capitalize" }}>{property.replace(/_/g, " ")}</MenuItem>
								))}
							</Select>
						</FormControl>
						<Button
							variant="contained"
							color="secondary"
							startIcon={<AddIcon />}
							onClick={e => updateReceiptProperty(receiptProperty, parkingReceiptProperties[receiptProperty])}
							style={{ marginLeft: 20, padding: "11px 21px", fontSize: "0.95rem" }}
						>
							Add
						</Button>
					</div>

					<div style={{ display: "grid", gridTemplateColumns: "45% 45% 8%", alignItems: "center", justifyContent: "space-between", gridColumnGap: 25, gridRowGap: 15, width: "max-content" }}>
						{Object.keys(value.receipt).filter(property => !["enabled", "header", "footer"].includes(property)).sort().map((property, index) => (value.receipt[property] != null &&
							<React.Fragment key={index}>
								<Typography style={{ textTransform: "capitalize" }}>{property.replace(/_/g, " ")}:</Typography>
								<div>
									{typeof value.receipt[property] === "number" &&
										<MuiTextField
											variant="outlined"
											size="small"
											value={value.receipt[property] >= 0 ? value.receipt[property] : ""}
											onChange={e => updateReceiptNumberProperty(property, e.target.value)}
										/>
									}
									{typeof value.receipt[property] === "string" &&
										<MuiTextField
											variant="outlined"
											size="small"
											value={value.receipt[property]}
											onChange={e => updateReceiptProperty(property, e.target.value)}
										/>
									}
									{typeof value.receipt[property] !== "string" && typeof value.receipt[property] !== "number" &&
										<Checkbox
											color="primary"
											checked={value.receipt[property]}
											onChange={e => updateReceiptProperty(property, e.target.checked)}
										/>
									}
								</div>
								<div>
									<IconButton onClick={e => removeReceiptProperty(property)}>
										<DeleteIcon />
									</IconButton>
								</div>
							</React.Fragment>
						))}
					</div>
				</div>}
			</TabPanel>}

			{value.parking_manager && <TabPanel value={currentTab} index={3}>
				<div style={{ display: "flex", alignItems: "center", margin: "10px 0 45px" }}>
					<FormControl variant="outlined">
						<InputLabel>Select Property</InputLabel>
						<Select
							variant="outlined"
							value={newProperty}
							onChange={e => setNewProperty(e.target.value)}
							label="Select Property"
							style={{ minWidth: 300, textTransform: "capitalize" }}
						>
							{availableProperties.sort().map((property, index) => (
								<MenuItem key={index} value={property} style={{ textTransform: "capitalize" }}>{property.replace(/_/g, " ")}</MenuItem>
							))}
						</Select>
					</FormControl>
					<Button
						variant="contained"
						color="secondary"
						startIcon={<AddIcon />}
						onClick={e => updateConfigurationProperty(newProperty, parkingConfigurationProperties[newProperty])}
						style={{ marginLeft: 20, padding: "11px 21px", fontSize: "0.95rem" }}
					>
						Add
					</Button>
				</div>

				<div style={{ display: "grid", gridTemplateColumns: "25% 65% 8%", alignItems: "flex-start", justifyContent: "space-between", gridColumnGap: 20, gridRowGap: 15, width: "100%" }}>
					{Object.keys(value.parking_manager).sort().map((property, index) => {
						return <React.Fragment key={index}>
							<Typography style={{ textTransform: "capitalize" }}>{property.replace(/_/g, " ")}:</Typography>
							<div style={typeof value.parking_manager[property] === "object" && !Array.isArray(value.parking_manager[property]) ? { display: "grid", gridTemplateColumns: "45% 45%", alignItems: "flex-start", justifyContent: "space-between", gridColumnGap: 10, gridRowGap: 5, width: "500px", backgroundColor: "#f5f5f5", padding: "10px 15px", borderRadius: 10 } : null}>
								{typeof value.parking_manager[property] === "number" &&
									<MuiTextField
										variant="outlined"
										size="small"
										value={value.parking_manager[property] >= 0 ? value.parking_manager[property] : ""}
										onChange={e => updateNumberProperty(property, e.target.value)}
									/>
								}
								{typeof value.parking_manager[property] === "string" &&
									<MuiTextField
										variant="outlined"
										size="small"
										value={value.parking_manager[property]}
										onChange={e => updateConfigurationProperty(property, e.target.value)}
									/>
								}
								{value.parking_manager[property] != null && typeof value.parking_manager[property] === "object" && !Array.isArray(value.parking_manager[property]) &&
									Object.keys(value.parking_manager[property]).sort().map((subProperty, subIndex) => (
										<React.Fragment key={subIndex}>
											<Typography style={{ textTransform: "capitalize" }}>{subProperty.replace(/_/g, " ")}:</Typography>
											<div>
												{typeof value.parking_manager[property][subProperty] === "number" &&
													<MuiTextField
														variant="outlined"
														size="small"
														value={value.parking_manager[property][subProperty] >= 0 ? value.parking_manager[property][subProperty] : ""}
														onChange={e => updateSubNumberProperty(property, subProperty, e.target.value)}
													/>
												}
												{typeof value.parking_manager[property][subProperty] === "string" &&
													<MuiTextField
														variant="outlined"
														size="small"
														value={value.parking_manager[property][subProperty]}
														onChange={e => updateSubConfigurationProperty(property, subProperty, e.target.value)}
													/>
												}
												<div>
													{typeof value.parking_manager[property][subProperty] === "object" && Array.isArray(value.parking_manager[property][subProperty]) &&
														Object.keys(value.parking_manager[property][subProperty]).map((sub, innerSubIndex) => (
															<div style={{ display: 'flex' }}>
																{value.parking_manager[property]["holidays"] ?
																<HolidaysDateTimeInputField
																	variant="outlined"
																	size="small"
																	value={value.parking_manager[property][subProperty][sub]}
																	onChange={e => updateInnerSubConfigurationProperty(property, subProperty, sub, e.target.value)}
																	onBlur={e => updateInnerSubConfigurationProperty(property, subProperty, sub, e.target.value)}
																/>
																:
																<MuiTextField
																	variant="outlined"
																	size="small"
																	value={value.parking_manager[property][subProperty][sub]}
																	onChange={e => updateInnerSubConfigurationProperty(property, subProperty, sub, e.target.value)}
																/>
																}
																<IconButton onClick={() => removeInnerSubArrayConfigurationProperty(property, subProperty, innerSubIndex)}>
																	<CloseIcon />
																</IconButton>
															</div>
														))}
													{Array.isArray(value.parking_manager[property][subProperty]) &&
														<Button
															variant="outlined"
															style={{ backgroundColor: "#f5f5f5", display: "block", height: 30, fontSize: 12 }}
															onClick={() => addInnerSubArrayConfigurationProperty(property, subProperty)}
														>
															Add
														</Button>
													}
												</div>
												{typeof value.parking_manager[property][subProperty] !== "string" && typeof value.parking_manager[property][subProperty] !== "number" && !Array.isArray(value.parking_manager[property][subProperty]) &&
													<Checkbox
														color="primary"
														checked={value.parking_manager[property][subProperty]}
														onChange={e => updateSubConfigurationProperty(property, subProperty, e.target.checked)}
													/>
												}
											</div>
										</React.Fragment>
									))
								}
								{typeof value.parking_manager[property] === "object" && Array.isArray(value.parking_manager[property]) &&
									<div>
										{value.parking_manager[property].map((subObject, subIndex) => (
											<div key={subIndex} style={{ display: "flex", columnGap: 20, alignItems: "center", justifyContent: "flex-start", marginBottom: 15 }}>
												{subObject != null && typeof subObject === "object" && !Array.isArray(subObject) &&
													Object.keys(subObject).map((subObjectKey, subObjectIndex) => (
														typeof subObject[subObjectKey] === "number" ?
															<MuiTextField
																key={subObjectKey}
																variant="outlined"
																size="small"
																label={subObjectKey}
																value={subObject[subObjectKey] >= 0 ? subObject[subObjectKey] : ""}
																onChange={e => updateSubArrayNumberProperty(property, subIndex, subObjectKey, e.target.value)}
															/>
															:
															<MuiTextField
																key={subObjectKey}
																variant="outlined"
																size="small"
																label={subObjectKey}
																value={subObject[subObjectKey]}
																onChange={e => updateSubArrayConfigurationProperty(property, subIndex, subObjectKey, e.target.value)}
															/>
													))
												}
												<IconButton onClick={() => removeSubArrayConfigurationProperty(property, subIndex)}>
													<CloseIcon />
												</IconButton>
											</div>
										))}
										<Button
											variant="outlined"
											startIcon={<AddIcon />}
											style={{ backgroundColor: "#f5f5f5" }}
											onClick={() => addSubArrayConfigurationProperty(property)}
										>
											Add
										</Button>
									</div>
								}
								{typeof value.parking_manager[property] !== "string" && typeof value.parking_manager[property] !== "number" && typeof value.parking_manager[property] !== "object" &&
									<Checkbox
										color="primary"
										checked={value.parking_manager[property]}
										onChange={e => updateConfigurationProperty(property, e.target.checked)}
									/>
								}

							</div>
							<div>
								<IconButton onClick={e => removeConfigurationProperty(property)}>
									<DeleteIcon />
								</IconButton>
							</div>
						</React.Fragment>
					})}
				</div>
			</TabPanel >}

			<TabPanel value={currentTab} index={4}>
				<div style={{ marginBottom: 15 }}>
					<FormControlLabel
						checked={value.billings && value.billings.enabled}
						onChange={e => updateRootKey(
							"billings",
							{ enabled: e.target.checked },
							featureData.billings,
						)}
						control={<Checkbox />}
						label="Enabled"
					/>
				</div>
				<div>
					<MuiTextField
						variant="outlined"
						size="small"
						label="Parking AMC Cost"
						value={value.billings ? value.billings.parking_amc_cost : ""}
						onChange={e => updateRootKey("billings", { parking_amc_cost: e.target.value })}
						onBlur={e => updateRootKey("billings", { parking_amc_cost: isNaN(e.target.value) ? "" : parseFloat(e.target.value) })}
						disabled={!(value.billings && value.billings.enabled)}
					/>
				</div>
				<div style={{marginTop: 15}}>
					<MuiTextField
						variant="outlined"
						size="small"
						label="Permit Per User Cost"
						value={value.billings ? value.billings.permit_per_user_cost : ""}
						onChange={e => updateRootKey("billings", { permit_per_user_cost: e.target.value })}
						onBlur={e => updateRootKey("billings", { permit_per_user_cost: isNaN(e.target.value) ? "" : parseFloat(e.target.value) })}
						disabled={!(value.billings && value.billings.enabled)}
					/>
				</div>
			</TabPanel>

			<TabPanel value={currentTab} index={5}>
				<div style={{ marginBottom: 15 }}>
					<FormControlLabel
						checked={value.password && value.password.enabled}
						onChange={e => updateRootKey(
							"password",
							{ enabled: e.target.checked },
							featureData.password,
						)}
						control={<Checkbox />}
						label="Enabled"
					/>
				</div>
				<MuiTextField
					variant="outlined"
					size="small"
					label="Password"
					value={value.password ? value.password.password : "1234"}
					onChange={e => updateRootKey("password", { password: e.target.value })}
					disabled={!(value.password && value.password.enabled)}
				/>
			</TabPanel>

			<TabPanel value={currentTab} index={6}>
				<div style={{ marginBottom: 15 }}>
					<FormControlLabel
						checked={value.nfc && value.nfc.enabled}
						onChange={e => updateRootKey(
							"nfc",
							{ enabled: e.target.checked },
							featureData.nfc,
						)}
						control={<Checkbox />}
						label="NFC Enabled"
					/>
				</div>
				<Accordion expanded={value.nfc && value.nfc.monthly_pass}>
					<AccordionSummary style={{ cursor: "default" }}>
						<FormControlLabel
							checked={value.nfc && value.nfc.monthly_pass}
							onChange={e => {
								updateRootKey("nfc", { monthly_pass: e.target.checked })
								if (value.monthly_pass == null)
									updateRootKey("monthly_pass", featureData.monthly_pass)
							}}
							onBlur={e => updateRootKey("monthly_pass", { enabled: e.target.checked})}
							control={<Checkbox />}
							label="Monthly Pass"
						/>
					</AccordionSummary>
					{value.monthly_pass && <AccordionDetails style={{ padding: "8px 45px 16px", display: "block" }}>

						<Typography style={{ marginBottom: 8 }}>NFC Card Charges Scooter</Typography>
						<MuiTextField
							variant="outlined"
							size="small"
							value={value.monthly_pass.nfc_card_charges_scooter}
							onChange={e => {
								if (!isNaN(e.target.value))
									updateRootKey("monthly_pass", { nfc_card_charges_scooter: e.target.value })
							}}
							onBlur={e => updateRootKey("monthly_pass", { nfc_card_charges_scooter: value.monthly_pass.nfc_card_charges_scooter === "" ? 0 : parseFloat(value.monthly_pass.nfc_card_charges_scooter) })}
							style={{ marginBottom: 20 }}
						/>
						<Typography style={{ marginBottom: 8 }}>NFC Card Charges Car</Typography>
						<MuiTextField
							variant="outlined"
							size="small"
							value={value.monthly_pass.nfc_card_charges_car}
							onChange={e => {
								if (!isNaN(e.target.value))
									updateRootKey("monthly_pass", { nfc_card_charges_car: e.target.value })
							}}
							onBlur={e => updateRootKey("monthly_pass", { nfc_card_charges_car: value.monthly_pass.nfc_card_charges_car === "" ? 0 : parseFloat(value.monthly_pass.nfc_card_charges_car) })}
							style={{ marginBottom: 20 }}
						/>
						<Typography style={{ marginBottom: 8 }}>RFID Charges Scooter</Typography>
						<MuiTextField
							variant="outlined"
							size="small"
							value={value.monthly_pass.rfid_charges_scooter}
							onChange={e => {
								if (!isNaN(e.target.value))
									updateRootKey("monthly_pass", { rfid_charges_scooter: e.target.value })
							}}
							onBlur={e => updateRootKey("monthly_pass", { rfid_charges_scooter: value.monthly_pass.rfid_charges_scooter === "" ? 0 : parseFloat(value.monthly_pass.rfid_charges_scooter) })}
							style={{ marginBottom: 20 }}
						/>
						<Typography style={{ marginBottom: 8 }}>RFID Charges Car</Typography>
						<MuiTextField
							variant="outlined"
							size="small"
							value={value.monthly_pass.rfid_charges_car}
							onChange={e => {
								if (!isNaN(e.target.value))
									updateRootKey("monthly_pass", { rfid_charges_car: e.target.value })
							}}
							onBlur={e => updateRootKey("monthly_pass", { rfid_charges_car: value.monthly_pass.rfid_charges_car === "" ? 0 : parseFloat(value.monthly_pass.rfid_charges_car) })}
							style={{ marginBottom: 20 }}
						/>
						<div style={{ display: "flex" }}>
							<FormControlLabel
								checked={value.monthly_pass.gst_enabled}
								onChange={e => updateRootKey("monthly_pass", { gst_enabled: e.target.checked })}
								control={<Checkbox />}
								label="GST"
							/>
							<MuiTextField
								variant="outlined"
								size="small"
								placeholder="Enter GST (in %)"
								value={value.monthly_pass.gst_percentage}
								onChange={e => {
									if (!isNaN(e.target.value))
										updateRootKey("monthly_pass", { gst_percentage: e.target.value })
								}}
								onBlur={e => updateRootKey("monthly_pass", { gst_percentage: value.monthly_pass.gst_percentage === "" ? 0 : parseFloat(value.monthly_pass.gst_percentage) })}
								disabled={!value.monthly_pass.gst_enabled}
							/>
						</div>
						<div>
							<FormControlLabel
								checked={value.monthly_pass.monthly_pass_recharge_enabled}
								onChange={e => updateRootKey("monthly_pass", { monthly_pass_recharge_enabled: e.target.checked })}
								control={<Checkbox />}
								label="Monthly Pass Recharge"
							/>
						</div>

						<Typography style={{ paddingTop: 20 }}>Pass Types</Typography>
						<div style={{ display: "grid", gridRowGap: 20, marginTop: 15 }}>
							{Object.keys(value.vehicle_type).map(key => (value.vehicle_type[key].visible &&
								<div key={key} style={{ borderRadius: 10, border: `1px solid #ccc`, padding: "17px 20px 20px" }}>
									<Typography style={{ fontSize: "1.1rem", marginBottom: 15 }}>{value.vehicle_type[key].label}</Typography>
									<div style={{ display: "grid", gridTemplateColumns: "45% 45% 10%", gap: "12px 22px" }}>
										<Typography style={{ fontSize: "0.84rem", padding: "12px 0", color: "#555" }}>Pass Type</Typography>
										<Typography style={{ fontSize: "0.84rem", padding: "12px 0", color: "#555" }}>Price</Typography>
										<div>
											<IconButton onClick={() => addPassType(value.vehicle_type[key].name)}>
												<AddIcon />
											</IconButton>
										</div>
										{value.monthly_pass.pass_types[value.vehicle_type[key].name] && value.monthly_pass.pass_types[value.vehicle_type[key].name].map((pass, index) => (
											<React.Fragment key={index}>
												<MuiTextField
													variant="outlined"
													size="small"
													placeholder="Enter Pass Type"
													value={pass.type}
													onChange={e => updatePassType(value.vehicle_type[key].name, index, "type", e.target.value)}
												/>
												<MuiTextField
													variant="outlined"
													size="small"
													placeholder="Enter Pass Amount"
													value={pass.price}
													onChange={e => {
														if (!isNaN(e.target.value))
															updatePassType(value.vehicle_type[key].name, index, "price", e.target.value)
													}}
													onBlur={e => updatePassType(value.vehicle_type[key].name, index, "price", pass.price === "" ? 0 : parseFloat(pass.price))}
												/>
												<div>
													<IconButton onClick={() => removePassType(value.vehicle_type[key].name, index)}>
														<CloseIcon />
													</IconButton>
												</div>
											</React.Fragment>
										))}
									</div>
									{value.monthly_pass.pass_types[value.vehicle_type[key].name] && value.monthly_pass.pass_types[value.vehicle_type[key].name].length === 0 && <Typography style={{ fontSize: "1rem", padding: "12px 0", color: "#555", textAlign: "center" }}>No Data</Typography>}
								</div>
							))}
						</div>
					</AccordionDetails>}
				</Accordion>
				<Accordion expanded={false}>
					<AccordionSummary style={{ cursor: "default" }}>
						<FormControlLabel
							checked={value.nfc && value.nfc.daily_pass}
							onChange={e => updateRootKey("nfc", { daily_pass: e.target.checked })}
							control={<Checkbox />}
							label="Daily Pass"
						/>
					</AccordionSummary>
				</Accordion>
				<Accordion expanded={false}>
					<AccordionSummary style={{ cursor: "default" }}>
						<FormControlLabel
							checked={value.nfc && value.nfc.entry_exit}
							onChange={e => updateRootKey("nfc", { entry_exit: e.target.checked })}
							control={<Checkbox />}
							label="Entry Exit"
						/>
					</AccordionSummary>
				</Accordion>
			</TabPanel>

			<TabPanel value={currentTab} index={7}>
				<div style={{ marginBottom: 15 }}>
					<FormControlLabel
						onChange={e => updateRootKey(
							"rfid_manager",
							{ enabled: e.target.checked },
							featureData.rfid_manager,
						)}
						control={<Checkbox checked={value.rfid_manager && value.rfid_manager.enabled} />}
						label="Enabled"
					/>
				</div>
				<Accordion expanded={value.rfid_manager && value.rfid_manager.permit} disabled={!(value.rfid_manager && value.rfid_manager.enabled)}>
					<AccordionSummary style={{ cursor: "default" }}>
						<FormControlLabel
							onChange={e => {
								updateRootKey("rfid_manager", { permit: e.target.checked })
								if (value.permit == null)
									updateRootKey("permit", featureData.permit)
							}}
							control={<Checkbox checked={value.rfid_manager && value.rfid_manager.permit} />}
							label="Permit"
						/>
					</AccordionSummary>
					{value.permit != null && <AccordionDetails style={{ padding: "8px 45px 16px", display: "block" }}>
						<div style={{ display: "grid", gridTemplateColumns: "33% 33% 33%", gridColumnGap: 10, justifyContent: "space-between", alignItems: "center", gridRowGap: 12, paddingBottom: 20 }}>
							{Object.keys(value.vehicle_type).map(key => (value.vehicle_type[key].visible &&
								<div key={key}>
									<Typography>{value.vehicle_type[key].label}</Typography>
									<MuiTextField
										variant="outlined"
										size="small"
										placeholder="Amount"
										value={value.permit.amount[value.vehicle_type[key].name]}
										onChange={e => {
											if (!isNaN(e.target.value))
												updateRootKey("permit", { amount: { ...value.permit.amount, [value.vehicle_type[key].name]: e.target.value } });
										}}
										onBlur={e => updateRootKey("permit", { amount: { ...value.permit.amount, [value.vehicle_type[key].name]: value.permit.amount[value.vehicle_type[key].name] === "" ? 0 : parseFloat(value.permit.amount[value.vehicle_type[key].name]) } })}
									/>
								</div>
							))}
						</div>
						<div style={{ display: "flex", marginTop: 25 }}>
							<FormControlLabel
								onChange={e => updateRootKey("permit", { gst_enabled: e.target.checked })}
								control={<Checkbox checked={value.permit.gst_enabled} />}
								label="GST"
							/>
							<MuiTextField
								variant="outlined"
								size="small"
								placeholder="Enter GST (in %)"
								value={value.permit.gst_percentage}
								onChange={e => {
									if (!isNaN(e.target.value))
										updateRootKey("permit", { gst_percentage: e.target.value })
								}}
								onBlur={e => updateRootKey("permit", { gst_percentage: value.permit.gst_percentage === "" ? 0 : parseFloat(value.permit.gst_percentage) })}
								disabled={!value.permit.gst_enabled}
							/>
						</div>

					</AccordionDetails>}
				</Accordion>
			</TabPanel>

			<TabPanel value={currentTab} index={8}>

				<div style={{ marginTop: 20 }}>
					<Typography style={{ marginBottom: 25, fontWeight: "bold" }}>Parking Configuration</Typography>
					<div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 300px))" }}>

						<FormControlLabel control={<Checkbox
							checked={show_amount_in_crm === 1 ? true : false}
							onChange={(event) => set_show_amount_in_crm(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Show Amount In CRM" />
						<FormControlLabel control={<Checkbox
							checked={category_filter === 1 ? true : false}
							onChange={(event) => set_category_filter(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Category Filter" />
						<FormControlLabel control={<Checkbox
							checked={feature_digital_pay === 1 ? true : false}
							onChange={(event) => set_feature_digital_pay(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Digital Pay" />
						<FormControlLabel control={<Checkbox
							checked={feature_monthly_pass === 1 ? true : false}
							onChange={(event) => set_feature_monthly_pass(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Monthly Pass" />
						<FormControlLabel control={<Checkbox
							checked={separate_summary_of_devices === 1 ? true : false}
							onChange={(event) => set_separate_summary_of_devices(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Separate Summary of Devices" />

						<FormControlLabel control={<Checkbox
							checked={show_anpr_images === 1 ? true : false}
							onChange={(event) => set_show_anpr_images(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Show ANPR Images" />

						<FormControlLabel control={<Checkbox
							checked={show_category_distribution === 1 ? true : false}
							onChange={(event) => set_show_category_distribution(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Show Category Distribution" />
						<FormControlLabel control={<Checkbox
							checked={show_foc_summary === 1 ? true : false}
							onChange={(event) => set_show_foc_summary(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Show FOC Summary" />
						<FormControlLabel control={<Checkbox
							checked={show_not_exited_in_crm === 1 ? true : false}
							onChange={(event) => set_show_not_exited_in_crm(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Show Not Exited In CRM" />
						<FormControlLabel control={<Checkbox
							checked={show_payment_type_summary === 1 ? true : false}
							onChange={(event) => set_show_payment_type_summary(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Show Payment Type Summary" />
						<FormControlLabel control={<Checkbox
							checked={show_violation_details === 1 ? true : false}
							onChange={(event) => set_show_violation_details(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Show Violation Details" />
						<FormControlLabel control={<Checkbox
							checked={use_latest_version === 1 ? true : false}
							onChange={(event) => set_use_latest_version(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Use Latest Version" />
						<FormControlLabel control={<Checkbox
							checked={use_latest_version === 1 ? true : false}
							onChange={(event) => set_use_latest_version(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Use Latest Version" />
						<FormControlLabel control={<Checkbox
							checked={fastag_allow_entry === 1 ? true : false}
							onChange={(event) => set_fastag_allow_entry(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Fastag Allow Entry" />
						<FormControlLabel control={<Checkbox
							checked={fastag_allow_exit === 1 ? true : false}
							onChange={(event) => set_fastag_allow_exit(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Fastag Allow Exit" />
						<FormControlLabel control={<Checkbox
							checked={fastag_allow_chassis === 1 ? true : false}
							onChange={(event) => set_fastag_allow_chassis(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Fastag Allow Chassis" />
						<FormControlLabel control={<Checkbox
							checked={fastag_allow_exit_after_24hrs === 1 ? true : false}
							onChange={(event) => set_fastag_allow_exit_after_24hrs(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Fastag Allow Exit After 24hrs" />
						<FormControlLabel control={<Checkbox
							checked={anpr_allow_entry === 1 ? true : false}
							onChange={(event) => set_anpr_allow_entry(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="ANPR Allow Entry" />
						<FormControlLabel control={<Checkbox
							checked={check_short_vehicle_number === 1 ? true : false}
							onChange={(event) => set_check_short_vehicle_number(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Check Short Vehicle Number" />
						<FormControlLabel control={<Checkbox
							checked={check_similar_vehicle_number === 1 ? true : false}
							onChange={(event) => set_check_similar_vehicle_number(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Check Similar Vehicle Number" />

						<FormControlLabel control={<Checkbox
							checked={is_anpr_only === 1 ? true : false}
							onChange={(event) => set_is_anpr_only(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Is ANPR Only" />

						<FormControlLabel control={<Checkbox
							checked={allow_anpr_rfid_permit === 1 ? true : false}
							onChange={(event) => set_allow_anpr_rfid_permit(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Allow ANPR Permit" />
							
						<FormControlLabel control={<Checkbox
							checked={is_required_parking_slot_number === 1 ? true : false}
							onChange={(event) => set_is_required_parking_slot_number(event.target.checked === true ? 1 : 0)}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Required Parking Slot Number" />

						<FormControlLabel
							control={
								<Checkbox
									checked={allow_permit_sub_types === 1}
									onChange={(event) => set_allow_permit_sub_types(event.target.checked ? 1 : 0)}
								/>
							}
							label="Allow Permit Sub Types"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={fastag_allow_vaahan_api === 1}
									onChange={(event) => set_fastag_allow_vaahan_api(event.target.checked ? 1 : 0)}
								/>
							}
							label="Fastag Allow Vaahan API"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={fastag_allow_new_entries === 1}
									onChange={(event) => set_fastag_allow_new_entries(event.target.checked ? 1 : 0)}
								/>
							}
							label="Fastag Allow New Entries"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={anpr_allow_new_entries === 1}
									onChange={(event) => set_anpr_allow_new_entries(event.target.checked ? 1 : 0)}
								/>
							}
							label="ANPR Allow New Entries"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={use_pass_as_permit === 1}
									onChange={(event) => set_use_pass_as_permit(event.target.checked ? 1 : 0)}
								/>
							}
							label="Use Pass as Permit"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={maruti_integrated === 1}
									onChange={(event) => set_maruti_integrated(event.target.checked ? 1 : 0)}
								/>
							}
							label="Maruti Integrated"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={show_pass_in_vehicle_summary === 1}
									onChange={(event) => set_show_pass_in_vehicle_summary(event.target.checked ? 1 : 0)}
								/>
							}
							label="Show Pass in Vehicle Summary"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={delete_entry_of_pass_vehicle === 1}
									onChange={(event) => set_delete_entry_of_pass_vehicle(event.target.checked ? 1 : 0)}
								/>
							}
							label="Delete Entry of Pass Vehicle"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={allow_pass_update_by_device === 1}
									onChange={(event) => set_allow_pass_update_by_device(event.target.checked ? 1 : 0)}
								/>
							}
							label="Allow Pass Update by Device"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={aeria_integrated === 1}
									onChange={(event) => set_aeria_integrated(event.target.checked ? 1 : 0)}
								/>
							}
							label="Aeria Integrated"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={verify_visitor_vehicle_type === 1}
									onChange={(event) => set_verify_visitor_vehicle_type(event.target.checked ? 1 : 0)}
								/>
							}
							label="Verify Visitor Vehicle Type"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={verify_surveillance_vehicle_type === 1}
									onChange={(event) => set_verify_surveillance_vehicle_type(event.target.checked ? 1 : 0)}
								/>
							}
							label="Verify Surveillance Vehicle Type"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={explicit_anpr_permits === 1}
									onChange={(event) => set_explicit_anpr_permits(event.target.checked ? 1 : 0)}
								/>
							}
							label="Explicit ANPR Permits"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={show_parksmart_tag_type === 1}
									onChange={(event) => set_show_parksmart_tag_type(event.target.checked ? 1 : 0)}
								/>
							}
							label="Show ParkSmart Tag Type"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={show_fastag_type === 1}
									onChange={(event) => set_show_fastag_type(event.target.checked ? 1 : 0)}
								/>
							}
							label="Show Fastag Type"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={show_lf_tag_type === 1}
									onChange={(event) => set_show_lf_tag_type(event.target.checked ? 1 : 0)}
								/>
							}
							label="Show LF Tag Type"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={allow_exit_without_entry === 1}
									onChange={(event) => set_allow_exit_without_entry(event.target.checked ? 1 : 0)}
								/>
							}
							label="Allow Exit Without Entry"
						/>

						<FormControlLabel
							control={
								<Checkbox
									checked={strictly_populate_parksmart_tags === 1}
									onChange={(event) => set_strictly_populate_parksmart_tags(event.target.checked ? 1 : 0)}
								/>
							}
							label="Strictly Populate ParkSmart Tags"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={occupancy_enable === 1}
									onChange={(event) =>
										set_occupancy_enable(event.target.checked ? 1 : 0)
									}
								/>
							}
							label="Occupancy Enable"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={allow_fetch_fastag === 1}
									onChange={(event) =>
										set_allow_fetch_fastag(event.target.checked ? 1 : 0)
									}
								/>
							}
							label="Allow Fetch FASTag"
						/>
					</div>
				</div>

			</TabPanel>
		</>
	);
};

const copyToTypes = [
	{ id: 'Everything', name: 'Everything' },
	{ id: 'Pricing Only', name: 'Pricing Only' },
	{ id: 'Receipt Header Only', name: 'Receipt Header Only' },
	{ id: 'Receipt Footer Only', name: 'Receipt Footer Only' },
	{ id: 'Parking Manager Only', name: 'Parking Manager Only' },
	{ id: 'Receipt Manager Only', name: 'Receipt Manager Only' },
	{ id: 'Vehicle Type Only', name: 'Vehicle Type Only' },
	{ id: 'NFC Monthly Pass Only', name: 'NFC Monthly Pass Only' },
];

export const ParkingEdit = (props) => {
	//const eventTracker = UseAnalyticsEvent()
	//const notify = useNotify();
	const classes = useStyles();
	const [data, setData] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [parkingToCopy, setParkingToCopy] = React.useState("");
	const [filterParking, setFilterParking] = React.useState("");
	//const [jsonFieldsVisible, setJsonFieldsVisible] = React.useState(false);
	const [copiedData, setCopiedDate] = React.useState({})
	const [copyOnly, setCopyOnly] = React.useState("Everything")
	const [checked, setChecked] = React.useState(false);
	const fetchParkingTimeout = useRef(null);
	const redirect = useRedirect();

	const [selectedParkingSettings, setSelectedParkingSettings] = useState(null);

	const onSuccess = () => {
		notify("Element Updated", "success")
		redirect(props.basePath)
	}
	const onFailure = (error) => {
		notify(error.message, "warning")
	}

	const handleChange = (event) => {
		setChecked(!checked);
	};

	const fetchParkings = () => {
		setLoading(true);
		var params = {
			user_id: sessionStorage.getItem("user_id"),
			filter: JSON.stringify({ zones: true, name: filterParking }),
		}
		fetch(`${config.HOST_NAME}/crm/v3/parkings?${stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
		}).then(response => {
			saveTokens(response)
			return response.json();
		}).then((responseJson) => {
			if (responseJson.success) {
				setData(responseJson.data);
				setLoading(false);
			} else {
				notify(responseJson.message, 'warning');
			}
		})
			.catch((e) => {
				notify('Error fetching Parkings', 'warning')
			});
	}

	const handleParkingChange = (event, value) => {
		setParkingToCopy(value);
	}

	const handleParkingFilterChange = (event, value) => {
		setFilterParking(value);
	}

	const selectParkingSettingsHandler = (event) => {
        const file = event.target.files[0];
		if(!file) return
        if(file.type !== "application/json") return notify("Invalid File", "warning")
        setSelectedParkingSettings(file);

		//Upload Parking Settings
		const formData = new FormData();
        formData.append('file', file);
        formData.append('access_key_id', props.id);

        fetch(`${config.HOST_NAME}/crm/v3/uploadParkingSettings`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            },
            body: formData
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify(json.message, "success");
					const parkingFeatures = json.data
					setCopiedDate(parkingFeatures)
					setSelectedParkingSettings(null)
                } else {
                    notify(json.message, "info");
                }
            })
            .catch(e => {
                notify("Check your internet connection", "warning");
            });
    }

	const copyParking = () => {
		var params = { access_key_id: parkingToCopy.id };
		fetch(`${config.HOST_NAME}/crm/v3/duplicateParking?${stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
		}).then(response => {
			saveTokens(response)
			return response.json();
		}).then((responseJson) => {
			if (responseJson.success) {
				const parking = responseJson.data;
				setCopiedDate(parking.features)
			} else {
				notify(responseJson.message, 'warning');
			}
		})
			.catch((e) => {
				notify('Error fetching Parkings', 'warning')
			});
	}

	const download = (url) => {
        const tempLinkElement = document.createElement('a');
        tempLinkElement.target = "_blank";
        tempLinkElement.href = `${url}?time=${Date.now()}`;
        let filename;
        if (typeof url === "string") {
            const urlKeys = url.split("/");
            filename = urlKeys[urlKeys.length - 1];
        } else {
            filename = "Download";
        }
        tempLinkElement.setAttribute('download', filename);
        tempLinkElement.click();
    };

React.useEffect(() => {
        if (fetchParkingTimeout.current)
            clearTimeout(fetchParkingTimeout.current);
        fetchParkingTimeout.current = setTimeout(fetchParkings, 500);
    }, [filterParking, notify]);  // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Paper className={classes.inlineForm}>
				<Autocomplete
					blurOnSelect
					disableClearable
					noOptionsText="No Parkings Found"
					loading={loading}
					onChange={handleParkingChange}
					onInputChange={handleParkingFilterChange}
					options={data}
					getOptionLabel={p => p.name}
					value={parkingToCopy}
					renderInput={params => <MuiTextField {...params} label="Select a parking" variant="outlined" />}
					required
				/>
				<MuiTextField
					label="Copy Only"
					style={{ marginLeft: "30px" }}
					select
					value={copyOnly}
					onChange={(e) => setCopyOnly(e.target.value)}
					variant='outlined'
				>
					<MenuItem value="Everything">Everything</MenuItem>
					<MenuItem value="parking_cost">Pricing Only</MenuItem>
					<MenuItem value="header">Receipt Header Only</MenuItem>
					<MenuItem value="footer">Receipt Footer Only</MenuItem>
					<MenuItem value="parking_manager">Parking Manager Only</MenuItem>
				</MuiTextField>
				<Button
					variant="contained"
					color="primary"
					style={{ width: "8%", minWidth: 80, margin: "6px 0 6px 30px" }}
					onClick={copyParking}
				>
					Copy
				</Button>

			</Paper>

			<Edit title="Edit Parking Settings" undoable={false} {...props} actions={null} onFailure={onFailure} onSuccess={onSuccess}>
				<SimpleForm redirect="list" initialValues={{ copy_to: [] }} style={{ position: "relative" }} toolbar={<CustomToolbar />}>
					<div style={{ display: "flex", width:"100%", justifyContent: "flex-start", alignItems: "center", gap: "20px", marginTop: 20, marginBottom: 20, flexWrap: "nowrap" }}>
						<Button className='customCreateBtnStyle' startIcon={<AddIcon />}>
							{selectedParkingSettings && selectedParkingSettings.name ? selectedParkingSettings.name : "Upload Settings.json"}
							<input type="file" accept=".json" onChange={selectParkingSettingsHandler} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "inherit" }} />
						</Button>
						<FunctionField render={record => record && record.access_key &&
							<Button className='customCreateBtnStyle' startIcon={<DownloadIcon />} onClick={() => download(`https://files.parksmart.in/main/Operator/${record.access_key}/features.json`)}>Download Settings.json</Button>
						} />
					</div>
					<TextField source="access_key" />
					<TextInput variant='outlined' source="name" />
					<RaAutocompleteInput source="client_id" resourceParam="owner_name" resourcePath="clientsInfo" label="Client Name" getOptionValue={option => option["id"]} getOptionLabel={option => `${option["owner_name"]}`} useAccessKeyId={false} style={{ maxWidth: 340, position: "relative", margin: "7px 0 25px" }} />
					<TextInput variant='outlined' source="sub_type" />
					<TextInput variant='outlined' source="city" />
					<TextInput variant='outlined' source="device_limit" disabled={sessionStorage.getItem("edit_device_limit") === "0"} />
					{/* <EsperGroupSelector source="esper_group_id" /> */}
					{/* <ParkingZonesSelector source="zone_id" resourceParam="name" resourcePath="parkingzones" label="Select Parking Group" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} style={{ marginTop: 15, marginBottom: 25 }} /> */}
					{/* {noZone && <CreateParkingZoneDialog setNoZone={setNoZone} zoneNameSearched={zoneNameSearched} />} */}

					<ParkingInfoSelector source="parking_info_id" resourceParam="parking_name" resourcePath="parkingInfo" label="Select Parking Group" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} style={{ marginTop: 15, marginBottom: 25 }} />
					<BooleanInput label="Copy to Whole Group" source="is_whole_group" defaultValue={false} checked={checked}
						onChange={handleChange} />
					{checked && <CopyToWholeGroupSelector source="copy_to" choices={copyToTypes} />}
					<FeaturesFormField copiedData={copiedData} copyOnly={copyOnly} source="features" edit={true} />
				</SimpleForm>
			</Edit>
		</>
	)
};

const CopyToWholeGroupSelector = ({ choices, source }) => {
	const everythingKey = "Everything"
	const classes = useStyles();
    const {input: { value, onChange }, meta: { touched, error }} = useInput({ source });

    const [selectedValues, setSelectedValues] = useState(value || []);
    const isEverythingOptionSelected = selectedValues.includes(everythingKey);

    const handleChange = (event, newValue) => {
        if (newValue.some(option => option.id === everythingKey)) {
            setSelectedValues([everythingKey]);
            onChange([everythingKey]);
        } else {
            setSelectedValues(newValue.map(option => option.id));
            onChange(newValue.map(option => option.id));
        }
    };

	React.useEffect(() => {
        if (isEverythingOptionSelected && selectedValues.length > 1) {
            setSelectedValues([everythingKey ]);
        }
    }, [isEverythingOptionSelected, selectedValues]);

    return (
        <Autocomplete
			className={classes.autocomplete}
            multiple
            options={choices}
            value={choices.filter(option => value.includes(option.id))}
            onChange={handleChange}
            disableCloseOnSelect
            getOptionLabel={option => option.name}
            renderOption={(option, { selected }) => (
                <>
                    <Checkbox style={{ marginRight: 8 }} checked={selected}disabled={isEverythingOptionSelected && option.id !== everythingKey }/>
                    {option.name}
                </>
            )}
            renderInput={params => (<MuiTextField {...params} variant="outlined" label="Please choose the desired options" error={touched && !!error} helperText={touched && error}/>)}
            renderTags={(selected, getTagProps) =>
                selected.map((option, index) => (<Chip label={option.name}{...getTagProps({ index })}/>))
            }
        />
    );
};

// const ParkingFilter = (props) => {

// 	return (
// 		<Filter {...props}>
// 			{props.showFilter && <CustomSearch search={search} setSearch={setSearch} />}
// 		</Filter>
// 	)
// };




const VehicleEdit = ({ fetchSummary, licenseNumber, vehicleEntryTime, vehicleExitTime, vehicleId, accessKeyName, oldValues }) => {
	const classes = useStyles();
	//const notify = useNotify()
	const [vehicleDialogVisible, setVehicleDialogVisible] = React.useState(false);
	const [loading, setLoading] = useState(false)
	const [vehicleNumber, setVehicleNumber] = useState(licenseNumber)
	const [entryTime, setEntryTime] = useState(vehicleEntryTime)
	const [exitTime, setExitTime] = useState(vehicleExitTime)

	let newData = {
		vehicle_number: vehicleNumber,
		entry_time: moment(entryTime).utcOffset('+05:30').format("YYYY-MM-DD HH:mm:ss"),
		exit_time: moment(exitTime).utcOffset('+05:30').format("YYYY-MM-DD HH:mm:ss")
	}
	let oldData = {
		...oldValues
	}

	const handleClose = () => setVehicleDialogVisible(false)
	const handleOpen = () => setVehicleDialogVisible(true)

	const onSubmitHandler = () => {
		const requestBody = {
			method: 'POST',
			headers: {
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ newData, oldData, access_key: accessKeyName })
		};
		fetch(`${config.HOST_NAME}/crm/v3/vehicleSummary/updateVehicle/${vehicleId}`, requestBody)
			.then((res) => {
				saveTokens(res)
				return res.json()
			})
			.then((response) => {
				if (response.success) {
					setLoading(false)
					notify("Vehicle Updated Successfully", 'success')
					handleClose()
					fetchSummary()
				} else {
					setLoading(false)
					notify(response.message, 'warning')
				}
			})
			.catch((error) => {
				console.log(error)
				notify("Something went wrong", 'warning')
			})
	}

	return (
		<>
			<Button style={{ color: "#18cc69" }} onClick={handleOpen}><EditIcon /></Button>

			<Dialog
				open={vehicleDialogVisible}
				onClose={handleClose}
				fullWidth
				classes={{ paper: classes.dialogPaper }}
				BackdropProps={{
					classes: {
						root: classes.backDrop
					}
				}}
			>
				<DialogContent>

					<MuiTextField label="Vehicle Number" variant='outlined' value={vehicleNumber} onChange={(e) => setVehicleNumber(e.target.value)} size="small" style={{ display: "block" }} />

					<MuiPickersUtilsProvider utils={DateFnsUtils}>

						<DateTimePicker
							disableFuture
							ampm
							value={entryTime}
							onChange={datetime => setEntryTime(datetime)}
							label="Entry Time"
							inputVariant="outlined"
							TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
							ToolbarComponent={DateTimePickerToolbar}
							format="dd/MM/yyyy hh:mm a"
							style={{ display: "block", marginTop: "20px" }}
						/>
						<DateTimePicker
							disableFuture
							ampm
							value={exitTime}
							onChange={datetime => setExitTime(datetime)}
							label="Exit Time"
							inputVariant="outlined"
							TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
							ToolbarComponent={DateTimePickerToolbar}
							format="dd/MM/yyyy hh:mm a"
							style={{ marginTop: "20px" }}
						/>

					</MuiPickersUtilsProvider>

				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
						Close
					</Button>
					<Button onClick={onSubmitHandler} color="primary" variant='contained' style={{ backgroundColor: '#18cc69', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
						Save {loading && <CircularProgress size={25} style={{ marginLeft: "10px", color: "#FFF" }} />}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}


const VehicleDelete = ({ fetchSummary, licenseNumber, vehicleId, accessKeyName, oldValues }) => {
	const classes = useStyles();
	//const notify = useNotify();
	const [vehicleDeleteDialogVisible, setVehicleDeleteDialogVisible] = React.useState(false);
	const [loading, setLoading] = useState(false)

	let oldData = {
		...oldValues
	}

	const handleCloseDelete = () => setVehicleDeleteDialogVisible(false)
	const handleOpenDelete = () => setVehicleDeleteDialogVisible(true)
	const onSubmitHandler = () => {
		const requestBody = {
			method: 'DELETE',
			headers: {
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ vehicle_number: licenseNumber, access_key: accessKeyName, oldData })
		};
		fetch(`${config.HOST_NAME}/crm/v3/vehicleSummary/deleteVehicle/${vehicleId}`, requestBody)
			.then((res) => {
				saveTokens(res)
				return res.json()
			})
			.then((response) => {
				if (response.success) {
					setLoading(false)
					notify("Vehicle Deleted Successfully", 'success')
					handleCloseDelete()
					fetchSummary()
				} else {
					setLoading(false)
					notify(response.message, 'warning')
				}
			})
			.catch((error) => {
				console.log(error)
				notify("Something went wrong", 'warning')
			})
	}

	return (
		<>
			<Button style={{ color: '#de575e' }} onClick={handleOpenDelete}><DeleteIcon /></Button>

			<Dialog
				open={vehicleDeleteDialogVisible}
				onClose={handleCloseDelete}
				fullWidth
				classes={{ paper: classes.dialogPaper }}
				BackdropProps={{
					classes: {
						root: classes.backDrop
					}
				}}
			>
				<DialogContent>

					<DialogContentText id="alert-dialog-description">
						Are you sure you want to <strong>Delete</strong> this vehicle.
					</DialogContentText>

				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseDelete} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
						Close
					</Button>
					<Button onClick={onSubmitHandler} color="primary" variant='contained' style={{ backgroundColor: '#de575e', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
						Delete {loading && <CircularProgress size={25} style={{ marginLeft: "10px", color: "#FFF" }} />}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

function CheckVehicleExited({ row, isSurveillanceExit }) {
	const classes = useStyles();
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
	const [dialogVisible, setDialogVisible] = useState(false);
	const [exitedVehDetails, setExitedVehDetails] = useState(null);
	const [loading , setLoading] = useState(false)
	const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
		return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY ${use24HourFormat ? `HH:mm${secondsFormat}` : `hh:mm${secondsFormat} a`}`);
	};

	const handleClose = () => setDialogVisible(false)
	const handleOpen = () => setDialogVisible(true)

	const checkVehicleExited = (vehicle_number, entry_time) => {
		if (!vehicle_number) return notify("Required Vehicle Number", "warning")
		if (!entry_time) return notify("Required Entry Time", "warning")

		setLoading(true);
		fetch(`${config.HOST_NAME}/crm/v3/checkVehicleExited?vehicle_number=${vehicle_number}&entry_time=${entry_time}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
			}
		})
			.then(response => response.json())
			.then((json) => {
				if (json.success) setExitedVehDetails(json.data)
			})
			.catch((e) => notify('Something went wrong', 'warning'))
			.finally(() => setLoading(false))
	}

	React.useEffect(() => {
		if (isSurveillanceExit && !exitedVehDetails) checkVehicleExited(row.license_number, row.entry_time)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSurveillanceExit]) 
	return (
		<>
			{exitedVehDetails ?
				<div title="Check Vehicle Exit" style={{ color: customTheme.palette.error.main, cursor: 'pointer', fontSize: 14 }} onClick={handleOpen}>
					{loading ?
						<CircularProgress size={20} style={{ color: "#18CC69" }} />
						:
						!isSmallDevice ? 
						<div style={{display: 'flex', justifyContent:'space-around', alignItems:'center'}}>
							<img width={15} height={15} src={CctvImage} alt="cctvImage" />
							<p>Exited</p>
						</div>
						: <span>Exited</span>
					}
				</div>
				: '-'
			}
			<Dialog
				open={dialogVisible}
				onClose={handleClose}
				classes={{ paper: classes.dialogPaper }}
				BackdropProps={{
					classes: {
						root: classes.backDrop
					}
				}}
			>
				{exitedVehDetails ?
					<DialogContent>
						<p style={{ fontWeight: 'bold', fontSize: 14, lineHeight: '1px' }}>Surveillance Details</p>

						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'stretch', columnGap: 10, flexWrap: 'wrap', borderRadius: 10 }}>
                                <div>
                                    <div style={{marginBottom: 20}}>
                                        <p style={{ fontSize: 12, lineHeight: "3px", color: '#9899A1' }}>VEHICLE NUMBER</p>
                                        <p style={{ fontSize: 14, color: '#272727', lineHeight: "3px", fontWeight: '600' }}>{row.license_number}</p>
                                    </div>
                                    <div style={{marginBottom: 20}}>
                                        <p style={{ fontSize: 12, lineHeight: "3px", color: '#9899A1' }}>Exit Time</p>
                                        <p style={{ fontSize: 14, color: '#272727', lineHeight: "3px", fontWeight: '600' }}>{renderTime(exitedVehDetails.exit_time)}</p>
                                    </div>
                                </div>

                                <div>
                                    {exitedVehDetails.image_url ?
                                        <ImageGalleryDialog
                                            thumbnail={true}
                                            record={exitedVehDetails}
                                            style={{ textAlign: isSmallDevice ? 'left' : 'right'  }}
                                            getImages={(record) => [record.image_url]}
                                        />
                                        :
                                        <div style={{ display: isSmallDevice ? 'block' : "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #BDBDBD", minWidth: "50px", width: "60px", borderRadius: 5, height: "40px" }}>
                                                <BrokenImageOutlinedIcon />
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
					</DialogContent>
					:
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
						Vehicle has <strong>Not Exited</strong> from Surveillance.
						</DialogContentText>
					</DialogContent>
				}
				<DialogActions>
					<Button onClick={handleClose} variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "35px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E", marginRight: 10 }} disableElevation>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

function ParkingLicenseDialog(props) {
	const { expiryTime, id } = props;
	const refresh = useRefresh();

	const [dialogVisible, setDialogVisible] = React.useState(false);
	const [unlimited, setUnlimited] = React.useState(false);
	const [extendLicense, setExtendLicense] = React.useState(false);
	const [expireLicense, setExpireLicense] = React.useState(true);
	const [selectedDate, setSelectedDate] = React.useState(new Date());
	const [days, setDays] = React.useState(30)
	const [loading, setLoading] = React.useState(false)


	let currentTime = moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss");
	const openDialog = () => {
		setDialogVisible(true);
		setExpireLicense(true)
	};

	const closeDialog = () => {
		setDialogVisible(false);
		setExpireLicense(false)
		setUnlimited(false)
		setExtendLicense(false)
	};

	const handleDateChange = (date) => {
		setSelectedDate(date);
	};

	const updateLicenseHandler = (event) => {

		if (!unlimited && !extendLicense && !expireLicense) return notify("Please select atleast one (*) option.", "warning")

		event.preventDefault();
		setLoading(true);
		const params = {
			user_id: sessionStorage.getItem("user_id"),
			expiry_time: (expireLicense ? moment().add(days, "day").utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss") : (extendLicense ? moment(selectedDate).utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss") : undefined))
		};
		fetch(`${config.HOST_NAME}/crm/parkings/${id}/updateLicense`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${sessionStorage.getItem('token')}`,
			},
			body: JSON.stringify(params),
		})
			.then(response => response.json())
			.then((responseJson) => {
				setLoading(false);
				if (responseJson.errorCode === 0) {
					refresh();
					notify(responseJson.message, "success");
					closeDialog()
				}
				else {
					notify(responseJson.message, 'warning');
				}
			})
			.catch((e) => {
				setLoading(false);
				notify('Error Deleting Operator Device', 'warning')
			});
	};

	return (
		<>
			{expiryTime < currentTime ? <IconButton title='Device License' style={{ color: customTheme.palette.primary.main }} onClick={openDialog} label={false}> <PhonelinkEraseIcon style={{ color: "#de575e" }} /></IconButton> :
				<IconButton title='Device License' style={{ color: customTheme.palette.primary.main }} onClick={openDialog} label={false}> <MobileFriendlyIcon /></IconButton>}
			<Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
				<DialogContent style={{ paddingBottom: 20 }}>
					<div style={{marginTop: 10, marginBottom: 10}}>
						<div style={{ fontWeight: 'bold', fontSize: 17 }}>License Status: <span style={{ color: !expiryTime ? customTheme.palette.secondary.main : expiryTime < currentTime ? customTheme.palette.error.main : expiryTime > currentTime ? customTheme.palette.primary.main : '#fff' }}>{!expiryTime ? 'Unlimited' : expiryTime < currentTime ? 'Expired' : expiryTime > currentTime ? 'On Going' : ''} </span></div>
						<div>{!expiryTime ? "This device license holds unlimited validity for now." : expiryTime < currentTime ? `This device license has been expired on ${moment(expiryTime).format('MMMM Do YYYY, h:mm:ss a')}` : expiryTime > currentTime ? `This device license will be expired on ${moment(expiryTime).format('MMMM Do YYYY, h:mm:ss a')}` : ""} </div>
					</div>

					<div>Select one of the following options to update license:</div>

					<div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', columnGap: 10 }}>
						<FormControlLabel value="end" control={<Radio
							checked={expireLicense}
							onChange={(event) => {
								setExpireLicense(event.target.checked)
								setExtendLicense(false)
								setUnlimited(false)
							}}
							value={expireLicense}
						/>} label="Set Days" />

						<FormControlLabel value="end" control={<Radio
							checked={extendLicense}
							onChange={(event) => {
								setExtendLicense(event.target.checked)
								setExpireLicense(false)
								setUnlimited(false)
							}}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Set Date" />

						<FormControlLabel value='end' control={<Radio
							checked={unlimited}
							onChange={(event) => {
								setUnlimited(event.target.checked)
								setExtendLicense(false)
								setExpireLicense(false)
							}}
							inputProps={{ 'aria-label': 'controlled' }}
						/>}
							label="Unlimited" />
					</div>

					{extendLicense && <MuiPickersUtilsProvider utils={DateFnsUtils}>

						<div id='expiryOperatorDateTimePicker' style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", columnGap: 20, rowGap: 20, width: 400 }}>
							<KeyboardDatePicker
								margin="normal"
								id="date-picker-dialog"
								label="Select Date"
								format="MM/dd/yyyy"
								inputVariant='outlined'
								value={selectedDate}
								onChange={handleDateChange}
								KeyboardButtonProps={{
									'aria-label': 'change date'
								}}
								InputProps={{
									disableUnderline: true,
								}}
								InputAdornmentProps={{ marginBottom: -20 }}
							/>
							<KeyboardTimePicker
								margin="normal"
								id="time-picker"
								label="Selecte Time"
								inputVariant='outlined'
								value={selectedDate}
								onChange={handleDateChange}
								KeyboardButtonProps={{
									'aria-label': 'change time'

								}}
							/>
						</div>

					</MuiPickersUtilsProvider>}

					{expireLicense && <MuiTextField label="" variant='outlined' type='number' value={days} onChange={(e) => setDays(e.target.value)} size="small" style={{ display: "block", marginTop: 20 }} />}

				</DialogContent>


				<DialogActions style={{ paddingBottom: 20, paddingRight: 20 }}>
					<Button onClick={closeDialog} style={{ backgroundColor: customTheme.palette.neutral.main, color: customTheme.palette.secondary.main, textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px" }}>Cancel</Button>
					<Button onClick={updateLicenseHandler} style={{ backgroundColor: customTheme.palette.secondary.main, color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }}>Apply {loading && <CircularProgress size={20} />}</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

const AntSwitch = withStyles((theme) => ({
	root: {
		width: 28,
		height: 15,
		padding: 0,
		display: 'flex',
	},
	switchBase: {
		padding: 2,
		color: theme.palette.grey[500],
		'&$checked': {
			transform: 'translateX(12px)',
			color: theme.palette.common.white,
			'& + $track': {
				opacity: 1,
				backgroundColor: theme.palette.primary.main,
				borderColor: theme.palette.primary.main,
			},
		},
	},
	thumb: {
		width: 11,
		height: 11,
		boxShadow: 'none',
	},
	track: {
		border: `1px solid ${theme.palette.grey[500]}`,
		borderRadius: 16 / 2,
		opacity: 1,
		backgroundColor: theme.palette.common.white,
		height: "auto",
		paddingTop: 2,
		paddingBottom: 2
	},
	checked: {},
}))(Switch);

const ValetKeys = () => {
	const { id } = useParams();
	const [keys, setKeys] = useState([]);
	const [editTimeouts, setEditTimeouts] = useState({});
	const accessKeyId = id
	const [loading, setLoading] = useState(false)

	const fetchValetKeys = async () => {
		try {
			setLoading(true)
			const res = await fetch(`${config.HOST_NAME}/dashboard/v1/valet/slot-keys/${accessKeyId}`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${sessionStorage.getItem("token")}`,
					RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
				},
			})
			const response = await res.json()
			if (response.success) {
				setKeys(response.data)
			}
		} catch (error) {
			console.log(error)
			notify('Something went wrong', 'warning');
		} finally {
			setLoading(false)
		}
	}

	React.useEffect(() => {
		fetchValetKeys()
	}, []); // eslint-disable-line react-hooks/exhaustive-deps


	const handleAdd = async () => {
		try {
			setLoading(true)
			const res = await fetch(`${config.HOST_NAME}/dashboard/v1/valet/slot-keys`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${sessionStorage.getItem("token")}`,
					RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
				},
				body: JSON.stringify({ access_key_id: accessKeyId, name: "Default Key" }),
			});
			const response = await res.json()
			if (response.success) {
				setKeys(prev => [...prev, response.data]);
			} else {
				notify('Unable to Add Valet Key', 'warning');
			}
		} catch (error) {
			console.error(error);
			notify('Something went wrong', 'warning');
		} finally {
			setLoading(false)
		}
	};

	const handleEdit = (index, id, value) => {
		setKeys((prev) => {
			const copy = [...prev]
			copy[index] = {...copy[index], name: value}
			return copy
		})
		if (editTimeouts[id]) {
			clearTimeout(editTimeouts[id]);
		}

		const newTimeout = setTimeout(async () => {
			if(value !== ""){
				try {
				setLoading(true)
				const res = await fetch(`${config.HOST_NAME}/dashboard/v1/valet/slot-keys/${id}`, {
					method: "PUT",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${sessionStorage.getItem("token")}`,
						RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
					},
					body: JSON.stringify({ name: value }),
				});

				const response = await res.json()
				if (!response.success) notify('Unable to Update Valet Key', 'warning');

			} catch (error) {
				console.error(error);
				notify('Something went wrong', 'warning');
			} finally {
				setLoading(false)
			}
		}
		}, 500);

		setEditTimeouts(prev => ({ ...prev, [id]: newTimeout }));
	};


	const handleRemove = async (id) => {
		try {
			setLoading(true)
			const res = await fetch(`${config.HOST_NAME}/dashboard/v1/valet/slot-keys/${id}`, {
				method: "DELETE",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${sessionStorage.getItem("token")}`,
					RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
				},
			});

			const response = await res.json()
			if (response.success) setKeys(prev => prev.filter(key => key.id !== id));
			else {
				notify('Unable to Remove Valet Key', 'warning');
			}

			if (editTimeouts[id]) {
				clearTimeout(editTimeouts[id]);
			}
		} catch (error) {
			console.error(error);
			notify('Something went wrong', 'warning');
		} finally {
			setLoading(false)
		}
	};

	return (
		<div style={{ border: "1px solid rgb(204, 204, 204)", padding: "10px",minWidth:300, maxHeight: 300, overflowX: "hidden", overflowY: "auto", borderRadius: "10px" }}>
			<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<div style={{display:"flex", alignItems:"center", gap: 5}}>
					<Typography>Keys</Typography>
					{loading && <CircularProgress size={12} style={{color:"#18CC69"}} />}
				</div>
				<div style={{display:"flex", alignItems:"center", gap: 5}}>
					<IconButton size='small' onClick={fetchValetKeys} color="primary" disabled={loading}>
						<RefreshIcon style={{ color: "#18CC69" }} />
					</IconButton>

					<IconButton size='small' onClick={handleAdd} color="primary">
						<AddIcon />
					</IconButton>
				</div>
			</div>
			{!keys || keys.length === 0 ? <p style={{fontSize:"13px", color:"#BDBDBD"}}>Please add keys</p> :

				keys.map((key, index) => (
					<div key={key.id} style={{display:"flex", justifyContent:"flex-start", alignItems:"center", margin: "10px 0px", gap:"10px"}}>
						<MuiTextField
							value={key.name}
							onChange={(e) => handleEdit(index, key.id, e.target.value)}
							variant="outlined"
							size="small"
							label="Name"
						/>
						<IconButton size='small' onClick={() => handleRemove(key.id)} color="error">
							<CloseIcon />
						</IconButton>
					</div>
				))}
		</div>
	);
};

const ValetDrivers = () => {
	const { id } = useParams();
	const [keys, setKeys] = useState([]);
	const [editTimeouts, setEditTimeouts] = useState({});
	const accessKeyId = id
	const [loading, setLoading] = useState(false)

	const fetchValetDrivers = async () => {
		try {
			setLoading(true)
			const res = await fetch(`${config.HOST_NAME}/dashboard/v1/valet/drivers/${accessKeyId}`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${sessionStorage.getItem("token")}`,
					RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
				},
			})
			const response = await res.json()
			if (response.success) {
				setKeys(response.data)
			}
		} catch (error) {
			console.log(error)
			notify('Something went wrong', 'warning');
		} finally {
			setLoading(false)
		}
	}

	React.useEffect(() => {
		fetchValetDrivers()
	}, []); // eslint-disable-line react-hooks/exhaustive-deps


	const handleAdd = async () => {
		try {
			setLoading(true)
			const res = await fetch(`${config.HOST_NAME}/dashboard/v1/valet/drivers`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${sessionStorage.getItem("token")}`,
					RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
				},
				body: JSON.stringify({ access_key_id: accessKeyId, name: "Default Driver" }),
			});
			const response = await res.json()
			if (response.success) {
				setKeys(prev => [...prev, response.data]);
			} else {
				notify('Unable to Add Valet Key', 'warning');
			}
		} catch (error) {
			console.error(error);
			notify('Something went wrong', 'warning');
		} finally {
			setLoading(false)
		}
	};

	const handleEdit = (index, id, value) => {
		setKeys((prev) => {
			const copy = [...prev]
			copy[index] = {...copy[index], name: value}
			return copy
		})
		if (editTimeouts[id]) {
			clearTimeout(editTimeouts[id]);
		}

		const newTimeout = setTimeout(async () => {
			if(value !== ""){
				try {
					setLoading(true)
					const res = await fetch(`${config.HOST_NAME}/dashboard/v1/valet/drivers/${id}`, {
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							Authorization: `Bearer ${sessionStorage.getItem("token")}`,
							RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
						},
						body: JSON.stringify({ name: value }),
					});
	
					const response = await res.json()
					if (!response.success) notify('Unable to Update Valet Key', 'warning');
	
				} catch (error) {
					console.error(error);
					notify('Something went wrong', 'warning');
				} finally {
					setLoading(false)
				}
			}
		}, 500);

		 setEditTimeouts(prev => ({ ...prev, [id]: newTimeout }));
	};


	const handleRemove = async (id) => {
		try {
			setLoading(true)
			const res = await fetch(`${config.HOST_NAME}/dashboard/v1/valet/drivers/${id}`, {
				method: "DELETE",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${sessionStorage.getItem("token")}`,
					RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
				},
			});

			const response = await res.json()
			if (response.success) setKeys(prev => prev.filter(key => key.id !== id));
			else {
				notify('Unable to Remove Valet Key', 'warning');
			}

			if (editTimeouts[id]) {
				clearTimeout(editTimeouts[id]);
			}
		} catch (error) {
			console.error(error);
			notify('Something went wrong', 'warning');
		} finally {
			setLoading(false)
		}
	};

	return (
		<div style={{ border: "1px solid rgb(204, 204, 204)", padding: "10px",minWidth:300, maxHeight: 300, overflowX: "hidden", overflowY: "auto", borderRadius: "10px" }}>
			<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<div style={{display:"flex", alignItems:"center", gap: 5}}>
					<Typography>Drivers</Typography>
					{loading && <CircularProgress size={12} style={{color:"#18CC69"}} />}
				</div>
				<div style={{display:"flex", alignItems:"center", gap: 5}}>
					<IconButton size='small' onClick={fetchValetDrivers} color="primary" disabled={loading}>
						<RefreshIcon style={{ color: "#18CC69" }} />
					</IconButton>

					<IconButton size='small' onClick={handleAdd} color="primary">
						<AddIcon />
					</IconButton>
				</div>
			</div>
			{!keys || keys.length === 0 ? <p style={{fontSize:"13px", color:"#BDBDBD"}}>Please add drivers</p> :

				keys.map((key, index) => (
					<div key={key.id} style={{display:"flex", justifyContent:"flex-start", alignItems:"center", margin: "10px 0px", gap:"10px"}}>
						<MuiTextField
							value={key.name}
							onChange={(e) => handleEdit(index, key.id, e.target.value)}
							variant="outlined"
							size="small"
							label="Name"
						/>
						<IconButton size='small' onClick={() => handleRemove(key.id)} color="error">
							<CloseIcon />
						</IconButton>
					</div>
				))}
		</div>
	);
};

const ValetParkingArea = () => {
	const { id } = useParams();
	const [parkingArea, setParkingArea] = useState([]);
	const [editTimeouts, setEditTimeouts] = useState({});
	const accessKeyId = id
	const [loading, setLoading] = useState(false)

	const fetchParkingArea = async () => {
		try {
			setLoading(true)
			const res = await fetch(`${config.HOST_NAME}/dashboard/v1/parking-slots-area/${accessKeyId}`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${sessionStorage.getItem("token")}`,
					RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
				},
			})
			const response = await res.json()
			if (response.success) {
				setParkingArea(response.data)
			}
		} catch (error) {
			console.log(error)
			notify('Something went wrong', 'warning');
		} finally {
			setLoading(false)
		}
	}

	React.useEffect(() => {
		fetchParkingArea()
	}, []); // eslint-disable-line react-hooks/exhaustive-deps


	const handleAdd = async () => {
		try {
			setLoading(true)
			const res = await fetch(`${config.HOST_NAME}/dashboard/v1/parking-slots-area`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${sessionStorage.getItem("token")}`,
					RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
				},
				body: JSON.stringify({ access_key_id: accessKeyId, name: "Default Area", recall_time: 10 }),
			});
			const response = await res.json()
			if (response.success) {
				setParkingArea(prev => [...prev, response.data]);
			} else {
				notify('Unable to Add Valet Parking Area', 'warning');
			}
		} catch (error) {
			console.error(error);
			notify('Something went wrong', 'warning');
		} finally {
			setLoading(false)
		}
	};

	const handleEdit = (index, id, value, key) => {
		let areaDetails = {}
		setParkingArea((prev) => {
			const copy = [...prev]
			copy[index] = {...copy[index], [key]: value}
			areaDetails = {...copy[index]}
			return copy
		})
		if (editTimeouts[id]) {
			clearTimeout(editTimeouts[id]);
		}

		const newTimeout = setTimeout(async () => {
				try {
					delete areaDetails.id
				setLoading(true)
				const res = await fetch(`${config.HOST_NAME}/dashboard/v1/parking-slots-area/${id}`, {
					method: "PUT",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${sessionStorage.getItem("token")}`,
						RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
					},
					body: JSON.stringify({ ...areaDetails }),
				});

				const response = await res.json()
				if (!response.success) notify(response.message, 'warning');

			} catch (error) {
				console.error(error);
				notify('Something went wrong', 'warning');
			} finally {
				setLoading(false)
			}
		}, 500);

		setEditTimeouts(prev => ({ ...prev, [id]: newTimeout }));
	};


	const handleRemove = async (id) => {
		try {
			setLoading(true)
			const res = await fetch(`${config.HOST_NAME}/dashboard/v1/parking-slots-area/${id}`, {
				method: "DELETE",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${sessionStorage.getItem("token")}`,
					RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
				},
			});

			const response = await res.json()
			if (response.success) setParkingArea(prev => prev.filter(key => key.id !== id));
			else {
				notify('Unable to Remove Valet Parking Area', 'warning');
			}

			if (editTimeouts[id]) {
				clearTimeout(editTimeouts[id]);
			}
		} catch (error) {
			console.error(error);
			notify('Something went wrong', 'warning');
		} finally {
			setLoading(false)
		}
	};

	return (
		<div style={{ border: "1px solid rgb(204, 204, 204)", padding: "10px",minWidth:300, maxHeight: 300, overflowX: "hidden", overflowY: "auto", borderRadius: "10px" }}>
			<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<div style={{display:"flex", alignItems:"center", gap: 5}}>
					<Typography>Parking Areas</Typography>
					{loading && <CircularProgress size={12} style={{color:"#18CC69"}} />}
				</div>
				<div style={{display:"flex", alignItems:"center", gap: 5}}>
					<IconButton size='small' onClick={fetchParkingArea} color="primary" disabled={loading}>
						<RefreshIcon style={{ color: "#18CC69" }} />
					</IconButton>

					<IconButton size='small' onClick={handleAdd} color="primary">
						<AddIcon />
					</IconButton>
				</div>
			</div>
			{!parkingArea || parkingArea.length === 0 ? <p style={{fontSize:"13px", color:"#BDBDBD"}}>Please add parkingArea</p> :

				parkingArea.map((key, index) => (
					<div key={key.id} style={{display:"flex", justifyContent:"space-between", alignItems:"center", gap:"10px", margin: "10px 0px"}}>
						<MuiTextField
							value={key.name}
							onChange={(e) => handleEdit(index, key.id, e.target.value, "name")}
							variant="outlined"
							size="small"
							label="Name"
						/>
						<MuiTextField
							type='number'
							value={key.recall_time}
							onChange={(e) => handleEdit(index, key.id, e.target.value, "recall_time")}
							variant="outlined"
							size="small"
							label="Recall Time (In Mins)"
						/>
						<IconButton size='small' onClick={() => handleRemove(key.id)} color="error">
							<CloseIcon />
						</IconButton>
					</div>
				))}
		</div>
	);
};
